// Generated by scripts/extract-squarespace.mjs. Do not edit by hand.

export const extractedSite = {
  "site": {
    "title": "Doctora Masa",
    "tagline": "Cirugía Plástica, Reparadora y Estética",
    "description": "La doctora Inmaculada Masa Jurado es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid, y Miembro Numerario de la Sociedad Española de Cirugía Plástica, Reparadora y Estética (SECPRE). Su principal ámbito de acción es la cirugía mamaria (aumento de pecho, elevación de mama, reducción mamaria) y la cirugía del contorno corporal (abdominoplastia, liposucción).",
    "language": "es-ES",
    "instagram": "https://www.instagram.com/doctoramasa/",
    "email": "consulta@doctoramasa.com",
    "phone": "+34 618 13 34 35"
  },
  "pages": [
    {
      "route": "/",
      "slug": "home",
      "url": "https://www.doctoramasa.com",
      "title": "Doctora Masa",
      "collectionTitle": "Home (Baja temporal)",
      "description": "Cirugía plástica y estética en Madrid  · Doctora Masa · Cirugía de mama ✓ · Liposucción ✓ · Blefaroplastia ✓ · Otoplastia ✓ · Máxima calidad y seguridad ✓  ☎ Pida su 1ª Cita Gratuita",
      "category": "profile",
      "lastmod": "",
      "priority": "1.0",
      "headings": [
        {
          "level": "h2",
          "text": "Mamas"
        },
        {
          "level": "h2",
          "text": "Facial"
        },
        {
          "level": "h2",
          "text": "Corporal"
        },
        {
          "level": "h2",
          "text": "Reconstrucción"
        },
        {
          "level": "h3",
          "text": "Profesionalidad"
        },
        {
          "level": "h3",
          "text": "1ª Consulta informativa"
        },
        {
          "level": "h3",
          "text": "Seguridad"
        }
      ],
      "sections": [
        {
          "heading": "Mamas",
          "body": "Aumento de pecho\nElevación de pecho\nReducción de pecho\nAsimetría de pecho\nReconstrucción",
          "items": [
            "Aumento de pecho",
            "Elevación de pecho",
            "Reducción de pecho",
            "Asimetría de pecho",
            "Reconstrucción"
          ]
        },
        {
          "heading": "Facial",
          "body": "Otoplastia\nBlefaroplastia\nRinoplastia\nLifting facial",
          "items": [
            "Otoplastia",
            "Blefaroplastia",
            "Rinoplastia",
            "Lifting facial"
          ]
        },
        {
          "heading": "Corporal",
          "body": "Liposucción\nAbdominoplastia\nLifting de muslos\nLipotransferencia\nCirugía íntima",
          "items": [
            "Liposucción",
            "Abdominoplastia",
            "Lifting de muslos",
            "Lipotransferencia",
            "Cirugía íntima"
          ]
        },
        {
          "heading": "Reconstrucción",
          "body": "Reconstrucción de mama\nOncología cutánea\nPérdidas de sustancia\nQuemaduras",
          "items": [
            "Reconstrucción de mama",
            "Oncología cutánea",
            "Pérdidas de sustancia",
            "Quemaduras"
          ]
        },
        {
          "heading": "",
          "body": "La doctora Inmaculada Masa es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid y Doctora cum laude en Medicina por la Universidad Autónoma de Madrid. Saber más...",
          "items": [
            "La doctora Inmaculada Masa es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid y Doctora cum laude en Medicina por la Universidad Autónoma de Madrid. Saber más..."
          ]
        },
        {
          "heading": "",
          "body": "\"En cirugía plástica, considero imprescindible ejercer con profesionalidad, cercanía y honestidad. Entender y ayudar a mis pacientes es mi principal motivación.\"\nDoctora Masa",
          "items": [
            "\"En cirugía plástica, considero imprescindible ejercer con profesionalidad, cercanía y honestidad. Entender y ayudar a mis pacientes es mi principal motivación.\"",
            "Doctora Masa"
          ]
        },
        {
          "heading": "Profesionalidad",
          "body": "La dra. Masa está acreditada por la Sociedad Española de Cirugía Plástica, Reparadora y Estética (SECPRE).",
          "items": [
            "La dra. Masa está acreditada por la Sociedad Española de Cirugía Plástica, Reparadora y Estética (SECPRE)."
          ]
        },
        {
          "heading": "1ª Consulta informativa",
          "body": "Te ofrecemos un asesoramiento personalizado y resolvemos todas tus dudas",
          "items": [
            "Te ofrecemos un asesoramiento personalizado y resolvemos todas tus dudas"
          ]
        },
        {
          "heading": "Seguridad",
          "body": "La seguridad es una máxima de nuestro servicio. Te atenderemos en HM Hospitales, centros de reconocido prestigio en Madrid.",
          "items": [
            "La seguridad es una máxima de nuestro servicio. Te atenderemos en HM Hospitales, centros de reconocido prestigio en Madrid."
          ]
        }
      ],
      "blocks": [
        "Mamas\nAumento de pecho\nElevación de pecho\nReducción de pecho\nAsimetría de pecho\nReconstrucción",
        "Facial\nOtoplastia\nBlefaroplastia\nRinoplastia\nLifting facial",
        "Corporal\nLiposucción\nAbdominoplastia\nLifting de muslos\nLipotransferencia\nCirugía íntima",
        "Reconstrucción\nReconstrucción de mama\nOncología cutánea\nPérdidas de sustancia\nQuemaduras",
        "La doctora Inmaculada Masa es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid y Doctora cum laude en Medicina por la Universidad Autónoma de Madrid. Saber más...",
        "\"En cirugía plástica, considero imprescindible ejercer con profesionalidad, cercanía y honestidad. Entender y ayudar a mis pacientes es mi principal motivación.\"\nDoctora Masa",
        "Profesionalidad\nLa dra. Masa está acreditada por la Sociedad Española de Cirugía Plástica, Reparadora y Estética (SECPRE).",
        "1ª Consulta informativa\nTe ofrecemos un asesoramiento personalizado y resolvemos todas tus dudas",
        "Seguridad\nLa seguridad es una máxima de nuestro servicio. Te atenderemos en HM Hospitales, centros de reconocido prestigio en Madrid."
      ],
      "images": [
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/sensabell_fotos_dra-inma_39-2ca1d2db5c.jpg",
        "/assets/squarespace/sensabell_fotos_dra-inma_26-b6fd55c1ca.jpg",
        "/assets/squarespace/img_0031-83a24c7e72.jpg",
        "/assets/squarespace/image-asset-bce51393a6.jpg",
        "/assets/squarespace/image-asset-9097a98543.jpg",
        "/assets/squarespace/image-asset-8a31dd194b.jpg",
        "/assets/squarespace/image-asset-f62353df21.jpg",
        "/assets/squarespace/image-asset-cefd18e88c.jpg"
      ]
    },
    {
      "route": "/blog",
      "slug": "blog",
      "url": "https://www.doctoramasa.com/blog",
      "title": "Blog",
      "collectionTitle": "Blog",
      "description": "",
      "category": "legacy",
      "lastmod": "2016-01-12",
      "priority": "0.75",
      "headings": [],
      "sections": [],
      "blocks": [],
      "images": [
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png",
        "/assets/squarespace/videoconsulta-1-e78b92b59a.png",
        "/assets/squarespace/videoconsulta-1-6679593101.png",
        "/assets/squarespace/videoconsulta-1-3f2ea7e36b.png"
      ]
    },
    {
      "route": "/workshops-om",
      "slug": "workshops-om",
      "url": "https://www.doctoramasa.com/workshops-om",
      "title": "Workshops",
      "collectionTitle": "Workshops",
      "description": "",
      "category": "legacy",
      "lastmod": "2025-05-09",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Yoga Hike"
        },
        {
          "level": "h1",
          "text": "Instructor Training"
        },
        {
          "level": "h1",
          "text": "Yoga Aerobics"
        }
      ],
      "sections": [
        {
          "heading": "",
          "body": "Curabitur blandit tempus porttitor. Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.\nPraesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec sed odio dui. Maecenas faucibus mollis interdum. Maecenas faucibus mollis interdum. Curabitur blandit tempus porttitor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.",
          "items": [
            "Curabitur blandit tempus porttitor. Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.",
            "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec sed odio dui. Maecenas faucibus mollis interdum. Maecenas faucibus mollis interdum. Curabitur blandit tempus porttitor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit."
          ]
        },
        {
          "heading": "",
          "body": "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.\nCras mattis consectetur purus sit amet fermentum. Nulla vitae elit libero, a pharetra augue. Maecenas sed diam eget risus varius blandit sit amet non magna. Sed posuere consectetur est at lobortis. Curabitur blandit tempus porttitor. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.",
          "items": [
            "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.",
            "Cras mattis consectetur purus sit amet fermentum. Nulla vitae elit libero, a pharetra augue. Maecenas sed diam eget risus varius blandit sit amet non magna. Sed posuere consectetur est at lobortis. Curabitur blandit tempus porttitor. Morbi leo risus, porta ac consectetur ac, vestibulum at eros."
          ]
        },
        {
          "heading": "",
          "body": "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec ullamcorper nulla non metus auctor fringilla.\nAenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Maecenas faucibus mollis interdum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Donec sed odio dui.",
          "items": [
            "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec ullamcorper nulla non metus auctor fringilla.",
            "Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Maecenas faucibus mollis interdum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Donec sed odio dui."
          ]
        }
      ],
      "blocks": [
        "Curabitur blandit tempus porttitor. Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.\nPraesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec sed odio dui. Maecenas faucibus mollis interdum. Maecenas faucibus mollis interdum. Curabitur blandit tempus porttitor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.",
        "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.\nCras mattis consectetur purus sit amet fermentum. Nulla vitae elit libero, a pharetra augue. Maecenas sed diam eget risus varius blandit sit amet non magna. Sed posuere consectetur est at lobortis. Curabitur blandit tempus porttitor. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.",
        "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec ullamcorper nulla non metus auctor fringilla.\nAenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Maecenas faucibus mollis interdum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Donec sed odio dui."
      ],
      "images": [
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/image-asset-3b32f2b70a.jpg",
        "/assets/squarespace/image-asset-8b1ca18f19.jpg",
        "/assets/squarespace/image-asset-a7f23287c2.jpg",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png"
      ]
    },
    {
      "route": "/workshops-om/2014/9/15/yoga-aerobics-b7wmp",
      "slug": "workshops-om-2014-9-15-yoga-aerobics-b7wmp",
      "url": "https://www.doctoramasa.com/workshops-om/2014/9/15/yoga-aerobics-b7wmp",
      "title": "Yoga Aerobics",
      "collectionTitle": "Workshops",
      "description": "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec ullam",
      "category": "legacy",
      "lastmod": "2019-04-10",
      "priority": "0.5",
      "headings": [
        {
          "level": "h1",
          "text": "Yoga Aerobics"
        }
      ],
      "sections": [
        {
          "heading": "",
          "body": "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec ullamcorper nulla non metus auctor fringilla.\nAenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Maecenas faucibus mollis interdum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Donec sed odio dui.",
          "items": [
            "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec ullamcorper nulla non metus auctor fringilla.",
            "Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Maecenas faucibus mollis interdum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Donec sed odio dui."
          ]
        }
      ],
      "blocks": [
        "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Sed posuere consectetur est at lobortis. Nullam id dolor id nibh ultricies vehicula ut id elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec ullamcorper nulla non metus auctor fringilla.\nAenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Maecenas faucibus mollis interdum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Donec sed odio dui."
      ],
      "images": [
        "/assets/squarespace/asset-634a4bdfc2.webp",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png",
        "/assets/squarespace/videoconsulta-1-e78b92b59a.png",
        "/assets/squarespace/videoconsulta-1-6679593101.png",
        "/assets/squarespace/videoconsulta-1-3f2ea7e36b.png"
      ]
    },
    {
      "route": "/workshops-om/2014/9/15/yoga-for-toddlers-mr3bb",
      "slug": "workshops-om-2014-9-15-yoga-for-toddlers-mr3bb",
      "url": "https://www.doctoramasa.com/workshops-om/2014/9/15/yoga-for-toddlers-mr3bb",
      "title": "Yoga Hike",
      "collectionTitle": "Workshops",
      "description": "Curabitur blandit tempus porttitor. Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.  Praesent commodo cursus magn",
      "category": "legacy",
      "lastmod": "2019-04-10",
      "priority": "0.5",
      "headings": [
        {
          "level": "h1",
          "text": "Yoga Hike"
        }
      ],
      "sections": [
        {
          "heading": "",
          "body": "Curabitur blandit tempus porttitor. Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.\nPraesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec sed odio dui. Maecenas faucibus mollis interdum. Maecenas faucibus mollis interdum. Curabitur blandit tempus porttitor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.",
          "items": [
            "Curabitur blandit tempus porttitor. Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.",
            "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec sed odio dui. Maecenas faucibus mollis interdum. Maecenas faucibus mollis interdum. Curabitur blandit tempus porttitor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit."
          ]
        }
      ],
      "blocks": [
        "Curabitur blandit tempus porttitor. Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.\nPraesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec sed odio dui. Maecenas faucibus mollis interdum. Maecenas faucibus mollis interdum. Curabitur blandit tempus porttitor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit."
      ],
      "images": [
        "/assets/squarespace/asset-8576491107.webp",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png",
        "/assets/squarespace/videoconsulta-1-e78b92b59a.png",
        "/assets/squarespace/videoconsulta-1-6679593101.png",
        "/assets/squarespace/videoconsulta-1-3f2ea7e36b.png"
      ]
    },
    {
      "route": "/workshops-om/2014/11/1/instructor-training-6km3e",
      "slug": "workshops-om-2014-11-1-instructor-training-6km3e",
      "url": "https://www.doctoramasa.com/workshops-om/2014/11/1/instructor-training-6km3e",
      "title": "Instructor Training",
      "collectionTitle": "Workshops",
      "description": "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio",
      "category": "legacy",
      "lastmod": "2019-04-10",
      "priority": "0.5",
      "headings": [
        {
          "level": "h1",
          "text": "Instructor Training"
        }
      ],
      "sections": [
        {
          "heading": "",
          "body": "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.\nCras mattis consectetur purus sit amet fermentum. Nulla vitae elit libero, a pharetra augue. Maecenas sed diam eget risus varius blandit sit amet non magna. Sed posuere consectetur est at lobortis. Curabitur blandit tempus porttitor. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.",
          "items": [
            "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.",
            "Cras mattis consectetur purus sit amet fermentum. Nulla vitae elit libero, a pharetra augue. Maecenas sed diam eget risus varius blandit sit amet non magna. Sed posuere consectetur est at lobortis. Curabitur blandit tempus porttitor. Morbi leo risus, porta ac consectetur ac, vestibulum at eros."
          ]
        }
      ],
      "blocks": [
        "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.\nCras mattis consectetur purus sit amet fermentum. Nulla vitae elit libero, a pharetra augue. Maecenas sed diam eget risus varius blandit sit amet non magna. Sed posuere consectetur est at lobortis. Curabitur blandit tempus porttitor. Morbi leo risus, porta ac consectetur ac, vestibulum at eros."
      ],
      "images": [
        "/assets/squarespace/asset-dd6491840c.webp",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png",
        "/assets/squarespace/videoconsulta-1-e78b92b59a.png",
        "/assets/squarespace/videoconsulta-1-6679593101.png",
        "/assets/squarespace/videoconsulta-1-3f2ea7e36b.png"
      ]
    },
    {
      "route": "/new-cover-page",
      "slug": "new-cover-page",
      "url": "https://www.doctoramasa.com/new-cover-page",
      "title": "New Cover Page",
      "collectionTitle": "New Cover Page",
      "description": "",
      "category": "other",
      "lastmod": "2018-08-07",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Aumento de pecho"
        }
      ],
      "sections": [],
      "blocks": [],
      "images": [
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/eedb3784-58e19e1918.jpg",
        "/assets/squarespace/logo-completo.mint-oscuro.2-2--5c9b1029fd.jpg"
      ]
    },
    {
      "route": "/preoperatorio",
      "slug": "preoperatorio",
      "url": "https://www.doctoramasa.com/preoperatorio",
      "title": "Preoperatorio",
      "collectionTitle": "Preoperatorio",
      "description": "",
      "category": "other",
      "lastmod": "2016-11-20",
      "priority": "0.75",
      "headings": [],
      "sections": [
        {
          "heading": "",
          "body": "Página en construcción",
          "items": [
            "Página en construcción"
          ]
        }
      ],
      "blocks": [
        "Página en construcción"
      ],
      "images": [
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png",
        "/assets/squarespace/videoconsulta-1-e78b92b59a.png",
        "/assets/squarespace/videoconsulta-1-6679593101.png",
        "/assets/squarespace/videoconsulta-1-3f2ea7e36b.png"
      ]
    },
    {
      "route": "/postoperatorio",
      "slug": "postoperatorio",
      "url": "https://www.doctoramasa.com/postoperatorio",
      "title": "Postoperatorio",
      "collectionTitle": "Postoperatorio",
      "description": "",
      "category": "other",
      "lastmod": "2016-11-20",
      "priority": "0.75",
      "headings": [],
      "sections": [
        {
          "heading": "",
          "body": "Página en construcción",
          "items": [
            "Página en construcción"
          ]
        }
      ],
      "blocks": [
        "Página en construcción"
      ],
      "images": [
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png",
        "/assets/squarespace/videoconsulta-1-e78b92b59a.png",
        "/assets/squarespace/videoconsulta-1-6679593101.png",
        "/assets/squarespace/videoconsulta-1-3f2ea7e36b.png"
      ]
    },
    {
      "route": "/cirujano-plastico",
      "slug": "cirujano-plastico",
      "url": "https://www.doctoramasa.com/cirujano-plastico",
      "title": "Doctora Masa",
      "collectionTitle": "Doctora Masa",
      "description": "",
      "category": "profile",
      "lastmod": "2025-08-21",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Acerca"
        },
        {
          "level": "h2",
          "text": "Experiencia profesional"
        },
        {
          "level": "h2",
          "text": "Formación"
        },
        {
          "level": "h2",
          "text": "Actividad científica"
        }
      ],
      "sections": [
        {
          "heading": "Acerca",
          "body": "La doctora Inmaculada Masa es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid y Doctora cum laude en Medicina por la Universidad Autónoma de Madrid.\nDurante su trayectoria profesional ha colaborado y se ha formado en servicios de prestigio nacional (Hospital La Paz en Madrid, Instituto de la mano Dr Piñal en Santander) e internacional (SickKids Hospital en Toronto, Chang Gung Memorial Hospital en Taipei). Además, estuvo trabajando durante un año como Fellow de Cirugía Plástica en el St James´s Hospital de Dublín (Irlanda), centro de referencia en el país para la especialidad.\nActualmente, la doctora Masa desarrolla su actividad asistencial en el prestigioso Hospital Clínico San Carlos en Madrid, donde puede desarrollar su pasión por la cirugía reconstructiva. En este centro colabora estrechamente con la Unidad de Mama para el tratamiento integral de pacientes con cáncer que requieren reconstrucción mamaria. Además, fuera de la asistencia sanitaria pública realiza intervenciones de cirugía estética poniendo en práctica los principios y delicadeza de la cirugía reconstructiva.\nEn su día a día, ejerce con profesionalidad la actividad quirúrgica sin olvidar la importancia de la empatía y la comunicación, tan necesarias para el entendimiento de las necesidades y los deseos de cada paciente.",
          "items": [
            "La doctora Inmaculada Masa es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid y Doctora cum laude en Medicina por la Universidad Autónoma de Madrid.",
            "Durante su trayectoria profesional ha colaborado y se ha formado en servicios de prestigio nacional (Hospital La Paz en Madrid, Instituto de la mano Dr Piñal en Santander) e internacional (SickKids Hospital en Toronto, Chang Gung Memorial Hospital en Taipei). Además, estuvo trabajando durante un año como Fellow de Cirugía Plástica en el St James´s Hospital de Dublín (Irlanda), centro de referencia en el país para la especialidad.",
            "Actualmente, la doctora Masa desarrolla su actividad asistencial en el prestigioso Hospital Clínico San Carlos en Madrid, donde puede desarrollar su pasión por la cirugía reconstructiva. En este centro colabora estrechamente con la Unidad de Mama para el tratamiento integral de pacientes con cáncer que requieren reconstrucción mamaria. Además, fuera de la asistencia sanitaria pública realiza intervenciones de cirugía estética poniendo en práctica los principios y delicadeza de la cirugía reconstructiva.",
            "En su día a día, ejerce con profesionalidad la actividad quirúrgica sin olvidar la importancia de la empatía y la comunicación, tan necesarias para el entendimiento de las necesidades y los deseos de cada paciente."
          ]
        },
        {
          "heading": "Experiencia profesional",
          "body": "Actualmente, especialista en Cirugía Plástica y Estética en el Sensabell Plastic Surgery, Madrid.\nActualmente, especialista adjunto del Servicio de Cirugía Plástica del Hospital Clínico San Carlos (Madrid), con especial implicación en Unidad de Mama (acreditada por SESPM).\nActualmente, profesora asociada de la Facultad de Medicina, Universidad Complutense de Madrid.\nEspecialista en Cirugía Plástica y Estética en el Hospital Virgen del Mar, Madrid.\nEspecialista en Cirugía Plástica y Estética en Alluring Clinic, centro especializado en el cuidado de la piel y estética femenina de Madrid.\nEspecialista adjunto del servicio de Cirugía Plástica en el Hospital Universitario Fundación Jiménez Díaz, con asistencia en Hospital Universitario Infanta Elena (Valdemoro), Hospital General de Villalba (Collado Villalba) y Hospital Universitario Rey Juan Carlos (Móstoles).\nProfesora asociada en la Facultad de Medicina de la Universidad San Pablo CEU.\nEspecialista en Cirugía Plástica en Clínica Londres (Madrid).\nEspecialista adjunto del Servicio de Cirugía Plástica del Hospital Universitario HM Puerta del Sur (Móstoles) y HM Nuevo Belén (Madrid).\nFellowship en Cirugía Plástica y Reconstructiva, St James´s Hospital (Dublín, Irlanda).\nEstancia en Unidad de Cirugía de la Mano, Dr. Piñal y asociados (Santander).\nEstancia en Unidad de Microcirugía, Chang Gung Memorial Hospital (Taipei, Taiwan).\nEstancia en Unidad de Cirugía Plástica Pediátrica, The Hospital for Sick Children (Toronto, Canadá).\nEstancia en Unidad de Cirugía Plástica Pediátrica, Great Ormond Street Hospital (Londres, Reino Unido).\nEstancia en Unidad de Cirugía Oral y Maxilofacial, Hospital Universitario Virgen del Rocío (Sevilla).\nEstancia en Unidad de de Quemados, Hospital Universitario La Paz (Madrid).\nMiembro del EBOPRAS (European Board of Plastic Reconstructive and Aesthetic Surgery)\nEspecialista en Cirugía Plástica, Reparadora y Estética vía MIR.\nDoctora en Medicina (Cum Laude) por la Universidad Autónoma de Madrid.\nMáster Universitario en Investigación en Ciencias de la Salud, Universidad de Extremadura.\nLicenciada en Medicina, Universidad de Sevilla.\nPublicaciones internacionales relacionadas con la Cirugía Plástica.\nMás de 15 comunicaciones en Congresos y Cursos de Cirugía Plástica.\nPremio accésit SECPRE de Residentes de Cirugía Plástica en 2014.\nMiembro de la Sociedad Española de Cirugía Plástica, Reconstructiva y Estética (SECPRE).\nMiembro del Ilustre Colegio de Médicos de Madrid.",
          "items": [
            "Actualmente, especialista en Cirugía Plástica y Estética en el Sensabell Plastic Surgery, Madrid.",
            "Actualmente, especialista adjunto del Servicio de Cirugía Plástica del Hospital Clínico San Carlos (Madrid), con especial implicación en Unidad de Mama (acreditada por SESPM).",
            "Actualmente, profesora asociada de la Facultad de Medicina, Universidad Complutense de Madrid.",
            "Especialista en Cirugía Plástica y Estética en el Hospital Virgen del Mar, Madrid.",
            "Especialista en Cirugía Plástica y Estética en Alluring Clinic, centro especializado en el cuidado de la piel y estética femenina de Madrid.",
            "Especialista adjunto del servicio de Cirugía Plástica en el Hospital Universitario Fundación Jiménez Díaz, con asistencia en Hospital Universitario Infanta Elena (Valdemoro), Hospital General de Villalba (Collado Villalba) y Hospital Universitario Rey Juan Carlos (Móstoles).",
            "Profesora asociada en la Facultad de Medicina de la Universidad San Pablo CEU.",
            "Especialista en Cirugía Plástica en Clínica Londres (Madrid).",
            "Especialista adjunto del Servicio de Cirugía Plástica del Hospital Universitario HM Puerta del Sur (Móstoles) y HM Nuevo Belén (Madrid).",
            "Fellowship en Cirugía Plástica y Reconstructiva, St James´s Hospital (Dublín, Irlanda).",
            "Estancia en Unidad de Cirugía de la Mano, Dr. Piñal y asociados (Santander).",
            "Estancia en Unidad de Microcirugía, Chang Gung Memorial Hospital (Taipei, Taiwan).",
            "Estancia en Unidad de Cirugía Plástica Pediátrica, The Hospital for Sick Children (Toronto, Canadá).",
            "Estancia en Unidad de Cirugía Plástica Pediátrica, Great Ormond Street Hospital (Londres, Reino Unido).",
            "Estancia en Unidad de Cirugía Oral y Maxilofacial, Hospital Universitario Virgen del Rocío (Sevilla).",
            "Estancia en Unidad de de Quemados, Hospital Universitario La Paz (Madrid).",
            "Miembro del EBOPRAS (European Board of Plastic Reconstructive and Aesthetic Surgery)",
            "Especialista en Cirugía Plástica, Reparadora y Estética vía MIR.",
            "Doctora en Medicina (Cum Laude) por la Universidad Autónoma de Madrid.",
            "Máster Universitario en Investigación en Ciencias de la Salud, Universidad de Extremadura.",
            "Licenciada en Medicina, Universidad de Sevilla.",
            "Publicaciones internacionales relacionadas con la Cirugía Plástica.",
            "Más de 15 comunicaciones en Congresos y Cursos de Cirugía Plástica.",
            "Premio accésit SECPRE de Residentes de Cirugía Plástica en 2014.",
            "Miembro de la Sociedad Española de Cirugía Plástica, Reconstructiva y Estética (SECPRE).",
            "Miembro del Ilustre Colegio de Médicos de Madrid."
          ]
        }
      ],
      "blocks": [
        "Acerca\nLa doctora Inmaculada Masa es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid y Doctora cum laude en Medicina por la Universidad Autónoma de Madrid.\nDurante su trayectoria profesional ha colaborado y se ha formado en servicios de prestigio nacional (Hospital La Paz en Madrid, Instituto de la mano Dr Piñal en Santander) e internacional (SickKids Hospital en Toronto, Chang Gung Memorial Hospital en Taipei). Además, estuvo trabajando durante un año como Fellow de Cirugía Plástica en el St James´s Hospital de Dublín (Irlanda), centro de referencia en el país para la especialidad.\nActualmente, la doctora Masa desarrolla su actividad asistencial en el prestigioso Hospital Clínico San Carlos en Madrid, donde puede desarrollar su pasión por la cirugía reconstructiva. En este centro colabora estrechamente con la Unidad de Mama para el tratamiento integral de pacientes con cáncer que requieren reconstrucción mamaria. Además, fuera de la asistencia sanitaria pública realiza intervenciones de cirugía estética poniendo en práctica los principios y delicadeza de la cirugía reconstructiva.\nEn su día a día, ejerce con profesionalidad la actividad quirúrgica sin olvidar la importancia de la empatía y la comunicación, tan necesarias para el entendimiento de las necesidades y los deseos de cada paciente.",
        "Experiencia profesional\nActualmente, especialista en Cirugía Plástica y Estética en el Sensabell Plastic Surgery, Madrid.\nActualmente, especialista adjunto del Servicio de Cirugía Plástica del Hospital Clínico San Carlos (Madrid), con especial implicación en Unidad de Mama (acreditada por SESPM).\nActualmente, profesora asociada de la Facultad de Medicina, Universidad Complutense de Madrid.\nEspecialista en Cirugía Plástica y Estética en el Hospital Virgen del Mar, Madrid.\nEspecialista en Cirugía Plástica y Estética en Alluring Clinic, centro especializado en el cuidado de la piel y estética femenina de Madrid.\nEspecialista adjunto del servicio de Cirugía Plástica en el Hospital Universitario Fundación Jiménez Díaz, con asistencia en Hospital Universitario Infanta Elena (Valdemoro), Hospital General de Villalba (Collado Villalba) y Hospital Universitario Rey Juan Carlos (Móstoles).\nProfesora asociada en la Facultad de Medicina de la Universidad San Pablo CEU.\nEspecialista en Cirugía Plástica en Clínica Londres (Madrid).\nEspecialista adjunto del Servicio de Cirugía Plástica del Hospital Universitario HM Puerta del Sur (Móstoles) y HM Nuevo Belén (Madrid).\nFellowship en Cirugía Plástica y Reconstructiva, St James´s Hospital (Dublín, Irlanda).\nEstancia en Unidad de Cirugía de la Mano, Dr. Piñal y asociados (Santander).\nEstancia en Unidad de Microcirugía, Chang Gung Memorial Hospital (Taipei, Taiwan).\nEstancia en Unidad de Cirugía Plástica Pediátrica, The Hospital for Sick Children (Toronto, Canadá).\nEstancia en Unidad de Cirugía Plástica Pediátrica, Great Ormond Street Hospital (Londres, Reino Unido).\nEstancia en Unidad de Cirugía Oral y Maxilofacial, Hospital Universitario Virgen del Rocío (Sevilla).\nEstancia en Unidad de de Quemados, Hospital Universitario La Paz (Madrid).\nMiembro del EBOPRAS (European Board of Plastic Reconstructive and Aesthetic Surgery)\nEspecialista en Cirugía Plástica, Reparadora y Estética vía MIR.\nDoctora en Medicina (Cum Laude) por la Universidad Autónoma de Madrid.\nMáster Universitario en Investigación en Ciencias de la Salud, Universidad de Extremadura.\nLicenciada en Medicina, Universidad de Sevilla.\nPublicaciones internacionales relacionadas con la Cirugía Plástica.\nMás de 15 comunicaciones en Congresos y Cursos de Cirugía Plástica.\nPremio accésit SECPRE de Residentes de Cirugía Plástica en 2014.\nMiembro de la Sociedad Española de Cirugía Plástica, Reconstructiva y Estética (SECPRE).\nMiembro del Ilustre Colegio de Médicos de Madrid."
      ],
      "images": [
        "/assets/squarespace/dsc04954-b0e067497f.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/dsc04954-f305cbfe55.jpg",
        "/assets/squarespace/dsc04954-1417e6e31f.jpg",
        "/assets/squarespace/dsc04954-99c2f728dc.jpg",
        "/assets/squarespace/dsc04954-3f90872638.jpg",
        "/assets/squarespace/dsc04954-c47b5efa8f.jpg",
        "/assets/squarespace/dsc04954-ef9b5582a4.jpg",
        "/assets/squarespace/dsc04954-06129ece38.jpg"
      ]
    },
    {
      "route": "/dra-masa-1",
      "slug": "dra-masa-1",
      "url": "https://www.doctoramasa.com/dra-masa-1",
      "title": "Dra Masa",
      "collectionTitle": "Dra Masa",
      "description": "Cirugía plástica y estética en Madrid ✓ ·&nbsp;Doctora Masa · Cirugía de mamas ✓ · Máxima calidad y seguridad ✓&nbsp;☎ Pida su 1ª Cita Gratuita",
      "category": "profile",
      "lastmod": "2020-04-21",
      "priority": "0.75",
      "headings": [
        {
          "level": "h2",
          "text": "Tu clínica de Cirugía Plástica en Madrid. ¡Ven a conocernos!"
        },
        {
          "level": "h2",
          "text": "Ahora también disponible nuestra Videoconsulta."
        },
        {
          "level": "h2",
          "text": "Mamas"
        },
        {
          "level": "h2",
          "text": "Facial"
        },
        {
          "level": "h2",
          "text": "Corporal"
        },
        {
          "level": "h2",
          "text": "Reconstrucción"
        },
        {
          "level": "h3",
          "text": "Profesionalidad"
        },
        {
          "level": "h3",
          "text": "1ª Consulta informativa"
        },
        {
          "level": "h3",
          "text": "Seguridad"
        }
      ],
      "sections": [
        {
          "heading": "Tu clínica de Cirugía Plástica en Madrid. ¡Ven a conocernos!",
          "body": "Resuelve tus dudas sin moverte de casa.",
          "items": [
            "Resuelve tus dudas sin moverte de casa."
          ]
        },
        {
          "heading": "Mamas",
          "body": "Aumento de pecho\nElevación de pecho\nReducción de pecho\nAsimetría de pecho\nReconstrucción",
          "items": [
            "Aumento de pecho",
            "Elevación de pecho",
            "Reducción de pecho",
            "Asimetría de pecho",
            "Reconstrucción"
          ]
        },
        {
          "heading": "Facial",
          "body": "Otoplastia\nBlefaroplastia\nRinoplastia\nLifting facial",
          "items": [
            "Otoplastia",
            "Blefaroplastia",
            "Rinoplastia",
            "Lifting facial"
          ]
        },
        {
          "heading": "Corporal",
          "body": "Liposucción\nAbdominoplastia\nLifting de muslos\nLipotransferencia\nCirugía íntima",
          "items": [
            "Liposucción",
            "Abdominoplastia",
            "Lifting de muslos",
            "Lipotransferencia",
            "Cirugía íntima"
          ]
        },
        {
          "heading": "Reconstrucción",
          "body": "Reconstrucción de mama\nOncología cutánea\nPérdidas de sustancia\nQuemaduras",
          "items": [
            "Reconstrucción de mama",
            "Oncología cutánea",
            "Pérdidas de sustancia",
            "Quemaduras"
          ]
        },
        {
          "heading": "",
          "body": "La doctora Inmaculada Masa es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid y Doctora cum laude en Medicina por la Universidad Autónoma de Madrid. Saber más...",
          "items": [
            "La doctora Inmaculada Masa es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid y Doctora cum laude en Medicina por la Universidad Autónoma de Madrid. Saber más..."
          ]
        },
        {
          "heading": "",
          "body": "\"En cirugía plástica, considero imprescindible ejercer con profesionalidad, cercanía y honestidad. Entender y ayudar a mis pacientes es mi principal motivación.\"\nDoctora Masa.",
          "items": [
            "\"En cirugía plástica, considero imprescindible ejercer con profesionalidad, cercanía y honestidad. Entender y ayudar a mis pacientes es mi principal motivación.\"",
            "Doctora Masa."
          ]
        },
        {
          "heading": "Profesionalidad",
          "body": "La dra. Masa está acreditada por la Sociedad Española de Cirugía Plástica, Reparadora y Estética (SECPRE).",
          "items": [
            "La dra. Masa está acreditada por la Sociedad Española de Cirugía Plástica, Reparadora y Estética (SECPRE)."
          ]
        },
        {
          "heading": "1ª Consulta informativa",
          "body": "Te ofrecemos un asesoramiento personalizado y resolvemos todas tus dudas",
          "items": [
            "Te ofrecemos un asesoramiento personalizado y resolvemos todas tus dudas"
          ]
        },
        {
          "heading": "Seguridad",
          "body": "La seguridad es una máxima de nuestro servicio. Te atenderemos en HM Hospitales, centros de reconocido prestigio en Madrid.",
          "items": [
            "La seguridad es una máxima de nuestro servicio. Te atenderemos en HM Hospitales, centros de reconocido prestigio en Madrid."
          ]
        }
      ],
      "blocks": [
        "Tu clínica de Cirugía Plástica en Madrid. ¡Ven a conocernos!\nResuelve tus dudas sin moverte de casa.",
        "Mamas\nAumento de pecho\nElevación de pecho\nReducción de pecho\nAsimetría de pecho\nReconstrucción",
        "Facial\nOtoplastia\nBlefaroplastia\nRinoplastia\nLifting facial",
        "Corporal\nLiposucción\nAbdominoplastia\nLifting de muslos\nLipotransferencia\nCirugía íntima",
        "Reconstrucción\nReconstrucción de mama\nOncología cutánea\nPérdidas de sustancia\nQuemaduras",
        "La doctora Inmaculada Masa es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid y Doctora cum laude en Medicina por la Universidad Autónoma de Madrid. Saber más...",
        "\"En cirugía plástica, considero imprescindible ejercer con profesionalidad, cercanía y honestidad. Entender y ayudar a mis pacientes es mi principal motivación.\"\nDoctora Masa.",
        "Profesionalidad\nLa dra. Masa está acreditada por la Sociedad Española de Cirugía Plástica, Reparadora y Estética (SECPRE).",
        "1ª Consulta informativa\nTe ofrecemos un asesoramiento personalizado y resolvemos todas tus dudas",
        "Seguridad\nLa seguridad es una máxima de nuestro servicio. Te atenderemos en HM Hospitales, centros de reconocido prestigio en Madrid."
      ],
      "images": [
        "/assets/squarespace/eedb3825-1991c5068d.jpg",
        "/assets/squarespace/img_0031-83a24c7e72.jpg",
        "/assets/squarespace/eedb3853-7d96611053.jpg",
        "/assets/squarespace/image-asset-bce51393a6.jpg",
        "/assets/squarespace/image-asset-dd26de1725.jpg",
        "/assets/squarespace/image-asset-0a59dab612.jpg",
        "/assets/squarespace/image-asset-8430df6428.jpg",
        "/assets/squarespace/image-asset-5d69e03a59.jpg",
        "/assets/squarespace/image-asset-3f2d3b2871.jpg",
        "/assets/squarespace/image-asset-a460a7dc97.jpg",
        "/assets/squarespace/image-asset-3ca9b3032e.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png"
      ]
    },
    {
      "route": "/contacto",
      "slug": "contacto",
      "url": "https://www.doctoramasa.com/contacto",
      "title": "Contacto",
      "collectionTitle": "Contacto",
      "description": "",
      "category": "contact",
      "lastmod": "2020-08-26",
      "priority": "0.75",
      "headings": [
        {
          "level": "h2",
          "text": "Pronto estaremos de vuelta para atenderte en nuestras consultas"
        },
        {
          "level": "h3",
          "text": "Videoconsulta a distancia"
        },
        {
          "level": "h3",
          "text": "Consulta de López Pozas"
        },
        {
          "level": "h3",
          "text": "Consulta de Alluring Clinic"
        },
        {
          "level": "h2",
          "text": "Consúltanos tus dudas"
        }
      ],
      "sections": [
        {
          "heading": "Pronto estaremos de vuelta para atenderte en nuestras consultas",
          "body": "",
          "items": []
        },
        {
          "heading": "Videoconsulta a distancia",
          "body": "Desde tu móvil, tablet u ordenado",
          "items": [
            "Desde tu móvil, tablet u ordenado"
          ]
        },
        {
          "heading": "Consulta de López Pozas",
          "body": "En Calle General López Pozas, 10.",
          "items": [
            "En Calle General López Pozas, 10."
          ]
        },
        {
          "heading": "Consulta de Alluring Clinic",
          "body": "En Calle de Raimundo Fdez-Villaverde, 53C.",
          "items": [
            "En Calle de Raimundo Fdez-Villaverde, 53C."
          ]
        },
        {
          "heading": "Consúltanos tus dudas",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Mediante el uso de este formulario de contacto enviarás un correo electrónico a la Doctora Masa. Enviando el formulario aceptas nuestra Política de Privacidad.",
          "items": [
            "Mediante el uso de este formulario de contacto enviarás un correo electrónico a la Doctora Masa. Enviando el formulario aceptas nuestra Política de Privacidad."
          ]
        }
      ],
      "blocks": [
        "Pronto estaremos de vuelta para atenderte en nuestras consultas",
        "Videoconsulta a distancia\nDesde tu móvil, tablet u ordenado",
        "Consulta de López Pozas\nEn Calle General López Pozas, 10.",
        "Consulta de Alluring Clinic\nEn Calle de Raimundo Fdez-Villaverde, 53C.",
        "Consúltanos tus dudas",
        "Mediante el uso de este formulario de contacto enviarás un correo electrónico a la Doctora Masa. Enviando el formulario aceptas nuestra Política de Privacidad."
      ],
      "images": [
        "/assets/squarespace/img_0008-f150fc65df.jpg",
        "/assets/squarespace/foto-videollamada-1f218fb6ec.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/foto-videollamada-dcaa261296.jpg",
        "/assets/squarespace/foto-videollamada-8b11947e6c.jpg",
        "/assets/squarespace/foto-videollamada-8ce0ea3f43.jpg",
        "/assets/squarespace/foto-videollamada-afe7d038ad.jpg",
        "/assets/squarespace/foto-videollamada-b2f899b730.jpg",
        "/assets/squarespace/foto-videollamada-e23c362847.jpg"
      ]
    },
    {
      "route": "/aumento-de-pecho-madrid",
      "slug": "aumento-de-pecho-madrid",
      "url": "https://www.doctoramasa.com/aumento-de-pecho-madrid",
      "title": "Aumento de pecho",
      "collectionTitle": "Aumento de pecho",
      "description": "Cirugía plástica y estética en Madrid · Doctora Masa · Aumento de mama ✓ · Resultados naturales ✓&nbsp;· Máxima calidad y seguridad ✓ &nbsp;☎ Pida su 1ª Cita Gratuita",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Aumento de Pecho"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera Consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Aumento de Pecho",
          "body": "El aumento de senos o mamoplastia de aumento, es un procedimiento quirúrgico cuyo objetivo es incrementar el tamaño y mejorar la forma del pecho de la mujer. Este aumento de volumen se consigue introduciendo unos implantes detrás de la glándula mamaria o del músculo pectoral mayor. La vía de abordaje, la posición y el tipo de implante dependerá de las necesidades de cada paciente, considerando sus preferencias y anatomía.",
          "items": [
            "El aumento de senos o mamoplastia de aumento, es un procedimiento quirúrgico cuyo objetivo es incrementar el tamaño y mejorar la forma del pecho de la mujer. Este aumento de volumen se consigue introduciendo unos implantes detrás de la glándula mamaria o del músculo pectoral mayor. La vía de abordaje, la posición y el tipo de implante dependerá de las necesidades de cada paciente, considerando sus preferencias y anatomía."
          ]
        },
        {
          "heading": "Indicación",
          "body": "La mamoplastia de aumento es la operación perfecta para aquellas mujeres que deseen aumentar el volumen y mejorar forma del pecho. Mediante esta operación podemos conseguir un pecho bonito, proporcionado y natural. En esta cirugía utilizamos implantes mamarios para:\nAumentar el volumen en senos hipoplásicos o pequeños.\nRecuperar la forma de tu pecho tras embarazos o pérdidas importante de peso.\nCorregir asimetrías o anomalías congénitas (ej. mamas tuberosas).",
          "items": [
            "La mamoplastia de aumento es la operación perfecta para aquellas mujeres que deseen aumentar el volumen y mejorar forma del pecho. Mediante esta operación podemos conseguir un pecho bonito, proporcionado y natural. En esta cirugía utilizamos implantes mamarios para:",
            "Aumentar el volumen en senos hipoplásicos o pequeños.",
            "Recuperar la forma de tu pecho tras embarazos o pérdidas importante de peso.",
            "Corregir asimetrías o anomalías congénitas (ej. mamas tuberosas)."
          ]
        },
        {
          "heading": "Primera Consulta",
          "body": "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preferencias y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una simulación de volumen que nos ayudará a elegir el implante. Finalizamos la consulta explicando las posibilidades quirúrgicas que se adaptan a las necesidades de cada paciente. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta informativa y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preferencias y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una simulación de volumen que nos ayudará a elegir el implante. Finalizamos la consulta explicando las posibilidades quirúrgicas que se adaptan a las necesidades de cada paciente. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.",
            "Acude a la primera consulta informativa y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La operación de aumento de pecho se realiza en un quirófano bajo anestesia general, es decir la paciente permanece dormida y monitorizada durante toda la operación. En función de la vía de abordaje que hayamos elegido para la colocación del implante realizaremos una pequeña incisión en el surco bajo del pecho o alrededor de la areola para introducir el implante. Este implante se alojará detrás de la glándula o del músculo pectoral según lo decidido en la primera consulta. La operación tiene una duración aproximada de una hora y en todo momento tus familiares permanecerán informados. Después de la cirugía utilizamos un vendaje compresivo que será sustituido por un sujetador anatómico a las 24 horas.",
          "items": [
            "La operación de aumento de pecho se realiza en un quirófano bajo anestesia general, es decir la paciente permanece dormida y monitorizada durante toda la operación. En función de la vía de abordaje que hayamos elegido para la colocación del implante realizaremos una pequeña incisión en el surco bajo del pecho o alrededor de la areola para introducir el implante. Este implante se alojará detrás de la glándula o del músculo pectoral según lo decidido en la primera consulta. La operación tiene una duración aproximada de una hora y en todo momento tus familiares permanecerán informados. Después de la cirugía utilizamos un vendaje compresivo que será sustituido por un sujetador anatómico a las 24 horas."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "Tras la operación, es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. A las 24 horas de la intervención sustituiremos el vendaje postoperatorio por un sujetador anatómico. Recomendamos usar este sujetador día y noche durante unas 3-4 semanas. A partir del 4º-5º día te puedes reincorporar a tu vida habitual, solo evitando hacer grandes esfuerzos con los brazos durante las 2-3 semanas siguientes. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de tus senos.\nLos resultados de un aumento de mama son naturales y estéticamente satisfactorios, siempre y cuando se respeten las dimensiones y el volumen final sea el adecuado al tórax y al físico de la paciente.",
          "items": [
            "Tras la operación, es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. A las 24 horas de la intervención sustituiremos el vendaje postoperatorio por un sujetador anatómico. Recomendamos usar este sujetador día y noche durante unas 3-4 semanas. A partir del 4º-5º día te puedes reincorporar a tu vida habitual, solo evitando hacer grandes esfuerzos con los brazos durante las 2-3 semanas siguientes. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de tus senos.",
            "Los resultados de un aumento de mama son naturales y estéticamente satisfactorios, siempre y cuando se respeten las dimensiones y el volumen final sea el adecuado al tórax y al físico de la paciente."
          ]
        }
      ],
      "blocks": [
        "Aumento de Pecho\nEl aumento de senos o mamoplastia de aumento, es un procedimiento quirúrgico cuyo objetivo es incrementar el tamaño y mejorar la forma del pecho de la mujer. Este aumento de volumen se consigue introduciendo unos implantes detrás de la glándula mamaria o del músculo pectoral mayor. La vía de abordaje, la posición y el tipo de implante dependerá de las necesidades de cada paciente, considerando sus preferencias y anatomía.",
        "Indicación\nLa mamoplastia de aumento es la operación perfecta para aquellas mujeres que deseen aumentar el volumen y mejorar forma del pecho. Mediante esta operación podemos conseguir un pecho bonito, proporcionado y natural. En esta cirugía utilizamos implantes mamarios para:\nAumentar el volumen en senos hipoplásicos o pequeños.\nRecuperar la forma de tu pecho tras embarazos o pérdidas importante de peso.\nCorregir asimetrías o anomalías congénitas (ej. mamas tuberosas).",
        "Primera Consulta\nEn la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preferencias y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una simulación de volumen que nos ayudará a elegir el implante. Finalizamos la consulta explicando las posibilidades quirúrgicas que se adaptan a las necesidades de cada paciente. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta informativa y consúltanos sin compromiso.",
        "Operación\nLa operación de aumento de pecho se realiza en un quirófano bajo anestesia general, es decir la paciente permanece dormida y monitorizada durante toda la operación. En función de la vía de abordaje que hayamos elegido para la colocación del implante realizaremos una pequeña incisión en el surco bajo del pecho o alrededor de la areola para introducir el implante. Este implante se alojará detrás de la glándula o del músculo pectoral según lo decidido en la primera consulta. La operación tiene una duración aproximada de una hora y en todo momento tus familiares permanecerán informados. Después de la cirugía utilizamos un vendaje compresivo que será sustituido por un sujetador anatómico a las 24 horas.",
        "Postoperatorio\nTras la operación, es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. A las 24 horas de la intervención sustituiremos el vendaje postoperatorio por un sujetador anatómico. Recomendamos usar este sujetador día y noche durante unas 3-4 semanas. A partir del 4º-5º día te puedes reincorporar a tu vida habitual, solo evitando hacer grandes esfuerzos con los brazos durante las 2-3 semanas siguientes. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de tus senos.\nLos resultados de un aumento de mama son naturales y estéticamente satisfactorios, siempre y cuando se respeten las dimensiones y el volumen final sea el adecuado al tórax y al físico de la paciente."
      ],
      "images": [
        "/assets/squarespace/exploraci-n-mama-6f7694dc81.webp",
        "/assets/squarespace/eedb3738-381d9d1829.jpg",
        "/assets/squarespace/eedb3878-729a0eab46.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/exploraci-n-mama-07834d558e.webp",
        "/assets/squarespace/exploraci-n-mama-814eb0eba9.webp",
        "/assets/squarespace/exploraci-n-mama-f9521fcd2b.webp",
        "/assets/squarespace/exploraci-n-mama-1ee071accc.webp",
        "/assets/squarespace/exploraci-n-mama-e1f55f188b.webp"
      ]
    },
    {
      "route": "/cirugia-mamaria-madrid",
      "slug": "cirugia-mamaria-madrid",
      "url": "https://www.doctoramasa.com/cirugia-mamaria-madrid",
      "title": "Cirugía mamaria",
      "collectionTitle": "Cirugía mamaria",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h3",
          "text": "Aumento de pecho"
        },
        {
          "level": "h3",
          "text": "Elevación de pecho"
        },
        {
          "level": "h3",
          "text": "Reducción de pecho"
        },
        {
          "level": "h3",
          "text": "Aumento con grasa propia"
        },
        {
          "level": "h3",
          "text": "Asimetría de pecho"
        },
        {
          "level": "h3",
          "text": "Reconstrucción"
        }
      ],
      "sections": [
        {
          "heading": "Aumento de pecho",
          "body": "",
          "items": []
        },
        {
          "heading": "Elevación de pecho",
          "body": "",
          "items": []
        },
        {
          "heading": "Reducción de pecho",
          "body": "",
          "items": []
        },
        {
          "heading": "Aumento con grasa propia",
          "body": "",
          "items": []
        },
        {
          "heading": "Asimetría de pecho",
          "body": "",
          "items": []
        },
        {
          "heading": "Reconstrucción",
          "body": "",
          "items": []
        }
      ],
      "blocks": [
        "Aumento de pecho",
        "Elevación de pecho",
        "Reducción de pecho",
        "Aumento con grasa propia",
        "Asimetría de pecho",
        "Reconstrucción"
      ],
      "images": [
        "/assets/squarespace/image-asset-7257a97311.jpg",
        "/assets/squarespace/image-asset-5d788c2e01.jpg",
        "/assets/squarespace/breast-633a0f6615.webp",
        "/assets/squarespace/aumento-de-pecho-aa391fff40.webp",
        "/assets/squarespace/image-asset-b29d91e1ee.jpg",
        "/assets/squarespace/image-asset-bbd5988cd5.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/aumento-de-pecho-5eaaeaf1d2.webp",
        "/assets/squarespace/aumento-de-pecho-a3e1b47449.webp"
      ]
    },
    {
      "route": "/reduccion-de-pecho-madrid",
      "slug": "reduccion-de-pecho-madrid",
      "url": "https://www.doctoramasa.com/reduccion-de-pecho-madrid",
      "title": "Reducción de pecho",
      "collectionTitle": "Reducción de pecho",
      "description": "Cirugía plástica y estética en Madrid · Doctora Masa · Reducción de pecho ✓ · Mastopexia ✓&nbsp;· Resultados naturales ✓&nbsp;· Máxima calidad y seguridad ✓ &nbsp;☎ Pida su 1ª Cita Gratuita",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Reducción de pecho"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera Consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Reducción de pecho",
          "body": "La reducción de pecho o mamoplastia de reducción es una técnica quirúrgica encaminada a la disminución y armonización del tamaño de las mamas grandes o desproporcionadas.\nUn exceso de volumen en los senos se debe al desarrollo excesivo de la glándula mamaria y del tejido adiposo (grasa) de su interior y puede darse tanto en mujeres obesas como en mujeres delgadas. En muchas ocasiones el excesivo volumen del pecho puede producir en la mujer dolores de espalda y de cuello, irritación de la piel debajo de la mama y problemas respiratorios. En estos casos, la reducción de pecho mejora considerablemente la calidad de vida de las pacientes.",
          "items": [
            "La reducción de pecho o mamoplastia de reducción es una técnica quirúrgica encaminada a la disminución y armonización del tamaño de las mamas grandes o desproporcionadas.",
            "Un exceso de volumen en los senos se debe al desarrollo excesivo de la glándula mamaria y del tejido adiposo (grasa) de su interior y puede darse tanto en mujeres obesas como en mujeres delgadas. En muchas ocasiones el excesivo volumen del pecho puede producir en la mujer dolores de espalda y de cuello, irritación de la piel debajo de la mama y problemas respiratorios. En estos casos, la reducción de pecho mejora considerablemente la calidad de vida de las pacientes."
          ]
        },
        {
          "heading": "Indicación",
          "body": "La mamoplastia de reducción está especialmente indicada en aquellas mujeres que, como consecuencia del tamaño de su pecho, ven afectada su calidad de vida, ya que padecen problemas estéticos y funcionales, como dolor de cuello y espalda, irritación de la piel, problemas respiratorios y dificultad para vestir.",
          "items": [
            "La mamoplastia de reducción está especialmente indicada en aquellas mujeres que, como consecuencia del tamaño de su pecho, ven afectada su calidad de vida, ya que padecen problemas estéticos y funcionales, como dolor de cuello y espalda, irritación de la piel, problemas respiratorios y dificultad para vestir."
          ]
        },
        {
          "heading": "Primera Consulta",
          "body": "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preferencias y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física en la que evaluamos la caída de la mama y el exceso glandular a resecar. Finalizamos la consulta explicando las posibilidades quirúrgicas que se adaptan a las necesidades de cada paciente. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta informativa y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preferencias y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física en la que evaluamos la caída de la mama y el exceso glandular a resecar. Finalizamos la consulta explicando las posibilidades quirúrgicas que se adaptan a las necesidades de cada paciente. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.",
            "Acude a la primera consulta informativa y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La intervención se realiza en un quirófano bajo anestesia general, es decir la paciente permanece dormida y monitorizada durante toda la operación. Existen distintos técnicas para realizar el tratamiento de reducción de pecho, pero la más frecuente deja una pequeña cicatriz ubicada alrededor de la areola y desde la areola hasta el surco (con forma de T invertida). Al terminar la cirugía, la paciente saldrá del quirófano con un vendaje en el pecho.\nLa intervención tiene una duración aproximada de 2-3 horas y en todo momento sus familiares están totalmente informados.",
          "items": [
            "La intervención se realiza en un quirófano bajo anestesia general, es decir la paciente permanece dormida y monitorizada durante toda la operación. Existen distintos técnicas para realizar el tratamiento de reducción de pecho, pero la más frecuente deja una pequeña cicatriz ubicada alrededor de la areola y desde la areola hasta el surco (con forma de T invertida). Al terminar la cirugía, la paciente saldrá del quirófano con un vendaje en el pecho.",
            "La intervención tiene una duración aproximada de 2-3 horas y en todo momento sus familiares están totalmente informados."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "Tras la intervención de reducción de pecho la paciente saldrá del quirófano con un vendaje. Es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la intervención.\nLa paciente podrá recuperar sus actividad normal en dos a cuatro días. No obstante, le recomendamos que limite su actividad física al principio, evitando ejercicios pesados o movimientos bruscos durante al menos tres semanas. La paciente debe llevar un sujetador anatómico especial también en las tres primeras semanas. Una vez transcurrido este plazo, la inflamación se habrá reducido casi completamente y comenzaremos a ver el pecho más natural.\nLas cicatrices pueden ser algo más visibles y tener un aspecto sonrosado durante los primeros meses. No obstante, al final del primer año comienzan a tener un color más pálido haciéndose, a menudo, prácticamente inapreciables.",
          "items": [
            "Tras la intervención de reducción de pecho la paciente saldrá del quirófano con un vendaje. Es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la intervención.",
            "La paciente podrá recuperar sus actividad normal en dos a cuatro días. No obstante, le recomendamos que limite su actividad física al principio, evitando ejercicios pesados o movimientos bruscos durante al menos tres semanas. La paciente debe llevar un sujetador anatómico especial también en las tres primeras semanas. Una vez transcurrido este plazo, la inflamación se habrá reducido casi completamente y comenzaremos a ver el pecho más natural.",
            "Las cicatrices pueden ser algo más visibles y tener un aspecto sonrosado durante los primeros meses. No obstante, al final del primer año comienzan a tener un color más pálido haciéndose, a menudo, prácticamente inapreciables."
          ]
        }
      ],
      "blocks": [
        "Reducción de pecho\nLa reducción de pecho o mamoplastia de reducción es una técnica quirúrgica encaminada a la disminución y armonización del tamaño de las mamas grandes o desproporcionadas.\nUn exceso de volumen en los senos se debe al desarrollo excesivo de la glándula mamaria y del tejido adiposo (grasa) de su interior y puede darse tanto en mujeres obesas como en mujeres delgadas. En muchas ocasiones el excesivo volumen del pecho puede producir en la mujer dolores de espalda y de cuello, irritación de la piel debajo de la mama y problemas respiratorios. En estos casos, la reducción de pecho mejora considerablemente la calidad de vida de las pacientes.",
        "Indicación\nLa mamoplastia de reducción está especialmente indicada en aquellas mujeres que, como consecuencia del tamaño de su pecho, ven afectada su calidad de vida, ya que padecen problemas estéticos y funcionales, como dolor de cuello y espalda, irritación de la piel, problemas respiratorios y dificultad para vestir.",
        "Primera Consulta\nEn la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preferencias y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física en la que evaluamos la caída de la mama y el exceso glandular a resecar. Finalizamos la consulta explicando las posibilidades quirúrgicas que se adaptan a las necesidades de cada paciente. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta informativa y consúltanos sin compromiso.",
        "Operación\nLa intervención se realiza en un quirófano bajo anestesia general, es decir la paciente permanece dormida y monitorizada durante toda la operación. Existen distintos técnicas para realizar el tratamiento de reducción de pecho, pero la más frecuente deja una pequeña cicatriz ubicada alrededor de la areola y desde la areola hasta el surco (con forma de T invertida). Al terminar la cirugía, la paciente saldrá del quirófano con un vendaje en el pecho.\nLa intervención tiene una duración aproximada de 2-3 horas y en todo momento sus familiares están totalmente informados.",
        "Postoperatorio\nTras la intervención de reducción de pecho la paciente saldrá del quirófano con un vendaje. Es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la intervención.\nLa paciente podrá recuperar sus actividad normal en dos a cuatro días. No obstante, le recomendamos que limite su actividad física al principio, evitando ejercicios pesados o movimientos bruscos durante al menos tres semanas. La paciente debe llevar un sujetador anatómico especial también en las tres primeras semanas. Una vez transcurrido este plazo, la inflamación se habrá reducido casi completamente y comenzaremos a ver el pecho más natural.\nLas cicatrices pueden ser algo más visibles y tener un aspecto sonrosado durante los primeros meses. No obstante, al final del primer año comienzan a tener un color más pálido haciéndose, a menudo, prácticamente inapreciables."
      ],
      "images": [
        "/assets/squarespace/image-asset-ffd2dfac7e.jpg",
        "/assets/squarespace/image-asset-4944a8cec2.jpg",
        "/assets/squarespace/image-asset-65a7d30917.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/image-asset-c53a65f201.jpg",
        "/assets/squarespace/image-asset-a64ed5205b.jpg",
        "/assets/squarespace/image-asset-170746b0f8.jpg",
        "/assets/squarespace/image-asset-13862b7f83.jpg",
        "/assets/squarespace/image-asset-305e54e327.jpg"
      ]
    },
    {
      "route": "/elevacion-de-pecho-madrid",
      "slug": "elevacion-de-pecho-madrid",
      "url": "https://www.doctoramasa.com/elevacion-de-pecho-madrid",
      "title": "Elevación de pecho",
      "collectionTitle": "Elevación de pecho",
      "description": "Cirugía plástica y estética en Madrid · Doctora Masa · Elevación de mama ✓ · Mastopexia ✓&nbsp;· Resultados naturales ✓&nbsp;· Máxima calidad y seguridad ✓ &nbsp;☎ Pida su 1ª Cita Gratuita",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Elevación de pecho"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Elevación de pecho",
          "body": "La elevación de senos, mamoplastia de elevación o mastopexia es un tipo de cirugía encaminada a la elevación y remodelación de las mamas caídas. Dicha elevación puede realizarse con o sin aumento de pecho (con o sin prótesis) en función de lo que la paciente desee. Con esta operación también podemos disminuir el tamaño del pezón y la areola en casos en los que sean excesivamente grandes.",
          "items": [
            "La elevación de senos, mamoplastia de elevación o mastopexia es un tipo de cirugía encaminada a la elevación y remodelación de las mamas caídas. Dicha elevación puede realizarse con o sin aumento de pecho (con o sin prótesis) en función de lo que la paciente desee. Con esta operación también podemos disminuir el tamaño del pezón y la areola en casos en los que sean excesivamente grandes."
          ]
        },
        {
          "heading": "Indicación",
          "body": "La elevación de pecho está especialmente indicada para aquellas mujeres que, aun teniendo un volumen normal, tienen el pecho caído y desean una elevación del mismo. Si además presentan poco volumen, durante la intervención se puede introducir una prótesis, para aumentar el volumen de sus senos.",
          "items": [
            "La elevación de pecho está especialmente indicada para aquellas mujeres que, aun teniendo un volumen normal, tienen el pecho caído y desean una elevación del mismo. Si además presentan poco volumen, durante la intervención se puede introducir una prótesis, para aumentar el volumen de sus senos."
          ]
        },
        {
          "heading": "Primera consulta",
          "body": "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preferencias y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física en la que evaluamos la caída de los senos y la calidad de la piel. Finalizamos la consulta explicando las posibilidades quirúrgicas que se adaptan a las necesidades de cada paciente. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta informativa y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preferencias y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física en la que evaluamos la caída de los senos y la calidad de la piel. Finalizamos la consulta explicando las posibilidades quirúrgicas que se adaptan a las necesidades de cada paciente. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.",
            "Acude a la primera consulta informativa y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La cirugía de elevación de mama se realiza en un quirófano bajo anestesia general y tiene una duración de 2-3 horas. Para conseguir un levantamiento de pecho es necesario eliminar el exceso cutáneo y adaptarlo al volumen mamario final. En función de la caída y calidad de la piel de cada paciente se diseñará un patrón cutáneo de elevación. En definitiva, estas características determinan el diseño de las cicatrices que pueden ser:\nAlrededor de la areola o periareolar\nPeriareolar añadiendo una vertical\nPeriareolar añadiendo vertical y horizontal (cicatriz en T invertida)\nLos resultados son muy satisfactorios, mejorando tanto la estética como la autoestima del paciente.",
          "items": [
            "La cirugía de elevación de mama se realiza en un quirófano bajo anestesia general y tiene una duración de 2-3 horas. Para conseguir un levantamiento de pecho es necesario eliminar el exceso cutáneo y adaptarlo al volumen mamario final. En función de la caída y calidad de la piel de cada paciente se diseñará un patrón cutáneo de elevación. En definitiva, estas características determinan el diseño de las cicatrices que pueden ser:",
            "Alrededor de la areola o periareolar",
            "Periareolar añadiendo una vertical",
            "Periareolar añadiendo vertical y horizontal (cicatriz en T invertida)",
            "Los resultados son muy satisfactorios, mejorando tanto la estética como la autoestima del paciente."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "Tras la operación la paciente saldrá del quirófano con un vendaje en el pecho. Es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la operación.\nLa paciente podrá recuperar sus actividad normal en dos a cuatro días. No obstante, le recomendamos que limite su actividad física al principio, evitando ejercicios pesados o movimientos bruscos durante al menos tres semanas. La paciente debe llevar un sujetador anatómico especial también en las tres primeras semanas. Una vez transcurrido este plazo, la inflamación se habrá reducido casi completamente y comenzaremos a ver el pecho con un aspecto más natural y definitivo.\nLas cicatrices pueden ser algo más visibles y tener un aspecto sonrosado durante los primeros meses. No obstante, al final del primer año comienzan a tener un color más pálido haciéndose, a menudo, prácticamente inapreciables.",
          "items": [
            "Tras la operación la paciente saldrá del quirófano con un vendaje en el pecho. Es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la operación.",
            "La paciente podrá recuperar sus actividad normal en dos a cuatro días. No obstante, le recomendamos que limite su actividad física al principio, evitando ejercicios pesados o movimientos bruscos durante al menos tres semanas. La paciente debe llevar un sujetador anatómico especial también en las tres primeras semanas. Una vez transcurrido este plazo, la inflamación se habrá reducido casi completamente y comenzaremos a ver el pecho con un aspecto más natural y definitivo.",
            "Las cicatrices pueden ser algo más visibles y tener un aspecto sonrosado durante los primeros meses. No obstante, al final del primer año comienzan a tener un color más pálido haciéndose, a menudo, prácticamente inapreciables."
          ]
        }
      ],
      "blocks": [
        "Elevación de pecho\nLa elevación de senos, mamoplastia de elevación o mastopexia es un tipo de cirugía encaminada a la elevación y remodelación de las mamas caídas. Dicha elevación puede realizarse con o sin aumento de pecho (con o sin prótesis) en función de lo que la paciente desee. Con esta operación también podemos disminuir el tamaño del pezón y la areola en casos en los que sean excesivamente grandes.",
        "Indicación\nLa elevación de pecho está especialmente indicada para aquellas mujeres que, aun teniendo un volumen normal, tienen el pecho caído y desean una elevación del mismo. Si además presentan poco volumen, durante la intervención se puede introducir una prótesis, para aumentar el volumen de sus senos.",
        "Primera consulta\nEn la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preferencias y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física en la que evaluamos la caída de los senos y la calidad de la piel. Finalizamos la consulta explicando las posibilidades quirúrgicas que se adaptan a las necesidades de cada paciente. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta informativa y consúltanos sin compromiso.",
        "Operación\nLa cirugía de elevación de mama se realiza en un quirófano bajo anestesia general y tiene una duración de 2-3 horas. Para conseguir un levantamiento de pecho es necesario eliminar el exceso cutáneo y adaptarlo al volumen mamario final. En función de la caída y calidad de la piel de cada paciente se diseñará un patrón cutáneo de elevación. En definitiva, estas características determinan el diseño de las cicatrices que pueden ser:\nAlrededor de la areola o periareolar\nPeriareolar añadiendo una vertical\nPeriareolar añadiendo vertical y horizontal (cicatriz en T invertida)\nLos resultados son muy satisfactorios, mejorando tanto la estética como la autoestima del paciente.",
        "Postoperatorio\nTras la operación la paciente saldrá del quirófano con un vendaje en el pecho. Es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la operación.\nLa paciente podrá recuperar sus actividad normal en dos a cuatro días. No obstante, le recomendamos que limite su actividad física al principio, evitando ejercicios pesados o movimientos bruscos durante al menos tres semanas. La paciente debe llevar un sujetador anatómico especial también en las tres primeras semanas. Una vez transcurrido este plazo, la inflamación se habrá reducido casi completamente y comenzaremos a ver el pecho con un aspecto más natural y definitivo.\nLas cicatrices pueden ser algo más visibles y tener un aspecto sonrosado durante los primeros meses. No obstante, al final del primer año comienzan a tener un color más pálido haciéndose, a menudo, prácticamente inapreciables."
      ],
      "images": [
        "/assets/squarespace/image-asset-4a885ac844.jpg",
        "/assets/squarespace/eedb3801-730b186fbd.jpg",
        "/assets/squarespace/image-asset-af7f2bf47b.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/eedb3801-cd08edaafd.jpg",
        "/assets/squarespace/eedb3801-bb8d90bced.jpg",
        "/assets/squarespace/eedb3801-cafd37128b.jpg",
        "/assets/squarespace/eedb3801-76279d29f6.jpg",
        "/assets/squarespace/eedb3801-0d6b88ae9e.jpg"
      ]
    },
    {
      "route": "/cirugia-corporal-madrid",
      "slug": "cirugia-corporal-madrid",
      "url": "https://www.doctoramasa.com/cirugia-corporal-madrid",
      "title": "Cirugía corporal",
      "collectionTitle": "Cirugía corporal",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h3",
          "text": "Liposucción"
        },
        {
          "level": "h3",
          "text": "Abdominoplastia"
        },
        {
          "level": "h3",
          "text": "Lifting de muslos"
        },
        {
          "level": "h3",
          "text": "Lipotransferencia"
        },
        {
          "level": "h3",
          "text": "Cirugía Íntima"
        }
      ],
      "sections": [
        {
          "heading": "Liposucción",
          "body": "",
          "items": []
        },
        {
          "heading": "Abdominoplastia",
          "body": "",
          "items": []
        },
        {
          "heading": "Lifting de muslos",
          "body": "",
          "items": []
        },
        {
          "heading": "Lipotransferencia",
          "body": "",
          "items": []
        },
        {
          "heading": "Cirugía Íntima",
          "body": "",
          "items": []
        }
      ],
      "blocks": [
        "Liposucción",
        "Abdominoplastia",
        "Lifting de muslos",
        "Lipotransferencia",
        "Cirugía Íntima"
      ],
      "images": [
        "/assets/squarespace/lipotransferencia-b99c1eb193.webp",
        "/assets/squarespace/liposuccion-madrid-c933dacc68.webp",
        "/assets/squarespace/hypertrophic-breast-b020cf10d0.webp",
        "/assets/squarespace/abdominoplastia-1561fe5da7.webp",
        "/assets/squarespace/lifting-de-muslos-madrid-e5dc8c1139.webp",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/liposuccion-madrid-e7f99c311d.webp",
        "/assets/squarespace/liposuccion-madrid-f515dd5013.webp",
        "/assets/squarespace/liposuccion-madrid-acc4527308.webp"
      ]
    },
    {
      "route": "/cirugia-facial-madrid",
      "slug": "cirugia-facial-madrid",
      "url": "https://www.doctoramasa.com/cirugia-facial-madrid",
      "title": "Cirugía facial",
      "collectionTitle": "Cirugía facial",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h3",
          "text": "Otoplastia"
        },
        {
          "level": "h3",
          "text": "Blefaroplastia"
        },
        {
          "level": "h3",
          "text": "Lifting facial"
        },
        {
          "level": "h3",
          "text": "Rinoplastia"
        }
      ],
      "sections": [
        {
          "heading": "Otoplastia",
          "body": "",
          "items": []
        },
        {
          "heading": "Blefaroplastia",
          "body": "",
          "items": []
        },
        {
          "heading": "Lifting facial",
          "body": "",
          "items": []
        },
        {
          "heading": "Rinoplastia",
          "body": "",
          "items": []
        }
      ],
      "blocks": [
        "Otoplastia",
        "Blefaroplastia",
        "Lifting facial",
        "Rinoplastia"
      ],
      "images": [
        "/assets/squarespace/rinoplastia-202ed30422.webp",
        "/assets/squarespace/blefaroplastia-8594353f07.webp",
        "/assets/squarespace/image-asset-97fbd71a7b.jpg",
        "/assets/squarespace/otoplasty-66aaf36194.webp",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/otoplasty-38bf191457.webp",
        "/assets/squarespace/otoplasty-05b86ae882.webp",
        "/assets/squarespace/otoplasty-6b6d8f9760.webp",
        "/assets/squarespace/otoplasty-d714582bc0.webp"
      ]
    },
    {
      "route": "/otoplastia-madrid",
      "slug": "otoplastia-madrid",
      "url": "https://www.doctoramasa.com/otoplastia-madrid",
      "title": "Otoplastia",
      "collectionTitle": "Otoplastia",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Otoplastia"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera Consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Otoplastia",
          "body": "La otoplastia es una operación encaminada a mejorar la forma y posición de las orejas. Mediante esta técnica se resuelven problemas estéticos de las orejas separadas, también denominadas orejas prominentes, de soplillo o en asa; así como otras malformaciones congénitas. La intervención persigue recrear una oreja normal y armónica con el óvalo facial.",
          "items": [
            "La otoplastia es una operación encaminada a mejorar la forma y posición de las orejas. Mediante esta técnica se resuelven problemas estéticos de las orejas separadas, también denominadas orejas prominentes, de soplillo o en asa; así como otras malformaciones congénitas. La intervención persigue recrear una oreja normal y armónica con el óvalo facial."
          ]
        },
        {
          "heading": "Indicación",
          "body": "La otoplastia está indicada en pacientes que tienen el pabellón auricular prominente y sobresale excesivamente del óvalo facial. Está especialmente recomendada en niños (a partir de los 4-6 años) y adolescentes para evitar los problemas sociales relacionados con este defecto, pero puede realizarse a cualquier edad.",
          "items": [
            "La otoplastia está indicada en pacientes que tienen el pabellón auricular prominente y sobresale excesivamente del óvalo facial. Está especialmente recomendada en niños (a partir de los 4-6 años) y adolescentes para evitar los problemas sociales relacionados con este defecto, pero puede realizarse a cualquier edad."
          ]
        },
        {
          "heading": "Primera Consulta",
          "body": "En la primera consulta realizaremos una historia clínica completa del paciente, así como una detallada exploración de las orejas. En función de esta exploración, le explicaremos la opción quirúrgica que mejor se adapte a su caso particular. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta informativa y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta realizaremos una historia clínica completa del paciente, así como una detallada exploración de las orejas. En función de esta exploración, le explicaremos la opción quirúrgica que mejor se adapte a su caso particular. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.",
            "Acude a la primera consulta informativa y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La otoplastia se realiza de forma ambulatoria bajo anestesia local y sedación. La cirugía dura 1 hora aproximadamente. Se han descrito numerosas técnicas para la corrección de la forma y posición de las orejas. Lo más habitual es acceder a través de una incisión elíptica localizada detrás de la oreja, que por tanto no deja cicatrices visibles. Una vez eliminado el exceso de piel de detrás de la oreja se remodela el cartílago auricular para recrear los pliegues ausentes, lo que permite aproximar la oreja a la cabeza.",
          "items": [
            "La otoplastia se realiza de forma ambulatoria bajo anestesia local y sedación. La cirugía dura 1 hora aproximadamente. Se han descrito numerosas técnicas para la corrección de la forma y posición de las orejas. Lo más habitual es acceder a través de una incisión elíptica localizada detrás de la oreja, que por tanto no deja cicatrices visibles. Una vez eliminado el exceso de piel de detrás de la oreja se remodela el cartílago auricular para recrear los pliegues ausentes, lo que permite aproximar la oreja a la cabeza."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "Tras la intervención se coloca un vendaje ligero que es necesario llevar las primeras 48 horas. Tras la retirada del vendaje el paciente deberá llevar una cinta elástica de forma permanente durante la primera semana postoperatoria. Después de esta primera semana solo indicamos la cinta elástica por la noche para evitar la mala posición de las orejas al dormir. La otoplastia es una intervención muy efectiva con unos resultados muy satisfactorios para el paciente.",
          "items": [
            "Tras la intervención se coloca un vendaje ligero que es necesario llevar las primeras 48 horas. Tras la retirada del vendaje el paciente deberá llevar una cinta elástica de forma permanente durante la primera semana postoperatoria. Después de esta primera semana solo indicamos la cinta elástica por la noche para evitar la mala posición de las orejas al dormir. La otoplastia es una intervención muy efectiva con unos resultados muy satisfactorios para el paciente."
          ]
        }
      ],
      "blocks": [
        "Otoplastia\nLa otoplastia es una operación encaminada a mejorar la forma y posición de las orejas. Mediante esta técnica se resuelven problemas estéticos de las orejas separadas, también denominadas orejas prominentes, de soplillo o en asa; así como otras malformaciones congénitas. La intervención persigue recrear una oreja normal y armónica con el óvalo facial.",
        "Indicación\nLa otoplastia está indicada en pacientes que tienen el pabellón auricular prominente y sobresale excesivamente del óvalo facial. Está especialmente recomendada en niños (a partir de los 4-6 años) y adolescentes para evitar los problemas sociales relacionados con este defecto, pero puede realizarse a cualquier edad.",
        "Primera Consulta\nEn la primera consulta realizaremos una historia clínica completa del paciente, así como una detallada exploración de las orejas. En función de esta exploración, le explicaremos la opción quirúrgica que mejor se adapte a su caso particular. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta informativa y consúltanos sin compromiso.",
        "Operación\nLa otoplastia se realiza de forma ambulatoria bajo anestesia local y sedación. La cirugía dura 1 hora aproximadamente. Se han descrito numerosas técnicas para la corrección de la forma y posición de las orejas. Lo más habitual es acceder a través de una incisión elíptica localizada detrás de la oreja, que por tanto no deja cicatrices visibles. Una vez eliminado el exceso de piel de detrás de la oreja se remodela el cartílago auricular para recrear los pliegues ausentes, lo que permite aproximar la oreja a la cabeza.",
        "Postoperatorio\nTras la intervención se coloca un vendaje ligero que es necesario llevar las primeras 48 horas. Tras la retirada del vendaje el paciente deberá llevar una cinta elástica de forma permanente durante la primera semana postoperatoria. Después de esta primera semana solo indicamos la cinta elástica por la noche para evitar la mala posición de las orejas al dormir. La otoplastia es una intervención muy efectiva con unos resultados muy satisfactorios para el paciente."
      ],
      "images": [
        "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-1272a0b094.webp",
        "/assets/squarespace/eedb3858-ede3beae9e.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-0f2f90ee53.webp",
        "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-e3c4e7ddd5.webp",
        "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-e2d12d49f3.webp",
        "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-6a68abed10.webp",
        "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-3c8248703e.webp",
        "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-fbfb6d559c.webp"
      ]
    },
    {
      "route": "/asimetria-de-pecho-madrid",
      "slug": "asimetria-de-pecho-madrid",
      "url": "https://www.doctoramasa.com/asimetria-de-pecho-madrid",
      "title": "Asimetría de pecho",
      "collectionTitle": "Asimetría de pecho",
      "description": "Cirugía plástica y estética en Madrid · Doctora Masa · Cirugía de mama ✓&nbsp;· Simetría y Naturalidad ✓&nbsp;· Máxima calidad y seguridad ✓ &nbsp;☎ Pida su 1ª Cita Gratuita",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Asimetría de pecho"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera Consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Asimetría de pecho",
          "body": "Pequeñas diferencias entre ambos senos existen en la mayoría de las mujeres. No obstante, si la diferencia entre ambos pechos es notable, nos hallamos ante un problema estético importante que puede limitar ciertos aspectos de la vida de la paciente. En estos casos hablamos de asimetría mamaria. Esta diferencia puede estar relacionada con el volumen, la base de implantación de las mamas en el tórax, la posición y tamaño de las areolas, o una combinación de varias de estas alteraciones.",
          "items": [
            "Pequeñas diferencias entre ambos senos existen en la mayoría de las mujeres. No obstante, si la diferencia entre ambos pechos es notable, nos hallamos ante un problema estético importante que puede limitar ciertos aspectos de la vida de la paciente. En estos casos hablamos de asimetría mamaria. Esta diferencia puede estar relacionada con el volumen, la base de implantación de las mamas en el tórax, la posición y tamaño de las areolas, o una combinación de varias de estas alteraciones."
          ]
        },
        {
          "heading": "Indicación",
          "body": "El tratamiento está indicado en aquellas pacientes que deseen mejorar el aspecto estético de su pecho debido a una desigualdad notable entre ambas mamas. Es especialmente recomendable en aquellas mujeres en las que la asimetría de los senos les afecta psicológicamente. En estos casos la intervención les ayudará a incrementar los sentimientos positivos hacia sí mismas, adquiriendo mayor confianza y seguridad en su propia imagen.",
          "items": [
            "El tratamiento está indicado en aquellas pacientes que deseen mejorar el aspecto estético de su pecho debido a una desigualdad notable entre ambas mamas. Es especialmente recomendable en aquellas mujeres en las que la asimetría de los senos les afecta psicológicamente. En estos casos la intervención les ayudará a incrementar los sentimientos positivos hacia sí mismas, adquiriendo mayor confianza y seguridad en su propia imagen."
          ]
        },
        {
          "heading": "Primera Consulta",
          "body": "Durante la primera visita valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preocupaciones. Tras una breve historia clínica, procedemos a la exploración física que incluye la valoración de la forma del tórax, la forma y tamaño de las mamas y la posición y aspecto de las areolas. Describiremos las asimetrías presentes y realizaremos un planteamiento terapéutico.\nLas intervenciones para corregir una asimetría requieren un estudio pormenorizado de la paciente y una planificación totalmente individualizada. Durante la primer consulta estudiaremos tu caso en particular, te explicaremos las técnicas quirúrgicas que mejor se adapten a tu situación y valoraremos todas las posibilidades.\nAcude a la primera consulta informativa y consúltanos sin compromiso.",
          "items": [
            "Durante la primera visita valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preocupaciones. Tras una breve historia clínica, procedemos a la exploración física que incluye la valoración de la forma del tórax, la forma y tamaño de las mamas y la posición y aspecto de las areolas. Describiremos las asimetrías presentes y realizaremos un planteamiento terapéutico.",
            "Las intervenciones para corregir una asimetría requieren un estudio pormenorizado de la paciente y una planificación totalmente individualizada. Durante la primer consulta estudiaremos tu caso en particular, te explicaremos las técnicas quirúrgicas que mejor se adapten a tu situación y valoraremos todas las posibilidades.",
            "Acude a la primera consulta informativa y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La operción se realiza en un quirófano bajo anestesia general, es decir la paciente permanece dormida y monitorizada durante toda la operación. El tratamiento quirúrgico de la asimetría mamaria implica la combinación de diversas técnicas en función de la exploración mamaria previa. En la mayoría de los casos aplicaremos distintos tratamientos en cada mama para conseguir un resultado satisfactorio. De este modo, la cirugía puede consistir en aumento, elevación o reducción de los senos, así como lipotransferencia o la combinación de varias de estas técnicas.\nLa cirugía tiene una duración aproximada de una a dos horas y en todo momento tus familiares permanecerán informados. Después de la cirugía utilizamos un vendaje compresivo que será sustituido por un sujetador anatómico a las 24 horas.",
          "items": [
            "La operción se realiza en un quirófano bajo anestesia general, es decir la paciente permanece dormida y monitorizada durante toda la operación. El tratamiento quirúrgico de la asimetría mamaria implica la combinación de diversas técnicas en función de la exploración mamaria previa. En la mayoría de los casos aplicaremos distintos tratamientos en cada mama para conseguir un resultado satisfactorio. De este modo, la cirugía puede consistir en aumento, elevación o reducción de los senos, así como lipotransferencia o la combinación de varias de estas técnicas.",
            "La cirugía tiene una duración aproximada de una a dos horas y en todo momento tus familiares permanecerán informados. Después de la cirugía utilizamos un vendaje compresivo que será sustituido por un sujetador anatómico a las 24 horas."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "Tras la opercación, es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. A las 24 horas de la intervención sustituiremos el vendaje postoperatorio por un sujetador anatómico. Recomendamos usar este sujetador día y noche durante unas 3-4 semanas. A partir del 4º-5º día te puedes reincorporar a tu vida habitual, solo evitando hacer grandes esfuerzos con los brazos durante las 2-3 semanas siguientes. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de tus mamas.",
          "items": [
            "Tras la opercación, es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. A las 24 horas de la intervención sustituiremos el vendaje postoperatorio por un sujetador anatómico. Recomendamos usar este sujetador día y noche durante unas 3-4 semanas. A partir del 4º-5º día te puedes reincorporar a tu vida habitual, solo evitando hacer grandes esfuerzos con los brazos durante las 2-3 semanas siguientes. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de tus mamas."
          ]
        }
      ],
      "blocks": [
        "Asimetría de pecho\nPequeñas diferencias entre ambos senos existen en la mayoría de las mujeres. No obstante, si la diferencia entre ambos pechos es notable, nos hallamos ante un problema estético importante que puede limitar ciertos aspectos de la vida de la paciente. En estos casos hablamos de asimetría mamaria. Esta diferencia puede estar relacionada con el volumen, la base de implantación de las mamas en el tórax, la posición y tamaño de las areolas, o una combinación de varias de estas alteraciones.",
        "Indicación\nEl tratamiento está indicado en aquellas pacientes que deseen mejorar el aspecto estético de su pecho debido a una desigualdad notable entre ambas mamas. Es especialmente recomendable en aquellas mujeres en las que la asimetría de los senos les afecta psicológicamente. En estos casos la intervención les ayudará a incrementar los sentimientos positivos hacia sí mismas, adquiriendo mayor confianza y seguridad en su propia imagen.",
        "Primera Consulta\nDurante la primera visita valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preocupaciones. Tras una breve historia clínica, procedemos a la exploración física que incluye la valoración de la forma del tórax, la forma y tamaño de las mamas y la posición y aspecto de las areolas. Describiremos las asimetrías presentes y realizaremos un planteamiento terapéutico.\nLas intervenciones para corregir una asimetría requieren un estudio pormenorizado de la paciente y una planificación totalmente individualizada. Durante la primer consulta estudiaremos tu caso en particular, te explicaremos las técnicas quirúrgicas que mejor se adapten a tu situación y valoraremos todas las posibilidades.\nAcude a la primera consulta informativa y consúltanos sin compromiso.",
        "Operación\nLa operción se realiza en un quirófano bajo anestesia general, es decir la paciente permanece dormida y monitorizada durante toda la operación. El tratamiento quirúrgico de la asimetría mamaria implica la combinación de diversas técnicas en función de la exploración mamaria previa. En la mayoría de los casos aplicaremos distintos tratamientos en cada mama para conseguir un resultado satisfactorio. De este modo, la cirugía puede consistir en aumento, elevación o reducción de los senos, así como lipotransferencia o la combinación de varias de estas técnicas.\nLa cirugía tiene una duración aproximada de una a dos horas y en todo momento tus familiares permanecerán informados. Después de la cirugía utilizamos un vendaje compresivo que será sustituido por un sujetador anatómico a las 24 horas.",
        "Postoperatorio\nTras la opercación, es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. A las 24 horas de la intervención sustituiremos el vendaje postoperatorio por un sujetador anatómico. Recomendamos usar este sujetador día y noche durante unas 3-4 semanas. A partir del 4º-5º día te puedes reincorporar a tu vida habitual, solo evitando hacer grandes esfuerzos con los brazos durante las 2-3 semanas siguientes. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de tus mamas."
      ],
      "images": [
        "/assets/squarespace/eedb3878-6a637abba0.jpg",
        "/assets/squarespace/image-asset-626297d419.jpg",
        "/assets/squarespace/eedb3738-d85f50e9e3.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/image-asset-09c2e5cb3f.jpg",
        "/assets/squarespace/image-asset-1ff8244bed.jpg",
        "/assets/squarespace/image-asset-46a77e2bb7.jpg",
        "/assets/squarespace/image-asset-863f21a8d7.jpg",
        "/assets/squarespace/image-asset-26820700f1.jpg"
      ]
    },
    {
      "route": "/blefaroplastia-madrid",
      "slug": "blefaroplastia-madrid",
      "url": "https://www.doctoramasa.com/blefaroplastia-madrid",
      "title": "Blefaroplastia",
      "collectionTitle": "Blefaroplastia",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Blefaroplastia"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera Consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Blefaroplastia",
          "body": "La blefaroplastia es una operación encaminada a mejorar el aspecto de la mirada. Mediante esta técnica se resuelven problemas estéticos como son el párpado caído y la presencia de bolsas en los párpados. La operación persigue rejuvenecer la mirada y eliminar el aspecto de cansancio típico del envejecimiento palpebral.",
          "items": [
            "La blefaroplastia es una operación encaminada a mejorar el aspecto de la mirada. Mediante esta técnica se resuelven problemas estéticos como son el párpado caído y la presencia de bolsas en los párpados. La operación persigue rejuvenecer la mirada y eliminar el aspecto de cansancio típico del envejecimiento palpebral."
          ]
        },
        {
          "heading": "Indicación",
          "body": "La blefaroplastia está indicada en pacientes que presentan signos de envejecimiento de la mirada o aspecto de cansancio. Esta operación elimina el párpado caído y las bolsas de los ojos. Tanto mujeres como hombres se pueden beneficiar de este tratamiento. EN función de las necesidades de cada paciente indicaremos una blefaroplastia superior (párpado superior), blefaroplastia inferior (párpado inferior) o completa (ambos párpados). La blefaroplastia puede realizarse a cualquier edad, aunque es más frecuente a partir de los 40-50 años.",
          "items": [
            "La blefaroplastia está indicada en pacientes que presentan signos de envejecimiento de la mirada o aspecto de cansancio. Esta operación elimina el párpado caído y las bolsas de los ojos. Tanto mujeres como hombres se pueden beneficiar de este tratamiento. EN función de las necesidades de cada paciente indicaremos una blefaroplastia superior (párpado superior), blefaroplastia inferior (párpado inferior) o completa (ambos párpados). La blefaroplastia puede realizarse a cualquier edad, aunque es más frecuente a partir de los 40-50 años."
          ]
        },
        {
          "heading": "Primera Consulta",
          "body": "En la primera consulta realizaremos una historia clínica completa del paciente, así como una detallada exploración de la expresión de su mirada y de los distintos componentes del envejecimiento palpebral. En función de esta exploración, le explicaremos la opción quirúrgica que mejor se adapte a su caso particular. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la cirugía si fuera necesario.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta realizaremos una historia clínica completa del paciente, así como una detallada exploración de la expresión de su mirada y de los distintos componentes del envejecimiento palpebral. En función de esta exploración, le explicaremos la opción quirúrgica que mejor se adapte a su caso particular. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la cirugía si fuera necesario.",
            "Acude a la primera consulta gratuita y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La blefaroplastia se realiza de forma ambulatoria bajo anestesia local y sedación. La cirugía dura 1 hora aproximadamente. En la cirugía de los párpados superiores la cirugía consiste fundamentalmente en la eliminación del exceso cutáneo y de las bolsas grasas a través de una incisión que quedará oculta en el pliegue cutáneo. En párpado inferior es habitual que el principal componente de las bolsas sea un exceso graso que se extirpa. En ocasiones será necesario también extirpar piel, siempre siendo más conservadores que en el párpado superior. por último, se colocan unas pequeñas tiritas cubriendo los puntos que se mantendrán hasta la retirada de puntos en consulta.",
          "items": [
            "La blefaroplastia se realiza de forma ambulatoria bajo anestesia local y sedación. La cirugía dura 1 hora aproximadamente. En la cirugía de los párpados superiores la cirugía consiste fundamentalmente en la eliminación del exceso cutáneo y de las bolsas grasas a través de una incisión que quedará oculta en el pliegue cutáneo. En párpado inferior es habitual que el principal componente de las bolsas sea un exceso graso que se extirpa. En ocasiones será necesario también extirpar piel, siempre siendo más conservadores que en el párpado superior. por último, se colocan unas pequeñas tiritas cubriendo los puntos que se mantendrán hasta la retirada de puntos en consulta."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "Tras la cirugía, es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. El paciente podrá marcharse en el mismo día de la intervención en la mayoría de los casos. Es habitual tener la zona inflamada las primeras 48-72 horas. Retiraremos los puntos a la semana de la operación. Poco a poco la inflamación va cediendo y tras la retirada de puntos el paciente puede realizar una vida normal, incluso usar maquillaje.",
          "items": [
            "Tras la cirugía, es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. El paciente podrá marcharse en el mismo día de la intervención en la mayoría de los casos. Es habitual tener la zona inflamada las primeras 48-72 horas. Retiraremos los puntos a la semana de la operación. Poco a poco la inflamación va cediendo y tras la retirada de puntos el paciente puede realizar una vida normal, incluso usar maquillaje."
          ]
        }
      ],
      "blocks": [
        "Blefaroplastia\nLa blefaroplastia es una operación encaminada a mejorar el aspecto de la mirada. Mediante esta técnica se resuelven problemas estéticos como son el párpado caído y la presencia de bolsas en los párpados. La operación persigue rejuvenecer la mirada y eliminar el aspecto de cansancio típico del envejecimiento palpebral.",
        "Indicación\nLa blefaroplastia está indicada en pacientes que presentan signos de envejecimiento de la mirada o aspecto de cansancio. Esta operación elimina el párpado caído y las bolsas de los ojos. Tanto mujeres como hombres se pueden beneficiar de este tratamiento. EN función de las necesidades de cada paciente indicaremos una blefaroplastia superior (párpado superior), blefaroplastia inferior (párpado inferior) o completa (ambos párpados). La blefaroplastia puede realizarse a cualquier edad, aunque es más frecuente a partir de los 40-50 años.",
        "Primera Consulta\nEn la primera consulta realizaremos una historia clínica completa del paciente, así como una detallada exploración de la expresión de su mirada y de los distintos componentes del envejecimiento palpebral. En función de esta exploración, le explicaremos la opción quirúrgica que mejor se adapte a su caso particular. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la cirugía si fuera necesario.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
        "Operación\nLa blefaroplastia se realiza de forma ambulatoria bajo anestesia local y sedación. La cirugía dura 1 hora aproximadamente. En la cirugía de los párpados superiores la cirugía consiste fundamentalmente en la eliminación del exceso cutáneo y de las bolsas grasas a través de una incisión que quedará oculta en el pliegue cutáneo. En párpado inferior es habitual que el principal componente de las bolsas sea un exceso graso que se extirpa. En ocasiones será necesario también extirpar piel, siempre siendo más conservadores que en el párpado superior. por último, se colocan unas pequeñas tiritas cubriendo los puntos que se mantendrán hasta la retirada de puntos en consulta.",
        "Postoperatorio\nTras la cirugía, es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. El paciente podrá marcharse en el mismo día de la intervención en la mayoría de los casos. Es habitual tener la zona inflamada las primeras 48-72 horas. Retiraremos los puntos a la semana de la operación. Poco a poco la inflamación va cediendo y tras la retirada de puntos el paciente puede realizar una vida normal, incluso usar maquillaje."
      ],
      "images": [
        "/assets/squarespace/image-asset-85356642a0.jpg",
        "/assets/squarespace/img_0008-8c4a6d58ff.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/img_0008-b2929da7df.jpg",
        "/assets/squarespace/img_0008-7af5cdd7d7.jpg",
        "/assets/squarespace/img_0008-d314c18c90.jpg",
        "/assets/squarespace/img_0008-d5ece0f939.jpg",
        "/assets/squarespace/img_0008-cefb451f23.jpg",
        "/assets/squarespace/img_0008-0f8384fd2d.jpg"
      ]
    },
    {
      "route": "/liposuccion-madrid",
      "slug": "liposuccion-madrid",
      "url": "https://www.doctoramasa.com/liposuccion-madrid",
      "title": "Liposucción",
      "collectionTitle": "Liposucción",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Liposucción"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera Consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Liposucción",
          "body": "La liposucción es un procedimiento quirúrgico cuyo objetivo es eliminar los excesos de grasa localizada en un área anatómica concreta. Las zonas donde más frecuentemente se acumula la grasa son: caderas, muslos, cara interna de rodillas, abdomen y flancos. Esta técnica nos permite remodelar el cuerpo y por ese motivo también es conocida como lipoescultura.",
          "items": [
            "La liposucción es un procedimiento quirúrgico cuyo objetivo es eliminar los excesos de grasa localizada en un área anatómica concreta. Las zonas donde más frecuentemente se acumula la grasa son: caderas, muslos, cara interna de rodillas, abdomen y flancos. Esta técnica nos permite remodelar el cuerpo y por ese motivo también es conocida como lipoescultura."
          ]
        },
        {
          "heading": "Indicación",
          "body": "Es la intervención perfecta para aquellas mujeres que deseen eliminar esas zonas de grasa acumulada. En mujeres lo más habitual es encontrar excesos grasos abdominal, en las caderas, cara interna de muslos y rodillas. En cambio, los hombres tienen tendencia a acumular grasa en flancos y pecho. En nuestra experiencia, la liposucción especialmente eficaz en esa grasa localizada resistente al dietas y ejercicio.",
          "items": [
            "Es la intervención perfecta para aquellas mujeres que deseen eliminar esas zonas de grasa acumulada. En mujeres lo más habitual es encontrar excesos grasos abdominal, en las caderas, cara interna de muslos y rodillas. En cambio, los hombres tienen tendencia a acumular grasa en flancos y pecho. En nuestra experiencia, la liposucción especialmente eficaz en esa grasa localizada resistente al dietas y ejercicio."
          ]
        },
        {
          "heading": "Primera Consulta",
          "body": "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente las zonas que quiere mejorar y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de las zonas a tratar. De modo que, en función de la exploración, indicaremos liposucción abdominal, de piernas o de otras zonas. Al realizar una valoración y tratamiento integral de todas las zonas se conseguirá el efecto de lipoescultura o remodelación corporal. Por último, le explicaremos detenidamente en qué consiste la cirugía y le responderemos a todas sus dudas.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente las zonas que quiere mejorar y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de las zonas a tratar. De modo que, en función de la exploración, indicaremos liposucción abdominal, de piernas o de otras zonas. Al realizar una valoración y tratamiento integral de todas las zonas se conseguirá el efecto de lipoescultura o remodelación corporal. Por último, le explicaremos detenidamente en qué consiste la cirugía y le responderemos a todas sus dudas.",
            "Acude a la primera consulta gratuita y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La intervención se realiza en un quirófano bajo anestesia local con sedación, o anestesia general en función de la cantidad de zonas a tratar. El tratamiento se realiza a través de pequeñas incisiones de apenas 3 mm que apenas serán percibidas con el paso del tiempo. La intervención se realiza con la ayuda de unas cánulas finas y largas, que con movimientos de vaivén, despegan la grasa de la piel y la succionan. En ocasiones, la grasa extraída puede utilizarse a su vez para rellenar otras zonas del cuerpo utilizando la técnica de lipotransferencia o lipofilling.",
          "items": [
            "La intervención se realiza en un quirófano bajo anestesia local con sedación, o anestesia general en función de la cantidad de zonas a tratar. El tratamiento se realiza a través de pequeñas incisiones de apenas 3 mm que apenas serán percibidas con el paso del tiempo. La intervención se realiza con la ayuda de unas cánulas finas y largas, que con movimientos de vaivén, despegan la grasa de la piel y la succionan. En ocasiones, la grasa extraída puede utilizarse a su vez para rellenar otras zonas del cuerpo utilizando la técnica de lipotransferencia o lipofilling."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "Normalmente la liposucción se lleva a cabo de forma ambulatoria (no requiere un ingreso hospitalario) aunque si el volumen de grasa extraído es muy elevado puede requerir un ingreso de una noche. Después de la intervención tendrá que usar una faja o prenda elástica que deberá mantener día y noche durante 3 semanas. Es normal tener molestias, inflamación o incluso cardenales en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. A partir del día siguiente a la intervención día te puedes reincorporar a tu vida habitual, siendo incluso recomendable caminar y realizar ejercicio de forma moderada. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía.\nLos resultados de la liposucción son muy satisfactorios estéticamente. Conseguirás esa bonita figura que estas buscando.",
          "items": [
            "Normalmente la liposucción se lleva a cabo de forma ambulatoria (no requiere un ingreso hospitalario) aunque si el volumen de grasa extraído es muy elevado puede requerir un ingreso de una noche. Después de la intervención tendrá que usar una faja o prenda elástica que deberá mantener día y noche durante 3 semanas. Es normal tener molestias, inflamación o incluso cardenales en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. A partir del día siguiente a la intervención día te puedes reincorporar a tu vida habitual, siendo incluso recomendable caminar y realizar ejercicio de forma moderada. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía.",
            "Los resultados de la liposucción son muy satisfactorios estéticamente. Conseguirás esa bonita figura que estas buscando."
          ]
        }
      ],
      "blocks": [
        "Liposucción\nLa liposucción es un procedimiento quirúrgico cuyo objetivo es eliminar los excesos de grasa localizada en un área anatómica concreta. Las zonas donde más frecuentemente se acumula la grasa son: caderas, muslos, cara interna de rodillas, abdomen y flancos. Esta técnica nos permite remodelar el cuerpo y por ese motivo también es conocida como lipoescultura.",
        "Indicación\nEs la intervención perfecta para aquellas mujeres que deseen eliminar esas zonas de grasa acumulada. En mujeres lo más habitual es encontrar excesos grasos abdominal, en las caderas, cara interna de muslos y rodillas. En cambio, los hombres tienen tendencia a acumular grasa en flancos y pecho. En nuestra experiencia, la liposucción especialmente eficaz en esa grasa localizada resistente al dietas y ejercicio.",
        "Primera Consulta\nEn la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente las zonas que quiere mejorar y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de las zonas a tratar. De modo que, en función de la exploración, indicaremos liposucción abdominal, de piernas o de otras zonas. Al realizar una valoración y tratamiento integral de todas las zonas se conseguirá el efecto de lipoescultura o remodelación corporal. Por último, le explicaremos detenidamente en qué consiste la cirugía y le responderemos a todas sus dudas.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
        "Operación\nLa intervención se realiza en un quirófano bajo anestesia local con sedación, o anestesia general en función de la cantidad de zonas a tratar. El tratamiento se realiza a través de pequeñas incisiones de apenas 3 mm que apenas serán percibidas con el paso del tiempo. La intervención se realiza con la ayuda de unas cánulas finas y largas, que con movimientos de vaivén, despegan la grasa de la piel y la succionan. En ocasiones, la grasa extraída puede utilizarse a su vez para rellenar otras zonas del cuerpo utilizando la técnica de lipotransferencia o lipofilling.",
        "Postoperatorio\nNormalmente la liposucción se lleva a cabo de forma ambulatoria (no requiere un ingreso hospitalario) aunque si el volumen de grasa extraído es muy elevado puede requerir un ingreso de una noche. Después de la intervención tendrá que usar una faja o prenda elástica que deberá mantener día y noche durante 3 semanas. Es normal tener molestias, inflamación o incluso cardenales en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. A partir del día siguiente a la intervención día te puedes reincorporar a tu vida habitual, siendo incluso recomendable caminar y realizar ejercicio de forma moderada. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía.\nLos resultados de la liposucción son muy satisfactorios estéticamente. Conseguirás esa bonita figura que estas buscando."
      ],
      "images": [
        "/assets/squarespace/eedb3738-4092e2ef60.jpg",
        "/assets/squarespace/eedb3878-6a637abba0.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/eedb3738-c8381ceaf1.jpg",
        "/assets/squarespace/eedb3738-1b051fd165.jpg",
        "/assets/squarespace/eedb3738-6bdfdd7880.jpg",
        "/assets/squarespace/eedb3738-19583213bf.jpg",
        "/assets/squarespace/eedb3738-de4f416809.jpg",
        "/assets/squarespace/eedb3738-3d33c8abf0.jpg"
      ]
    },
    {
      "route": "/abdominoplastia-madrid",
      "slug": "abdominoplastia-madrid",
      "url": "https://www.doctoramasa.com/abdominoplastia-madrid",
      "title": "Abdominoplastia",
      "collectionTitle": "Abdominoplastia",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Abdominoplastia"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera Consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Abdominoplastia",
          "body": "La abdominoplastia es una operación cuyo objetivo es eliminar el exceso de piel y grasa de la parte media y baja del abdomen. También se trata la pared abdominal para tratar la flacidez o separación de la musculatura. De esta forma se remodela el vientre y la cintura. En aquellos casos donde hay además un componente graso, esta técnica se puede combinar con la liposucción o lipoescultura.",
          "items": [
            "La abdominoplastia es una operación cuyo objetivo es eliminar el exceso de piel y grasa de la parte media y baja del abdomen. También se trata la pared abdominal para tratar la flacidez o separación de la musculatura. De esta forma se remodela el vientre y la cintura. En aquellos casos donde hay además un componente graso, esta técnica se puede combinar con la liposucción o lipoescultura."
          ]
        },
        {
          "heading": "Indicación",
          "body": "Esta técnica está indicada tanto en hombres como en mujeres que después una pérdida de peso notable o por efecto de la edad presentan flacidez en su abdomen, provocando la caída del mismo sobre la región púbica. La abdominoplastia tiene un beneficio especialmente evidente en mujeres que han tenido varios embarazos y en personas que padecían de obesidad mórbida tras una pérdida masiva de peso. Por otra parte, también existe la técnica de la mini-abdominoplastia para aquellos casos cuyo exceso de piel es moderado se concentra por debajo del ombligo.",
          "items": [
            "Esta técnica está indicada tanto en hombres como en mujeres que después una pérdida de peso notable o por efecto de la edad presentan flacidez en su abdomen, provocando la caída del mismo sobre la región púbica. La abdominoplastia tiene un beneficio especialmente evidente en mujeres que han tenido varios embarazos y en personas que padecían de obesidad mórbida tras una pérdida masiva de peso. Por otra parte, también existe la técnica de la mini-abdominoplastia para aquellos casos cuyo exceso de piel es moderado se concentra por debajo del ombligo."
          ]
        },
        {
          "heading": "Primera Consulta",
          "body": "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que el paciente comente sus preocupaciones y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de la zona a tratar. Finalizamos la consulta explicando las posibilidades quirúrgicas que se mejor se adaptan a las necesidades de cada paciente. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que el paciente comente sus preocupaciones y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de la zona a tratar. Finalizamos la consulta explicando las posibilidades quirúrgicas que se mejor se adaptan a las necesidades de cada paciente. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.",
            "Acude a la primera consulta gratuita y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La operación se realiza en un quirófano bajo anestesia general y tiene una duración aproximada de 2 a 3 horas. Para retirar toda la piel y grasa en exceso a nivel infraumbilical realizamos una incisión o corte horizontal por encima del pubis. A través de ella la piel es liberada y tensada, y la pared muscular restaurada. La cicatriz quedará a nivel suprapúbico de forma que es fácilmente escondida por la ropa interior o bikini. En ocasiones, la abdominoplastia se combinará con liposucción.",
          "items": [
            "La operación se realiza en un quirófano bajo anestesia general y tiene una duración aproximada de 2 a 3 horas. Para retirar toda la piel y grasa en exceso a nivel infraumbilical realizamos una incisión o corte horizontal por encima del pubis. A través de ella la piel es liberada y tensada, y la pared muscular restaurada. La cicatriz quedará a nivel suprapúbico de forma que es fácilmente escondida por la ropa interior o bikini. En ocasiones, la abdominoplastia se combinará con liposucción."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "La operación requiere ingreso hospitalario de una noche para mayor comodidad del paciente en las primeras horas postoperatorias. Después de la operación tendrá que usar una faja o prenda elástica que deberá mantener día y noche durante 3 semanas. Es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Durante los 2 o 3 días postoperatorios recomendaremos al paciente que camine con el tronco ligeramente inclinado. A partir del 4º-5º día se puede reincorporar a tu vida habitual, solo evitando hacer grandes esfuerzos con los brazos durante las 2-3 semanas siguientes. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía.\nLos resultados de la abdominoplastia son muy satisfactorios, consiguiendo un abdomen plano y estilizado.",
          "items": [
            "La operación requiere ingreso hospitalario de una noche para mayor comodidad del paciente en las primeras horas postoperatorias. Después de la operación tendrá que usar una faja o prenda elástica que deberá mantener día y noche durante 3 semanas. Es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Durante los 2 o 3 días postoperatorios recomendaremos al paciente que camine con el tronco ligeramente inclinado. A partir del 4º-5º día se puede reincorporar a tu vida habitual, solo evitando hacer grandes esfuerzos con los brazos durante las 2-3 semanas siguientes. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía.",
            "Los resultados de la abdominoplastia son muy satisfactorios, consiguiendo un abdomen plano y estilizado."
          ]
        }
      ],
      "blocks": [
        "Abdominoplastia\nLa abdominoplastia es una operación cuyo objetivo es eliminar el exceso de piel y grasa de la parte media y baja del abdomen. También se trata la pared abdominal para tratar la flacidez o separación de la musculatura. De esta forma se remodela el vientre y la cintura. En aquellos casos donde hay además un componente graso, esta técnica se puede combinar con la liposucción o lipoescultura.",
        "Indicación\nEsta técnica está indicada tanto en hombres como en mujeres que después una pérdida de peso notable o por efecto de la edad presentan flacidez en su abdomen, provocando la caída del mismo sobre la región púbica. La abdominoplastia tiene un beneficio especialmente evidente en mujeres que han tenido varios embarazos y en personas que padecían de obesidad mórbida tras una pérdida masiva de peso. Por otra parte, también existe la técnica de la mini-abdominoplastia para aquellos casos cuyo exceso de piel es moderado se concentra por debajo del ombligo.",
        "Primera Consulta\nEn la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que el paciente comente sus preocupaciones y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de la zona a tratar. Finalizamos la consulta explicando las posibilidades quirúrgicas que se mejor se adaptan a las necesidades de cada paciente. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
        "Operación\nLa operación se realiza en un quirófano bajo anestesia general y tiene una duración aproximada de 2 a 3 horas. Para retirar toda la piel y grasa en exceso a nivel infraumbilical realizamos una incisión o corte horizontal por encima del pubis. A través de ella la piel es liberada y tensada, y la pared muscular restaurada. La cicatriz quedará a nivel suprapúbico de forma que es fácilmente escondida por la ropa interior o bikini. En ocasiones, la abdominoplastia se combinará con liposucción.",
        "Postoperatorio\nLa operación requiere ingreso hospitalario de una noche para mayor comodidad del paciente en las primeras horas postoperatorias. Después de la operación tendrá que usar una faja o prenda elástica que deberá mantener día y noche durante 3 semanas. Es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Durante los 2 o 3 días postoperatorios recomendaremos al paciente que camine con el tronco ligeramente inclinado. A partir del 4º-5º día se puede reincorporar a tu vida habitual, solo evitando hacer grandes esfuerzos con los brazos durante las 2-3 semanas siguientes. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía.\nLos resultados de la abdominoplastia son muy satisfactorios, consiguiendo un abdomen plano y estilizado."
      ],
      "images": [
        "/assets/squarespace/img_0008-d3cdbe59f6.jpg",
        "/assets/squarespace/eedb3878-6a637abba0.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/img_0008-abf34d43f7.jpg",
        "/assets/squarespace/img_0008-9d35ef70eb.jpg",
        "/assets/squarespace/img_0008-afad8a0fff.jpg",
        "/assets/squarespace/img_0008-fda9922599.jpg",
        "/assets/squarespace/img_0008-b19335ee26.jpg",
        "/assets/squarespace/img_0008-6273fe081c.jpg"
      ]
    },
    {
      "route": "/cirugia-reconstructiva-madrid",
      "slug": "cirugia-reconstructiva-madrid",
      "url": "https://www.doctoramasa.com/cirugia-reconstructiva-madrid",
      "title": "Cirugía reconstructiva",
      "collectionTitle": "Cirugía reconstructiva",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h3",
          "text": "Reconstrucción Mama"
        },
        {
          "level": "h3",
          "text": "Oncología cutánea"
        },
        {
          "level": "h3",
          "text": "Quemaduras"
        },
        {
          "level": "h3",
          "text": "Pérdida de sustancia"
        }
      ],
      "sections": [
        {
          "heading": "Reconstrucción Mama",
          "body": "",
          "items": []
        },
        {
          "heading": "Oncología cutánea",
          "body": "",
          "items": []
        },
        {
          "heading": "Quemaduras",
          "body": "",
          "items": []
        },
        {
          "heading": "Pérdida de sustancia",
          "body": "",
          "items": []
        }
      ],
      "blocks": [
        "Reconstrucción Mama",
        "Oncología cutánea",
        "Quemaduras",
        "Pérdida de sustancia"
      ],
      "images": [
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png",
        "/assets/squarespace/videoconsulta-1-e78b92b59a.png",
        "/assets/squarespace/videoconsulta-1-6679593101.png",
        "/assets/squarespace/videoconsulta-1-3f2ea7e36b.png"
      ]
    },
    {
      "route": "/lifting-de-muslos",
      "slug": "lifting-de-muslos",
      "url": "https://www.doctoramasa.com/lifting-de-muslos",
      "title": "Lifting de muslos",
      "collectionTitle": "Lifting de muslos",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Lifting de muslos"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera Consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Lifting de muslos",
          "body": "El lifting de muslos es una operación dirigida a cambiar la forma y mejorar el aspecto de los muslos, en especial la cara interna de los mismos. Esta técnica nos permite mejorar notablemente el contorno corporal, realizar una tracción de la piel de esta zona, consiguiendo la elevación del tejido descolgado y el efecto de una piel más tersa a nivel de muslos.",
          "items": [
            "El lifting de muslos es una operación dirigida a cambiar la forma y mejorar el aspecto de los muslos, en especial la cara interna de los mismos. Esta técnica nos permite mejorar notablemente el contorno corporal, realizar una tracción de la piel de esta zona, consiguiendo la elevación del tejido descolgado y el efecto de una piel más tersa a nivel de muslos."
          ]
        },
        {
          "heading": "Indicación",
          "body": "Esta cirugía está indicada en aquellas personas que deseen mejorar su contorno corporal. Se beneficiarán especialmente de esta técnica las pacientes que presenten flacidez cutánea o descolgamiento a nivel de muslos. El origen de esta flacidez es con frecuencia consecuencia de una importante pérdida de peso. En ocasiones, el lifting de muslos se puede combinar con técnicas de liposucción o lipoescultura para una mejoría global del contorno corporal.",
          "items": [
            "Esta cirugía está indicada en aquellas personas que deseen mejorar su contorno corporal. Se beneficiarán especialmente de esta técnica las pacientes que presenten flacidez cutánea o descolgamiento a nivel de muslos. El origen de esta flacidez es con frecuencia consecuencia de una importante pérdida de peso. En ocasiones, el lifting de muslos se puede combinar con técnicas de liposucción o lipoescultura para una mejoría global del contorno corporal."
          ]
        },
        {
          "heading": "Primera Consulta",
          "body": "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente las zonas que quiere mejorar y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de las zonas a tratar. Por último, le explicaremos detenidamente en qué consiste la cirugía y le responderemos a todas sus dudas.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente las zonas que quiere mejorar y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de las zonas a tratar. Por último, le explicaremos detenidamente en qué consiste la cirugía y le responderemos a todas sus dudas.",
            "Acude a la primera consulta gratuita y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La intervención se realiza en un quirófano bajo anestesia general, es decir, permanecerá dormido durante toda la intervención y tiene una duración aproximada de 1 hora y media. El abordaje quirúrgico se realiza a nivel de la parte superior e interna del muslo, de modo que las cicatrices quedarán alojadas en la ingle. El estiramiento de la parte interna de los muslos consiste en eliminar el exceso de piel y grasa de la cara interna de los muslos. La piel se estira \"hacia arriba\", anclando las estructuras a los planos profundos para que tengan fuerza de sujeción en el futuro y se mantenga tersa y lisa.",
          "items": [
            "La intervención se realiza en un quirófano bajo anestesia general, es decir, permanecerá dormido durante toda la intervención y tiene una duración aproximada de 1 hora y media. El abordaje quirúrgico se realiza a nivel de la parte superior e interna del muslo, de modo que las cicatrices quedarán alojadas en la ingle. El estiramiento de la parte interna de los muslos consiste en eliminar el exceso de piel y grasa de la cara interna de los muslos. La piel se estira \"hacia arriba\", anclando las estructuras a los planos profundos para que tengan fuerza de sujeción en el futuro y se mantenga tersa y lisa."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "La operación requiere ingreso hospitalario de una noche para mayor comodidad del paciente en las primeras horas postoperatorias. Después de la intervención tendrá que usar una faja o prenda elástica que deberá mantener día y noche durante 3 semanas. Es normal tener molestias, inflamación o incluso cardenales en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Después de la cirugía día debes tener un reposo relativo durante al menos una semana. Posteriormente, te puedes reincorporar a tu vida habitual, solo evitando realizar ejercicio intenso durante al menos 3 semanas. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía.",
          "items": [
            "La operación requiere ingreso hospitalario de una noche para mayor comodidad del paciente en las primeras horas postoperatorias. Después de la intervención tendrá que usar una faja o prenda elástica que deberá mantener día y noche durante 3 semanas. Es normal tener molestias, inflamación o incluso cardenales en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Después de la cirugía día debes tener un reposo relativo durante al menos una semana. Posteriormente, te puedes reincorporar a tu vida habitual, solo evitando realizar ejercicio intenso durante al menos 3 semanas. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía."
          ]
        }
      ],
      "blocks": [
        "Lifting de muslos\nEl lifting de muslos es una operación dirigida a cambiar la forma y mejorar el aspecto de los muslos, en especial la cara interna de los mismos. Esta técnica nos permite mejorar notablemente el contorno corporal, realizar una tracción de la piel de esta zona, consiguiendo la elevación del tejido descolgado y el efecto de una piel más tersa a nivel de muslos.",
        "Indicación\nEsta cirugía está indicada en aquellas personas que deseen mejorar su contorno corporal. Se beneficiarán especialmente de esta técnica las pacientes que presenten flacidez cutánea o descolgamiento a nivel de muslos. El origen de esta flacidez es con frecuencia consecuencia de una importante pérdida de peso. En ocasiones, el lifting de muslos se puede combinar con técnicas de liposucción o lipoescultura para una mejoría global del contorno corporal.",
        "Primera Consulta\nEn la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente las zonas que quiere mejorar y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de las zonas a tratar. Por último, le explicaremos detenidamente en qué consiste la cirugía y le responderemos a todas sus dudas.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
        "Operación\nLa intervención se realiza en un quirófano bajo anestesia general, es decir, permanecerá dormido durante toda la intervención y tiene una duración aproximada de 1 hora y media. El abordaje quirúrgico se realiza a nivel de la parte superior e interna del muslo, de modo que las cicatrices quedarán alojadas en la ingle. El estiramiento de la parte interna de los muslos consiste en eliminar el exceso de piel y grasa de la cara interna de los muslos. La piel se estira \"hacia arriba\", anclando las estructuras a los planos profundos para que tengan fuerza de sujeción en el futuro y se mantenga tersa y lisa.",
        "Postoperatorio\nLa operación requiere ingreso hospitalario de una noche para mayor comodidad del paciente en las primeras horas postoperatorias. Después de la intervención tendrá que usar una faja o prenda elástica que deberá mantener día y noche durante 3 semanas. Es normal tener molestias, inflamación o incluso cardenales en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Después de la cirugía día debes tener un reposo relativo durante al menos una semana. Posteriormente, te puedes reincorporar a tu vida habitual, solo evitando realizar ejercicio intenso durante al menos 3 semanas. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía."
      ],
      "images": [
        "/assets/squarespace/eedb3878-6a637abba0.jpg",
        "/assets/squarespace/eedb3738-442f846f52.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/eedb3738-0a4138e82b.jpg",
        "/assets/squarespace/eedb3738-e984343dfe.jpg",
        "/assets/squarespace/eedb3738-b106f43811.jpg",
        "/assets/squarespace/eedb3738-ed87b19f2f.jpg",
        "/assets/squarespace/eedb3738-c3f3169de8.jpg",
        "/assets/squarespace/eedb3738-eca7124026.jpg"
      ]
    },
    {
      "route": "/rinoplastia-madrid",
      "slug": "rinoplastia-madrid",
      "url": "https://www.doctoramasa.com/rinoplastia-madrid",
      "title": "Rinoplastia",
      "collectionTitle": "Rinoplastia",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Rinoplastia"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera Consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Rinoplastia",
          "body": "La rinoplastia es una cirugía destinada a modificar la estructura de la nariz, adaptándola a la cara, para que el conjunto se muestre más armónico y, por lo tanto, más estético. Además, con esta intervención también podemos corregir defectos congénitos o adquiridos por una accidente o enfermedad.",
          "items": [
            "La rinoplastia es una cirugía destinada a modificar la estructura de la nariz, adaptándola a la cara, para que el conjunto se muestre más armónico y, por lo tanto, más estético. Además, con esta intervención también podemos corregir defectos congénitos o adquiridos por una accidente o enfermedad."
          ]
        },
        {
          "heading": "Indicación",
          "body": "Esta operación está indicada en aquellas personas que deseen corregir aquellos aspectos que afean la nariz, bien porque la hacen desproporcionada o bien porque no están en armonía con el resto de la cara. Tanto mujeres como hombres se pueden beneficiar de este tratamiento.",
          "items": [
            "Esta operación está indicada en aquellas personas que deseen corregir aquellos aspectos que afean la nariz, bien porque la hacen desproporcionada o bien porque no están en armonía con el resto de la cara. Tanto mujeres como hombres se pueden beneficiar de este tratamiento."
          ]
        },
        {
          "heading": "Primera Consulta",
          "body": "En la primera consulta realizaremos una historia clínica completa del paciente, así como una detallada exploración de la nariz, tanto a nivel funcional como estético. En función de esta exploración, le explicaremos la opción quirúrgica que mejor se adapte a su caso particular. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta realizaremos una historia clínica completa del paciente, así como una detallada exploración de la nariz, tanto a nivel funcional como estético. En función de esta exploración, le explicaremos la opción quirúrgica que mejor se adapte a su caso particular. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.",
            "Acude a la primera consulta gratuita y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La operación se realiza en un quirófano bajo anestesia general (el paciente permanecerá dormido durante toda la cirugía) y tiene una duración aproximada de 1 a 2 horas. Existen fundamentalmente dos tipos de abordajes para esta cirugía, la rinoplastia cerrada y la rinoplastia abierta. La primera y más común es aquella que se realiza a través de incisiones por dentro de la nariz, por los orificios nasales. Está indicada en casos en los que no hay grandes alteraciones del andamiaje cartilaginoso. En cambio, la rinoplastia abierta, es aquella que requiere la elevación la piel y tejidos superficiales de la nariz durante la cirugía para tener un acceso amplio a todas las estructuras que conforman la arquitectura de la nariz.",
          "items": [
            "La operación se realiza en un quirófano bajo anestesia general (el paciente permanecerá dormido durante toda la cirugía) y tiene una duración aproximada de 1 a 2 horas. Existen fundamentalmente dos tipos de abordajes para esta cirugía, la rinoplastia cerrada y la rinoplastia abierta. La primera y más común es aquella que se realiza a través de incisiones por dentro de la nariz, por los orificios nasales. Está indicada en casos en los que no hay grandes alteraciones del andamiaje cartilaginoso. En cambio, la rinoplastia abierta, es aquella que requiere la elevación la piel y tejidos superficiales de la nariz durante la cirugía para tener un acceso amplio a todas las estructuras que conforman la arquitectura de la nariz."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la intervención. Tras la intervención se introducen unos tapones en los orificios nasales que se mantienen durante las primeras 48-72 horas. También utilizaremos una férula externa en el dorso de la nariz durante 1 semana. El postoperatorio de la rinoplastia no suele ser doloroso, se controla fácilmente con los analgésicos habituales que le indicaremos. La mayoría de los pacientes describen como lo más molesto el taponamiento nasal que les obliga a respirar por la boca. Además, le aconsejaremos que duerma con el cabecero elevado y evite agacharse en la primera semana postoperatoria para favorecer el descenso de la inflamación inicial.",
          "items": [
            "Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la intervención. Tras la intervención se introducen unos tapones en los orificios nasales que se mantienen durante las primeras 48-72 horas. También utilizaremos una férula externa en el dorso de la nariz durante 1 semana. El postoperatorio de la rinoplastia no suele ser doloroso, se controla fácilmente con los analgésicos habituales que le indicaremos. La mayoría de los pacientes describen como lo más molesto el taponamiento nasal que les obliga a respirar por la boca. Además, le aconsejaremos que duerma con el cabecero elevado y evite agacharse en la primera semana postoperatoria para favorecer el descenso de la inflamación inicial."
          ]
        }
      ],
      "blocks": [
        "Rinoplastia\nLa rinoplastia es una cirugía destinada a modificar la estructura de la nariz, adaptándola a la cara, para que el conjunto se muestre más armónico y, por lo tanto, más estético. Además, con esta intervención también podemos corregir defectos congénitos o adquiridos por una accidente o enfermedad.",
        "Indicación\nEsta operación está indicada en aquellas personas que deseen corregir aquellos aspectos que afean la nariz, bien porque la hacen desproporcionada o bien porque no están en armonía con el resto de la cara. Tanto mujeres como hombres se pueden beneficiar de este tratamiento.",
        "Primera Consulta\nEn la primera consulta realizaremos una historia clínica completa del paciente, así como una detallada exploración de la nariz, tanto a nivel funcional como estético. En función de esta exploración, le explicaremos la opción quirúrgica que mejor se adapte a su caso particular. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
        "Operación\nLa operación se realiza en un quirófano bajo anestesia general (el paciente permanecerá dormido durante toda la cirugía) y tiene una duración aproximada de 1 a 2 horas. Existen fundamentalmente dos tipos de abordajes para esta cirugía, la rinoplastia cerrada y la rinoplastia abierta. La primera y más común es aquella que se realiza a través de incisiones por dentro de la nariz, por los orificios nasales. Está indicada en casos en los que no hay grandes alteraciones del andamiaje cartilaginoso. En cambio, la rinoplastia abierta, es aquella que requiere la elevación la piel y tejidos superficiales de la nariz durante la cirugía para tener un acceso amplio a todas las estructuras que conforman la arquitectura de la nariz.",
        "Postoperatorio\nEs recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la intervención. Tras la intervención se introducen unos tapones en los orificios nasales que se mantienen durante las primeras 48-72 horas. También utilizaremos una férula externa en el dorso de la nariz durante 1 semana. El postoperatorio de la rinoplastia no suele ser doloroso, se controla fácilmente con los analgésicos habituales que le indicaremos. La mayoría de los pacientes describen como lo más molesto el taponamiento nasal que les obliga a respirar por la boca. Además, le aconsejaremos que duerma con el cabecero elevado y evite agacharse en la primera semana postoperatoria para favorecer el descenso de la inflamación inicial."
      ],
      "images": [
        "/assets/squarespace/image-asset-85356642a0.jpg",
        "/assets/squarespace/img_0008-8c4a6d58ff.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/img_0008-b2929da7df.jpg",
        "/assets/squarespace/img_0008-7af5cdd7d7.jpg",
        "/assets/squarespace/img_0008-d314c18c90.jpg",
        "/assets/squarespace/img_0008-d5ece0f939.jpg",
        "/assets/squarespace/img_0008-cefb451f23.jpg",
        "/assets/squarespace/img_0008-0f8384fd2d.jpg"
      ]
    },
    {
      "route": "/lifting-facial-madrid",
      "slug": "lifting-facial-madrid",
      "url": "https://www.doctoramasa.com/lifting-facial-madrid",
      "title": "Lifting facial",
      "collectionTitle": "Lifting facial",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Lifting facial"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera Consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Lifting facial",
          "body": "El lifting facial, también conocido como estiramiento facial o ritidectomía, es una cirugía estética destinada a mejorar los signos del envejecimiento facial. Con el paso del tiempo, la piel y los músculos del rostro pierden tonicidad, apareciendo arrugas y descolgamientos de piel. El lifting facial consigue contrarrestar este deterioro y devolver el aspecto de juventud al rostro. Con cierta frecuencia, esta cirugía se combina con el tratamiento de los párpados mediante una blefaroplastia.",
          "items": [
            "El lifting facial, también conocido como estiramiento facial o ritidectomía, es una cirugía estética destinada a mejorar los signos del envejecimiento facial. Con el paso del tiempo, la piel y los músculos del rostro pierden tonicidad, apareciendo arrugas y descolgamientos de piel. El lifting facial consigue contrarrestar este deterioro y devolver el aspecto de juventud al rostro. Con cierta frecuencia, esta cirugía se combina con el tratamiento de los párpados mediante una blefaroplastia."
          ]
        },
        {
          "heading": "Indicación",
          "body": "Los candidatos ideales para someterse a un lifting facial son aquellas personas que desean reducir los signos del paso del tiempo (arrugas) con las que se sienten insatisfechos. Tanto mujeres como hombres se pueden beneficiar de este tratamiento.",
          "items": [
            "Los candidatos ideales para someterse a un lifting facial son aquellas personas que desean reducir los signos del paso del tiempo (arrugas) con las que se sienten insatisfechos. Tanto mujeres como hombres se pueden beneficiar de este tratamiento."
          ]
        },
        {
          "heading": "Primera Consulta",
          "body": "En la primera consulta realizaremos una historia clínica completa del paciente, así como una detallada exploración cervicofacial, tanto a nivel funcional como estético. En función de esta exploración, le explicaremos concretamente en qué consistirá su cirugía. la opción quirúrgica que mejor se adapte a su caso particular. En ocasiones le recomendaremos complementar el tratamiento con una blefaroplastia o con relleno graso de algunas zonas. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta realizaremos una historia clínica completa del paciente, así como una detallada exploración cervicofacial, tanto a nivel funcional como estético. En función de esta exploración, le explicaremos concretamente en qué consistirá su cirugía. la opción quirúrgica que mejor se adapte a su caso particular. En ocasiones le recomendaremos complementar el tratamiento con una blefaroplastia o con relleno graso de algunas zonas. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.",
            "Acude a la primera consulta gratuita y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La operación se realiza en un quirófano bajo anestesia general y tiene una duración aproximada de 3 a 4 horas. El éxito de esta cirugía depende del tratamiento de las estructuras profundas que sostienen a su vez la piel de la cara. Realizamos un abordaje que se inicia en la línea de cuero cabelludo a nivel de las sienes y desciende ocultándose en el borde anterior de la oreja para terminar a nivel retroauricular. Esta incisión nos permite acceder a las estructuras que dan soporte a la piel y tensarlas por medio de suturas internas. Por último, se reseca el exceso cutáneo resultante y se cierra la herida. Las cicatrices quedan escondidas por dentro del cabello y dentro de los pliegues anatómicos de tu piel por lo que serán prácticamente imperceptibles.",
          "items": [
            "La operación se realiza en un quirófano bajo anestesia general y tiene una duración aproximada de 3 a 4 horas. El éxito de esta cirugía depende del tratamiento de las estructuras profundas que sostienen a su vez la piel de la cara. Realizamos un abordaje que se inicia en la línea de cuero cabelludo a nivel de las sienes y desciende ocultándose en el borde anterior de la oreja para terminar a nivel retroauricular. Esta incisión nos permite acceder a las estructuras que dan soporte a la piel y tensarlas por medio de suturas internas. Por último, se reseca el exceso cutáneo resultante y se cierra la herida. Las cicatrices quedan escondidas por dentro del cabello y dentro de los pliegues anatómicos de tu piel por lo que serán prácticamente imperceptibles."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la intervención. Tras la cirugía de lifting facial, dejamos unos drenajes detrás de las orejas para recoger cualquier líquido y evitar que se acumule dentro de la herida. Habitualmente, podemos retirar estos drenajes a las 24 horas. Utilizamos un vendaje ligero durante la primera semana después de la operación. El postoperatorio no acostumbra a ser doloroso. Las molestias que aparecen se controlan bien con analgésicos habituales vía oral. Después de un lifting, el rostro presenta un aspecto más o menos hinchado en función de la extensión del trabajo realizado y de las características propias de cada paciente. Esta hinchazón desaparecerá en unas semanas o meses. Deberá mantener la cabeza elevada durante unos días después de la cirugía para disminuir la inflamación.",
          "items": [
            "Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la intervención. Tras la cirugía de lifting facial, dejamos unos drenajes detrás de las orejas para recoger cualquier líquido y evitar que se acumule dentro de la herida. Habitualmente, podemos retirar estos drenajes a las 24 horas. Utilizamos un vendaje ligero durante la primera semana después de la operación. El postoperatorio no acostumbra a ser doloroso. Las molestias que aparecen se controlan bien con analgésicos habituales vía oral. Después de un lifting, el rostro presenta un aspecto más o menos hinchado en función de la extensión del trabajo realizado y de las características propias de cada paciente. Esta hinchazón desaparecerá en unas semanas o meses. Deberá mantener la cabeza elevada durante unos días después de la cirugía para disminuir la inflamación."
          ]
        }
      ],
      "blocks": [
        "Lifting facial\nEl lifting facial, también conocido como estiramiento facial o ritidectomía, es una cirugía estética destinada a mejorar los signos del envejecimiento facial. Con el paso del tiempo, la piel y los músculos del rostro pierden tonicidad, apareciendo arrugas y descolgamientos de piel. El lifting facial consigue contrarrestar este deterioro y devolver el aspecto de juventud al rostro. Con cierta frecuencia, esta cirugía se combina con el tratamiento de los párpados mediante una blefaroplastia.",
        "Indicación\nLos candidatos ideales para someterse a un lifting facial son aquellas personas que desean reducir los signos del paso del tiempo (arrugas) con las que se sienten insatisfechos. Tanto mujeres como hombres se pueden beneficiar de este tratamiento.",
        "Primera Consulta\nEn la primera consulta realizaremos una historia clínica completa del paciente, así como una detallada exploración cervicofacial, tanto a nivel funcional como estético. En función de esta exploración, le explicaremos concretamente en qué consistirá su cirugía. la opción quirúrgica que mejor se adapte a su caso particular. En ocasiones le recomendaremos complementar el tratamiento con una blefaroplastia o con relleno graso de algunas zonas. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
        "Operación\nLa operación se realiza en un quirófano bajo anestesia general y tiene una duración aproximada de 3 a 4 horas. El éxito de esta cirugía depende del tratamiento de las estructuras profundas que sostienen a su vez la piel de la cara. Realizamos un abordaje que se inicia en la línea de cuero cabelludo a nivel de las sienes y desciende ocultándose en el borde anterior de la oreja para terminar a nivel retroauricular. Esta incisión nos permite acceder a las estructuras que dan soporte a la piel y tensarlas por medio de suturas internas. Por último, se reseca el exceso cutáneo resultante y se cierra la herida. Las cicatrices quedan escondidas por dentro del cabello y dentro de los pliegues anatómicos de tu piel por lo que serán prácticamente imperceptibles.",
        "Postoperatorio\nEs recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la intervención. Tras la cirugía de lifting facial, dejamos unos drenajes detrás de las orejas para recoger cualquier líquido y evitar que se acumule dentro de la herida. Habitualmente, podemos retirar estos drenajes a las 24 horas. Utilizamos un vendaje ligero durante la primera semana después de la operación. El postoperatorio no acostumbra a ser doloroso. Las molestias que aparecen se controlan bien con analgésicos habituales vía oral. Después de un lifting, el rostro presenta un aspecto más o menos hinchado en función de la extensión del trabajo realizado y de las características propias de cada paciente. Esta hinchazón desaparecerá en unas semanas o meses. Deberá mantener la cabeza elevada durante unos días después de la cirugía para disminuir la inflamación."
      ],
      "images": [
        "/assets/squarespace/image-asset-85356642a0.jpg",
        "/assets/squarespace/img_0008-8c4a6d58ff.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/img_0008-b2929da7df.jpg",
        "/assets/squarespace/img_0008-7af5cdd7d7.jpg",
        "/assets/squarespace/img_0008-d314c18c90.jpg",
        "/assets/squarespace/img_0008-d5ece0f939.jpg",
        "/assets/squarespace/img_0008-cefb451f23.jpg",
        "/assets/squarespace/img_0008-0f8384fd2d.jpg"
      ]
    },
    {
      "route": "/reconstruccion-mama-madrid",
      "slug": "reconstruccion-mama-madrid",
      "url": "https://www.doctoramasa.com/reconstruccion-mama-madrid",
      "title": "Reconstrucción de mama",
      "collectionTitle": "Reconstrucción de mama",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Reconstrucción de mama"
        }
      ],
      "sections": [
        {
          "heading": "Reconstrucción de mama",
          "body": "La reconstrucción de mama postmastectomía es parte del tratamiento integral del cáncer de mama. Es importante tener en cuenta que la reconstrucción dependerá y se adaptará al tratamiento contra el cáncer de mama que se haya establecido, siendo siempre la seguridad oncológica la prioridad en estas pacientes. La cirugía de reconstrucción de mama tiene como objetivos principales:\nRecrear una mama de aspecto natural, incluyendo la areola y el pezón.\nEliminar la necesidad de llevar prótesis externas de relleno facilitando el día a día de estas pacientes a la hora de vestir.\nRestaurar la imagen corporal y mejorar la calidad de vida de la paciente.\nCuando hablamos de reconstrucción mamaria son dos aspectos fundamentales los que tenemos que considerar.\nPor una parte el cuándo iniciar la reconstrucción, diferenciando entre reconstrucción mamaria inmediata o diferida. La cirugía puede hacerse o comenzar al momento de la mastectomía (reconstrucción inmediata) o después de que las incisiones de la mastectomía hayan cicatrizado y la terapia contra el cáncer de mama se haya completado (reconstrucción diferida). La reconstrucción mamaria diferida puede realizarse meses o incluso años después de la mastectomía.\nEl segundo aspecto a considerar en reconstrucción mamaria es qué técnica realizar. En este sentido, el abanico de posibilidades es muy amplio: con implantes mamarios, con el propio tejido de la paciente o con la combinación de ambos. Algunas veces la cirugía de reconstrucción incluye cirugía en el otro pecho, o mama contralateral, para maximizar la simetría de los dos pechos en tamaño y forma.",
          "items": [
            "La reconstrucción de mama postmastectomía es parte del tratamiento integral del cáncer de mama. Es importante tener en cuenta que la reconstrucción dependerá y se adaptará al tratamiento contra el cáncer de mama que se haya establecido, siendo siempre la seguridad oncológica la prioridad en estas pacientes. La cirugía de reconstrucción de mama tiene como objetivos principales:",
            "Recrear una mama de aspecto natural, incluyendo la areola y el pezón.",
            "Eliminar la necesidad de llevar prótesis externas de relleno facilitando el día a día de estas pacientes a la hora de vestir.",
            "Restaurar la imagen corporal y mejorar la calidad de vida de la paciente.",
            "Cuando hablamos de reconstrucción mamaria son dos aspectos fundamentales los que tenemos que considerar.",
            "Por una parte el cuándo iniciar la reconstrucción, diferenciando entre reconstrucción mamaria inmediata o diferida. La cirugía puede hacerse o comenzar al momento de la mastectomía (reconstrucción inmediata) o después de que las incisiones de la mastectomía hayan cicatrizado y la terapia contra el cáncer de mama se haya completado (reconstrucción diferida). La reconstrucción mamaria diferida puede realizarse meses o incluso años después de la mastectomía.",
            "El segundo aspecto a considerar en reconstrucción mamaria es qué técnica realizar. En este sentido, el abanico de posibilidades es muy amplio: con implantes mamarios, con el propio tejido de la paciente o con la combinación de ambos. Algunas veces la cirugía de reconstrucción incluye cirugía en el otro pecho, o mama contralateral, para maximizar la simetría de los dos pechos en tamaño y forma."
          ]
        }
      ],
      "blocks": [
        "Reconstrucción de mama\nLa reconstrucción de mama postmastectomía es parte del tratamiento integral del cáncer de mama. Es importante tener en cuenta que la reconstrucción dependerá y se adaptará al tratamiento contra el cáncer de mama que se haya establecido, siendo siempre la seguridad oncológica la prioridad en estas pacientes. La cirugía de reconstrucción de mama tiene como objetivos principales:\nRecrear una mama de aspecto natural, incluyendo la areola y el pezón.\nEliminar la necesidad de llevar prótesis externas de relleno facilitando el día a día de estas pacientes a la hora de vestir.\nRestaurar la imagen corporal y mejorar la calidad de vida de la paciente.\nCuando hablamos de reconstrucción mamaria son dos aspectos fundamentales los que tenemos que considerar.\nPor una parte el cuándo iniciar la reconstrucción, diferenciando entre reconstrucción mamaria inmediata o diferida. La cirugía puede hacerse o comenzar al momento de la mastectomía (reconstrucción inmediata) o después de que las incisiones de la mastectomía hayan cicatrizado y la terapia contra el cáncer de mama se haya completado (reconstrucción diferida). La reconstrucción mamaria diferida puede realizarse meses o incluso años después de la mastectomía.\nEl segundo aspecto a considerar en reconstrucción mamaria es qué técnica realizar. En este sentido, el abanico de posibilidades es muy amplio: con implantes mamarios, con el propio tejido de la paciente o con la combinación de ambos. Algunas veces la cirugía de reconstrucción incluye cirugía en el otro pecho, o mama contralateral, para maximizar la simetría de los dos pechos en tamaño y forma."
      ],
      "images": [
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png",
        "/assets/squarespace/videoconsulta-1-e78b92b59a.png",
        "/assets/squarespace/videoconsulta-1-6679593101.png",
        "/assets/squarespace/videoconsulta-1-3f2ea7e36b.png"
      ]
    },
    {
      "route": "/lipotransferencia-madrid",
      "slug": "lipotransferencia-madrid",
      "url": "https://www.doctoramasa.com/lipotransferencia-madrid",
      "title": "Lipotransferencia",
      "collectionTitle": "Lipotransferencia",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Lipotransferencia"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera Consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Lipotransferencia",
          "body": "La lipotransferencia, también conocida como transferencia de grasa o lipofilling, es un procedimiento quirúrgico que permite aumentar el volumen de una parte del cuerpo utilizando grasa del propio paciente conseguida por una liposucción. Las modernas técnicas quirúrgicas permiten conseguir un aumento de volumen duradero en zonas faciales, en arrugas, depresiones cicatriciales, piernas, mamas, y cualquier otra parte que precise un aumento de tamaño.",
          "items": [
            "La lipotransferencia, también conocida como transferencia de grasa o lipofilling, es un procedimiento quirúrgico que permite aumentar el volumen de una parte del cuerpo utilizando grasa del propio paciente conseguida por una liposucción. Las modernas técnicas quirúrgicas permiten conseguir un aumento de volumen duradero en zonas faciales, en arrugas, depresiones cicatriciales, piernas, mamas, y cualquier otra parte que precise un aumento de tamaño."
          ]
        },
        {
          "heading": "Indicación",
          "body": "Existen múltiples indicaciones para esta técnica. Pequeños defectos de volumen, arrugas, cicatrices deprimidas o aumento mamario son indicaciones ideales para la lipotransferencia. La condición indispensable para que podamos realizar esta técnica es que el paciente tenga la cantidad y la calidad de grasa apropiada para la indicación propuesta.\nEs necesario tener en cuenta que la cantidad de grasa que podemos infiltrar por sesión para que ésta sea viable es limitada. En ocasiones puede ser suficiente con una sola sesión, si el volumen que necesitamos aportar es moderado. Lo habitual, sin embargo, es que sean necesarias varias sesiones separadas entre sí 3 meses. Esto nos asegurará la viabilidad de los injertos grasos y nos permitirá conseguir volúmenes mayores.",
          "items": [
            "Existen múltiples indicaciones para esta técnica. Pequeños defectos de volumen, arrugas, cicatrices deprimidas o aumento mamario son indicaciones ideales para la lipotransferencia. La condición indispensable para que podamos realizar esta técnica es que el paciente tenga la cantidad y la calidad de grasa apropiada para la indicación propuesta.",
            "Es necesario tener en cuenta que la cantidad de grasa que podemos infiltrar por sesión para que ésta sea viable es limitada. En ocasiones puede ser suficiente con una sola sesión, si el volumen que necesitamos aportar es moderado. Lo habitual, sin embargo, es que sean necesarias varias sesiones separadas entre sí 3 meses. Esto nos asegurará la viabilidad de los injertos grasos y nos permitirá conseguir volúmenes mayores."
          ]
        },
        {
          "heading": "Primera Consulta",
          "body": "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente las zonas que quiere mejorar y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de las zonas a tratar. Por último, le explicaremos detenidamente en qué consiste la cirugía y le responderemos a todas sus dudas.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente las zonas que quiere mejorar y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de las zonas a tratar. Por último, le explicaremos detenidamente en qué consiste la cirugía y le responderemos a todas sus dudas.",
            "Acude a la primera consulta gratuita y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "Este procedimiento se realiza en quirófano y dependiendo de la localización se hará bajo anestesia local y sedación o anestesia general. Tiene una duración aproximada de 1 a 2 horas. En la mayoría de las ocasiones se podrá volver a casa pasadas unas horas.\nSe comienza extrayendo la grasa con una cánula especial, generalmente de la zona abdominal, de las piernas o de los flancos abdominales (liposucción). Las cicatrices en la zona donante son mínimas (3 mm) y suelen esconderse en el ombligo o pliegues cutáneos. A continuación se procesa la grasa, con la ayuda de una centrifugadora se separan los adipocitos del suero, células sanguíneas, células muertas, etc. Una vez obtenida la grasa pura pasamos a la fase de infiltración. Para ello utilizamos nuevamente unas cánulas específicas que, a través de incisiones de 1-2 mm, nos permiten ir depositado la grasa a lo largo de las distintas zonas que queremos tratar. Las cicatrices, por su mínimo tamaño y localización apenas serán visibles tras la cirugía.",
          "items": [
            "Este procedimiento se realiza en quirófano y dependiendo de la localización se hará bajo anestesia local y sedación o anestesia general. Tiene una duración aproximada de 1 a 2 horas. En la mayoría de las ocasiones se podrá volver a casa pasadas unas horas.",
            "Se comienza extrayendo la grasa con una cánula especial, generalmente de la zona abdominal, de las piernas o de los flancos abdominales (liposucción). Las cicatrices en la zona donante son mínimas (3 mm) y suelen esconderse en el ombligo o pliegues cutáneos. A continuación se procesa la grasa, con la ayuda de una centrifugadora se separan los adipocitos del suero, células sanguíneas, células muertas, etc. Una vez obtenida la grasa pura pasamos a la fase de infiltración. Para ello utilizamos nuevamente unas cánulas específicas que, a través de incisiones de 1-2 mm, nos permiten ir depositado la grasa a lo largo de las distintas zonas que queremos tratar. Las cicatrices, por su mínimo tamaño y localización apenas serán visibles tras la cirugía."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "Normalmente la lipotransferencia se lleva a cabo de forma ambulatoria (no requiere un ingreso hospitalario) aunque si la zona tratada es muy amplia requerir un ingreso de una noche. Después de la intervención tendrá que usar una faja o prenda elástica que deberá mantener día y noche durante 3 semanas en la zona donante. Es normal tener molestias, inflamación o incluso cardenales en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. A partir del día siguiente a la intervención día te puedes reincorporar a tu vida habitual, siendo incluso recomendable caminar y realizar ejercicio de forma moderada. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía.",
          "items": [
            "Normalmente la lipotransferencia se lleva a cabo de forma ambulatoria (no requiere un ingreso hospitalario) aunque si la zona tratada es muy amplia requerir un ingreso de una noche. Después de la intervención tendrá que usar una faja o prenda elástica que deberá mantener día y noche durante 3 semanas en la zona donante. Es normal tener molestias, inflamación o incluso cardenales en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. A partir del día siguiente a la intervención día te puedes reincorporar a tu vida habitual, siendo incluso recomendable caminar y realizar ejercicio de forma moderada. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía."
          ]
        }
      ],
      "blocks": [
        "Lipotransferencia\nLa lipotransferencia, también conocida como transferencia de grasa o lipofilling, es un procedimiento quirúrgico que permite aumentar el volumen de una parte del cuerpo utilizando grasa del propio paciente conseguida por una liposucción. Las modernas técnicas quirúrgicas permiten conseguir un aumento de volumen duradero en zonas faciales, en arrugas, depresiones cicatriciales, piernas, mamas, y cualquier otra parte que precise un aumento de tamaño.",
        "Indicación\nExisten múltiples indicaciones para esta técnica. Pequeños defectos de volumen, arrugas, cicatrices deprimidas o aumento mamario son indicaciones ideales para la lipotransferencia. La condición indispensable para que podamos realizar esta técnica es que el paciente tenga la cantidad y la calidad de grasa apropiada para la indicación propuesta.\nEs necesario tener en cuenta que la cantidad de grasa que podemos infiltrar por sesión para que ésta sea viable es limitada. En ocasiones puede ser suficiente con una sola sesión, si el volumen que necesitamos aportar es moderado. Lo habitual, sin embargo, es que sean necesarias varias sesiones separadas entre sí 3 meses. Esto nos asegurará la viabilidad de los injertos grasos y nos permitirá conseguir volúmenes mayores.",
        "Primera Consulta\nEn la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente las zonas que quiere mejorar y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de las zonas a tratar. Por último, le explicaremos detenidamente en qué consiste la cirugía y le responderemos a todas sus dudas.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
        "Operación\nEste procedimiento se realiza en quirófano y dependiendo de la localización se hará bajo anestesia local y sedación o anestesia general. Tiene una duración aproximada de 1 a 2 horas. En la mayoría de las ocasiones se podrá volver a casa pasadas unas horas.\nSe comienza extrayendo la grasa con una cánula especial, generalmente de la zona abdominal, de las piernas o de los flancos abdominales (liposucción). Las cicatrices en la zona donante son mínimas (3 mm) y suelen esconderse en el ombligo o pliegues cutáneos. A continuación se procesa la grasa, con la ayuda de una centrifugadora se separan los adipocitos del suero, células sanguíneas, células muertas, etc. Una vez obtenida la grasa pura pasamos a la fase de infiltración. Para ello utilizamos nuevamente unas cánulas específicas que, a través de incisiones de 1-2 mm, nos permiten ir depositado la grasa a lo largo de las distintas zonas que queremos tratar. Las cicatrices, por su mínimo tamaño y localización apenas serán visibles tras la cirugía.",
        "Postoperatorio\nNormalmente la lipotransferencia se lleva a cabo de forma ambulatoria (no requiere un ingreso hospitalario) aunque si la zona tratada es muy amplia requerir un ingreso de una noche. Después de la intervención tendrá que usar una faja o prenda elástica que deberá mantener día y noche durante 3 semanas en la zona donante. Es normal tener molestias, inflamación o incluso cardenales en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. A partir del día siguiente a la intervención día te puedes reincorporar a tu vida habitual, siendo incluso recomendable caminar y realizar ejercicio de forma moderada. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía."
      ],
      "images": [
        "/assets/squarespace/eedb3738-4092e2ef60.jpg",
        "/assets/squarespace/eedb3878-6a637abba0.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/eedb3738-c8381ceaf1.jpg",
        "/assets/squarespace/eedb3738-1b051fd165.jpg",
        "/assets/squarespace/eedb3738-6bdfdd7880.jpg",
        "/assets/squarespace/eedb3738-19583213bf.jpg",
        "/assets/squarespace/eedb3738-de4f416809.jpg",
        "/assets/squarespace/eedb3738-3d33c8abf0.jpg"
      ]
    },
    {
      "route": "/ciruga-intima-labioplastia-madrid",
      "slug": "ciruga-intima-labioplastia-madrid",
      "url": "https://www.doctoramasa.com/ciruga-intima-labioplastia-madrid",
      "title": "Cirugía íntima",
      "collectionTitle": "Cirugía íntima",
      "description": "",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Cirugía íntima"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera Consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Cirugía íntima",
          "body": "La cirugía íntima o labioplastia consiste en la reducción de los labios menores y/o mayores que por razones congénitas o adquiridas están hipertrofiados, se han 'caído' o son asimétricos. Esta deformidad puede dar lugar a molestias y a una incidencia mayor de infecciones. La intervención busca la reconstrucción del aspecto normal los labios vaginales, siendo los procedimientos más comunes la reducción de los labios menores.",
          "items": [
            "La cirugía íntima o labioplastia consiste en la reducción de los labios menores y/o mayores que por razones congénitas o adquiridas están hipertrofiados, se han 'caído' o son asimétricos. Esta deformidad puede dar lugar a molestias y a una incidencia mayor de infecciones. La intervención busca la reconstrucción del aspecto normal los labios vaginales, siendo los procedimientos más comunes la reducción de los labios menores."
          ]
        },
        {
          "heading": "Indicación",
          "body": "La cirugía íntima o labioplastia está indicada en casos de hipertrofias, caída o asimetría de labios vaginales. Son buenas candidatas tanto mujeres mayores que deseen recuperar su estética vaginal como mujeres jóvenes con defectos congénitos que deseen mejorarla.\nEn ocasiones, pacientes con complexión delgada pueden requerir un aumento del monte de Venus. Se podría obtener mediante técnicas de lipotransferencia o lipofilling.",
          "items": [
            "La cirugía íntima o labioplastia está indicada en casos de hipertrofias, caída o asimetría de labios vaginales. Son buenas candidatas tanto mujeres mayores que deseen recuperar su estética vaginal como mujeres jóvenes con defectos congénitos que deseen mejorarla.",
            "En ocasiones, pacientes con complexión delgada pueden requerir un aumento del monte de Venus. Se podría obtener mediante técnicas de lipotransferencia o lipofilling."
          ]
        },
        {
          "heading": "Primera Consulta",
          "body": "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente las zonas que quiere mejorar y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de las zonas a tratar. Por último, le explicaremos detenidamente en qué consiste la cirugía y le responderemos a todas sus dudas.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente las zonas que quiere mejorar y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de las zonas a tratar. Por último, le explicaremos detenidamente en qué consiste la cirugía y le responderemos a todas sus dudas.",
            "Acude a la primera consulta gratuita y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La labioplastia de labios vaginales es una cirugía ambulatoria que se realiza en quirófano bajo anestesia local con sedación y la paciente vuelve a su domicilio el mismo día de la intervención. La cirugía dura aproximadamente entre 30 minutos y 1 hora aproximadamente. En la mayoría de las ocasiones se podrá volver a casa pasadas unas horas.\nEl procedimiento se adapta a las necesidades de cada caso. Lo habitual es que precise la extirpación del exceso de labios para adaptarlos a la anatomía normal de la zona.",
          "items": [
            "La labioplastia de labios vaginales es una cirugía ambulatoria que se realiza en quirófano bajo anestesia local con sedación y la paciente vuelve a su domicilio el mismo día de la intervención. La cirugía dura aproximadamente entre 30 minutos y 1 hora aproximadamente. En la mayoría de las ocasiones se podrá volver a casa pasadas unas horas.",
            "El procedimiento se adapta a las necesidades de cada caso. Lo habitual es que precise la extirpación del exceso de labios para adaptarlos a la anatomía normal de la zona."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "Normalmente la cirugía íntima se lleva a cabo de forma ambulatoria (no requiere un ingreso hospitalario). Tras la intervención puede notar alguna molestia que se controlan bien con los analgésicos que le indicaremos. Los primeros días tras la cirugía deberá mantener un reposo relativo evitando largas caminatas o permanecer sentada sobre la zona intervenida durante muchas horas. Después de tres a cuatro días, puede volver a su trabajo o actividades cotidianas. Debe evitar las relaciones sexuales con penetración, los baños, las piscinas y montar a caballo o en bicicleta durante las siguientes 3 semanas, tiempo en el que se consigue una completa cicatrización. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía.",
          "items": [
            "Normalmente la cirugía íntima se lleva a cabo de forma ambulatoria (no requiere un ingreso hospitalario). Tras la intervención puede notar alguna molestia que se controlan bien con los analgésicos que le indicaremos. Los primeros días tras la cirugía deberá mantener un reposo relativo evitando largas caminatas o permanecer sentada sobre la zona intervenida durante muchas horas. Después de tres a cuatro días, puede volver a su trabajo o actividades cotidianas. Debe evitar las relaciones sexuales con penetración, los baños, las piscinas y montar a caballo o en bicicleta durante las siguientes 3 semanas, tiempo en el que se consigue una completa cicatrización. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía."
          ]
        }
      ],
      "blocks": [
        "Cirugía íntima\nLa cirugía íntima o labioplastia consiste en la reducción de los labios menores y/o mayores que por razones congénitas o adquiridas están hipertrofiados, se han 'caído' o son asimétricos. Esta deformidad puede dar lugar a molestias y a una incidencia mayor de infecciones. La intervención busca la reconstrucción del aspecto normal los labios vaginales, siendo los procedimientos más comunes la reducción de los labios menores.",
        "Indicación\nLa cirugía íntima o labioplastia está indicada en casos de hipertrofias, caída o asimetría de labios vaginales. Son buenas candidatas tanto mujeres mayores que deseen recuperar su estética vaginal como mujeres jóvenes con defectos congénitos que deseen mejorarla.\nEn ocasiones, pacientes con complexión delgada pueden requerir un aumento del monte de Venus. Se podría obtener mediante técnicas de lipotransferencia o lipofilling.",
        "Primera Consulta\nEn la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente las zonas que quiere mejorar y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física y a una valoración de las zonas a tratar. Por último, le explicaremos detenidamente en qué consiste la cirugía y le responderemos a todas sus dudas.\nAcude a la primera consulta gratuita y consúltanos sin compromiso.",
        "Operación\nLa labioplastia de labios vaginales es una cirugía ambulatoria que se realiza en quirófano bajo anestesia local con sedación y la paciente vuelve a su domicilio el mismo día de la intervención. La cirugía dura aproximadamente entre 30 minutos y 1 hora aproximadamente. En la mayoría de las ocasiones se podrá volver a casa pasadas unas horas.\nEl procedimiento se adapta a las necesidades de cada caso. Lo habitual es que precise la extirpación del exceso de labios para adaptarlos a la anatomía normal de la zona.",
        "Postoperatorio\nNormalmente la cirugía íntima se lleva a cabo de forma ambulatoria (no requiere un ingreso hospitalario). Tras la intervención puede notar alguna molestia que se controlan bien con los analgésicos que le indicaremos. Los primeros días tras la cirugía deberá mantener un reposo relativo evitando largas caminatas o permanecer sentada sobre la zona intervenida durante muchas horas. Después de tres a cuatro días, puede volver a su trabajo o actividades cotidianas. Debe evitar las relaciones sexuales con penetración, los baños, las piscinas y montar a caballo o en bicicleta durante las siguientes 3 semanas, tiempo en el que se consigue una completa cicatrización. Una vez superado el periodo postoperatorio, realizaremos revisiones a los 3, a los 6 y a los 12 meses para valorar la evolución de la cirugía."
      ],
      "images": [
        "/assets/squarespace/eedb3738-4092e2ef60.jpg",
        "/assets/squarespace/eedb3878-6a637abba0.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/eedb3738-c8381ceaf1.jpg",
        "/assets/squarespace/eedb3738-1b051fd165.jpg",
        "/assets/squarespace/eedb3738-6bdfdd7880.jpg",
        "/assets/squarespace/eedb3738-19583213bf.jpg",
        "/assets/squarespace/eedb3738-de4f416809.jpg",
        "/assets/squarespace/eedb3738-3d33c8abf0.jpg"
      ]
    },
    {
      "route": "/consulta",
      "slug": "consulta",
      "url": "https://www.doctoramasa.com/consulta",
      "title": "Consulta",
      "collectionTitle": "Consulta",
      "description": "",
      "category": "contact",
      "lastmod": "2025-03-19",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Consultas"
        },
        {
          "level": "h3",
          "text": "Consulta Sensabell Plastic Surgery"
        },
        {
          "level": "h3",
          "text": "Videoconsulta"
        }
      ],
      "sections": [
        {
          "heading": "Consultas",
          "body": "",
          "items": []
        },
        {
          "heading": "Consulta Sensabell Plastic Surgery",
          "body": "Beauty Clinic",
          "items": [
            "Beauty Clinic"
          ]
        },
        {
          "heading": "",
          "body": "Calle Nuñez de Balboa 107, planta 5. 28001, Madrid",
          "items": [
            "Calle Nuñez de Balboa 107, planta 5. 28001, Madrid"
          ]
        },
        {
          "heading": "Videoconsulta",
          "body": "Resolvemos tus dudas sin moverte casa",
          "items": [
            "Resolvemos tus dudas sin moverte casa"
          ]
        }
      ],
      "blocks": [
        "Consultas",
        "Consulta Sensabell Plastic Surgery\nBeauty Clinic",
        "Calle Nuñez de Balboa 107, planta 5. 28001, Madrid",
        "Videoconsulta\nResolvemos tus dudas sin moverte casa"
      ],
      "images": [
        "/assets/squarespace/foto-videollamada-07ffa904e9.jpg",
        "/assets/squarespace/sensabel-logo-f08b28186b.png",
        "/assets/squarespace/consulta_sensabell_madrid-1030x690-7f6d82626f.png",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/sensabel-logo-06e65271d5.png",
        "/assets/squarespace/sensabel-logo-ab9cf3b119.png",
        "/assets/squarespace/sensabel-logo-735c166cc6.png",
        "/assets/squarespace/sensabel-logo-f8e8ec0a19.png",
        "/assets/squarespace/sensabel-logo-ee8454ed34.png"
      ]
    },
    {
      "route": "/aumento-de-pecho-dra-masa",
      "slug": "aumento-de-pecho-dra-masa",
      "url": "https://www.doctoramasa.com/aumento-de-pecho-dra-masa",
      "title": "LP - Aumento de pecho",
      "collectionTitle": "LP - Aumento de pecho",
      "description": "Cirugía plástica y estética en Madrid · Doctora Masa · Aumento de mama ✓ · Resultados naturales ✓&nbsp;· Máxima calidad y seguridad ✓ &nbsp;☎ Pida su 1ª Cita Gratuita",
      "category": "procedure",
      "lastmod": "2020-03-07",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Aumento de pecho"
        },
        {
          "level": "h2",
          "text": "Consúltanos tus dudas"
        },
        {
          "level": "h2",
          "text": "Decisiones Quirúrgicas"
        },
        {
          "level": "h3",
          "text": "Resumen de la técnica: Aumento de pecho"
        },
        {
          "level": "h2",
          "text": "Solicita tu valoración preoperatoria"
        }
      ],
      "sections": [
        {
          "heading": "Aumento de pecho",
          "body": "",
          "items": []
        },
        {
          "heading": "Consúltanos tus dudas",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "El aumento de senos o mamoplastia de aumento, es un procedimiento quirúrgico que permite aumentar el tamaño y mejorar la forma del pecho de la mujer. Este aumento de volumen se realiza mediante la implantación de prótesis mamarias, que se alojarán en un bolsillo detrás de la glándula mamaria o del músculo pectoral mayor.\nEs imprescindible una valoración personalizada en la que valorar la mejor técnica para cada paciente. En la primera consulta la Doctora Masa te explica los distintos aspectos de la intervención: al abordaje quirúrgico (donde quedará la cicatriz), la posición de implante respecto al pecho y musculatura de la paciente y los distintos tipos de implantes que podemos utilizar. Solo utilizamos implantes de primera calidad porque la seguridad de nuestras pacientes es una prioridad.",
          "items": [
            "El aumento de senos o mamoplastia de aumento, es un procedimiento quirúrgico que permite aumentar el tamaño y mejorar la forma del pecho de la mujer. Este aumento de volumen se realiza mediante la implantación de prótesis mamarias, que se alojarán en un bolsillo detrás de la glándula mamaria o del músculo pectoral mayor.",
            "Es imprescindible una valoración personalizada en la que valorar la mejor técnica para cada paciente. En la primera consulta la Doctora Masa te explica los distintos aspectos de la intervención: al abordaje quirúrgico (donde quedará la cicatriz), la posición de implante respecto al pecho y musculatura de la paciente y los distintos tipos de implantes que podemos utilizar. Solo utilizamos implantes de primera calidad porque la seguridad de nuestras pacientes es una prioridad."
          ]
        },
        {
          "heading": "Decisiones Quirúrgicas",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Abordaje QuirúgicoSubmamarioAreolarAxilar",
          "items": [
            "Abordaje QuirúgicoSubmamarioAreolarAxilar"
          ]
        },
        {
          "heading": "",
          "body": "Posición del implanteSubglandularRetropectoralDual-plane",
          "items": [
            "Posición del implanteSubglandularRetropectoralDual-plane"
          ]
        },
        {
          "heading": "",
          "body": "Tipos de implanteRedondo o AnatómicoAlta o Moderada proyección",
          "items": [
            "Tipos de implanteRedondo o AnatómicoAlta o Moderada proyección"
          ]
        },
        {
          "heading": "Resumen de la técnica: Aumento de pecho",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Tiempo de cirugíaTipo de anestesiaHospitalizaciónReposo postoperatorioAlta médica",
          "items": [
            "Tiempo de cirugíaTipo de anestesiaHospitalizaciónReposo postoperatorioAlta médica"
          ]
        },
        {
          "heading": "",
          "body": "De 60 a 90 minutosAnestesia general1 noche de control intrahospitalarioReposo relativo de 4 a 5 días. Y 20 días sin hacer esfuerzos.Revisiones durante un año postoperatorio.",
          "items": [
            "De 60 a 90 minutosAnestesia general1 noche de control intrahospitalarioReposo relativo de 4 a 5 días. Y 20 días sin hacer esfuerzos.Revisiones durante un año postoperatorio."
          ]
        },
        {
          "heading": "Solicita tu valoración preoperatoria",
          "body": "Pide tu cita cuando mejor se adapte a tus planes y te llamaremos para confirmarla.",
          "items": [
            "Pide tu cita cuando mejor se adapte a tus planes y te llamaremos para confirmarla."
          ]
        }
      ],
      "blocks": [
        "Aumento de pecho",
        "Consúltanos tus dudas",
        "El aumento de senos o mamoplastia de aumento, es un procedimiento quirúrgico que permite aumentar el tamaño y mejorar la forma del pecho de la mujer. Este aumento de volumen se realiza mediante la implantación de prótesis mamarias, que se alojarán en un bolsillo detrás de la glándula mamaria o del músculo pectoral mayor.\nEs imprescindible una valoración personalizada en la que valorar la mejor técnica para cada paciente. En la primera consulta la Doctora Masa te explica los distintos aspectos de la intervención: al abordaje quirúrgico (donde quedará la cicatriz), la posición de implante respecto al pecho y musculatura de la paciente y los distintos tipos de implantes que podemos utilizar. Solo utilizamos implantes de primera calidad porque la seguridad de nuestras pacientes es una prioridad.",
        "Decisiones Quirúrgicas",
        "Abordaje QuirúgicoSubmamarioAreolarAxilar",
        "Posición del implanteSubglandularRetropectoralDual-plane",
        "Tipos de implanteRedondo o AnatómicoAlta o Moderada proyección",
        "Resumen de la técnica: Aumento de pecho",
        "Tiempo de cirugíaTipo de anestesiaHospitalizaciónReposo postoperatorioAlta médica",
        "De 60 a 90 minutosAnestesia general1 noche de control intrahospitalarioReposo relativo de 4 a 5 días. Y 20 días sin hacer esfuerzos.Revisiones durante un año postoperatorio.",
        "Solicita tu valoración preoperatoria\nPide tu cita cuando mejor se adapte a tus planes y te llamaremos para confirmarla."
      ],
      "images": [
        "/assets/squarespace/eedb3741-8dad1c5631.jpg",
        "/assets/squarespace/female-832266_640-eba2d3fac1.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/female-832266_640-619e6b43b7.jpg",
        "/assets/squarespace/female-832266_640-d593f6579e.jpg",
        "/assets/squarespace/female-832266_640-a77148310a.jpg",
        "/assets/squarespace/female-832266_640-31f0f3226b.jpg",
        "/assets/squarespace/female-832266_640-7e4ca876ee.jpg",
        "/assets/squarespace/female-832266_640-38636e9a12.jpg"
      ]
    },
    {
      "route": "/poltica-de-cookies",
      "slug": "poltica-de-cookies",
      "url": "https://www.doctoramasa.com/poltica-de-cookies",
      "title": "Política de cookies",
      "collectionTitle": "Política de cookies",
      "description": "",
      "category": "legal",
      "lastmod": "2018-08-11",
      "priority": "0.75",
      "headings": [
        {
          "level": "h2",
          "text": "Política de cookies"
        }
      ],
      "sections": [
        {
          "heading": "Política de cookies",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "DEFINICIÓN Y FUNCIÓN DE LAS COOKIES\nUna cookie es un fichero que se descarga en tu ordenador o terminal al acceder a nuestra página web. Las cookies nos permiten, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo. Dependiendo de la información que contengan estas cookies y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.\nTIPOS DE COOKIES\nCookies propias: Son aquéllas que enviamos a tu ordenador o terminal desde nuestra página web.\nCookies de terceros: Son aquellas que se envían a tu ordenador o terminal desde un dominio o una página web que no es gestionada por nosotros, sino por otra entidad que trata los datos obtenidos a través de las cookies.\nCookies de análisis: Son aquéllas que bien tratadas por nosotros o por terceros, nos permiten cuantificar el número de usuarios y realizar la medición y análisis estadístico de la utilización que hacen los usuarios de nuestra web. Para ello analizamos la navegación en nuestra página web con el fin de mejorar la oferta de productos o servicios que ofrecemos.\nCookies publicitarias: Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que hay en nuestra página web en base a criterios como el contenido editado o la frecuencia en la que se muestran los anuncios o en función del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar la publicidad en función del mismo.\nADMINISTRACIÓN DE LAS COOKIES\nPuedes permitir, bloquear o eliminar las cookies instaladas en tu ordenador mediante la configuración de las opciones del navegador instalado en tu ordenador.\nNavegador Google Chrome\nNavegador Google Chrome para Andorid\nNavegador Safari\nNavegador Safari para iOS (iPhone y iPad)\nNavegador Internet Explorer\nNavegador Mozilla Firefox\nMuchos navegadores permiten activar un modo privado mediante el cual las cookies se borran siempre después de su visita. Dependiendo de cada navegador este modo privado puede tener diferentes nombres. A continuación encontrará una lista de los navegadores más comunes y los diferentes nombres de este “modo privado\":\nGoogle Chrome 10 y superior – Incógnito\nSafari 2 y superior – Navegación Privada\nFirefox 3.5 y superior – Navegación Privada\nInternet Explorer 8 y superior – InPrivate\nOpera 10.5 y superior – Navegación Privada\nCOOKIES UTILIZADAS EN DOCTORAMASA.COM\nCookies de terceros: La Web de Doctora Masa puede utilizar servicios de terceros que, por cuenta de Doctora Masa, recopilaran información con fines estadísticos, de uso del Site por parte del usuario y para la prestación de otros servicios relacionados con la actividad del Website y otros servicios de Internet.Este sitio Web utiliza:\nSquarespace cookies. Squarespace utiliza cookies y tecnologías similares con el objetivo de proporcionar, personalizar, evaluar, mejorar, promover y proteger nuestros Servicios. Más información en el siguiente enlace: Política sobre el uso de cookies de Squarespace.\nGoogle Analytics. Herramienta de análisis que ayuda a los propietarios de sitios web a medir cómo interactúan los usuarios con el contenido del sitio: número de páginas vistas, frecuencia y repetición de las visitas, duración de las visitas, navegador usado, operador que presta el servicio, idioma, terminal usado o la ciudad a la que está asignada su dirección IP. Para garantizar el anonimato, Google Analytics trunca la dirección IP antes de almacenarla. Más información en los siguientes enlaces: Política de Privacidad de Google Analytics / Sobre el uso que Google da a las cookies",
          "items": [
            "DEFINICIÓN Y FUNCIÓN DE LAS COOKIES",
            "Una cookie es un fichero que se descarga en tu ordenador o terminal al acceder a nuestra página web. Las cookies nos permiten, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo. Dependiendo de la información que contengan estas cookies y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.",
            "TIPOS DE COOKIES",
            "Cookies propias: Son aquéllas que enviamos a tu ordenador o terminal desde nuestra página web.",
            "Cookies de terceros: Son aquellas que se envían a tu ordenador o terminal desde un dominio o una página web que no es gestionada por nosotros, sino por otra entidad que trata los datos obtenidos a través de las cookies.",
            "Cookies de análisis: Son aquéllas que bien tratadas por nosotros o por terceros, nos permiten cuantificar el número de usuarios y realizar la medición y análisis estadístico de la utilización que hacen los usuarios de nuestra web. Para ello analizamos la navegación en nuestra página web con el fin de mejorar la oferta de productos o servicios que ofrecemos.",
            "Cookies publicitarias: Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que hay en nuestra página web en base a criterios como el contenido editado o la frecuencia en la que se muestran los anuncios o en función del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar la publicidad en función del mismo.",
            "ADMINISTRACIÓN DE LAS COOKIES",
            "Puedes permitir, bloquear o eliminar las cookies instaladas en tu ordenador mediante la configuración de las opciones del navegador instalado en tu ordenador.",
            "Navegador Google Chrome",
            "Navegador Google Chrome para Andorid",
            "Navegador Safari",
            "Navegador Safari para iOS (iPhone y iPad)",
            "Navegador Internet Explorer",
            "Navegador Mozilla Firefox",
            "Muchos navegadores permiten activar un modo privado mediante el cual las cookies se borran siempre después de su visita. Dependiendo de cada navegador este modo privado puede tener diferentes nombres. A continuación encontrará una lista de los navegadores más comunes y los diferentes nombres de este “modo privado\":",
            "Google Chrome 10 y superior – Incógnito",
            "Safari 2 y superior – Navegación Privada",
            "Firefox 3.5 y superior – Navegación Privada",
            "Internet Explorer 8 y superior – InPrivate",
            "Opera 10.5 y superior – Navegación Privada",
            "COOKIES UTILIZADAS EN DOCTORAMASA.COM",
            "Cookies de terceros: La Web de Doctora Masa puede utilizar servicios de terceros que, por cuenta de Doctora Masa, recopilaran información con fines estadísticos, de uso del Site por parte del usuario y para la prestación de otros servicios relacionados con la actividad del Website y otros servicios de Internet.Este sitio Web utiliza:",
            "Squarespace cookies. Squarespace utiliza cookies y tecnologías similares con el objetivo de proporcionar, personalizar, evaluar, mejorar, promover y proteger nuestros Servicios. Más información en el siguiente enlace: Política sobre el uso de cookies de Squarespace.",
            "Google Analytics. Herramienta de análisis que ayuda a los propietarios de sitios web a medir cómo interactúan los usuarios con el contenido del sitio: número de páginas vistas, frecuencia y repetición de las visitas, duración de las visitas, navegador usado, operador que presta el servicio, idioma, terminal usado o la ciudad a la que está asignada su dirección IP. Para garantizar el anonimato, Google Analytics trunca la dirección IP antes de almacenarla. Más información en los siguientes enlaces: Política de Privacidad de Google Analytics / Sobre el uso que Google da a las cookies"
          ]
        }
      ],
      "blocks": [
        "Política de cookies",
        "DEFINICIÓN Y FUNCIÓN DE LAS COOKIES\nUna cookie es un fichero que se descarga en tu ordenador o terminal al acceder a nuestra página web. Las cookies nos permiten, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo. Dependiendo de la información que contengan estas cookies y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.\nTIPOS DE COOKIES\nCookies propias: Son aquéllas que enviamos a tu ordenador o terminal desde nuestra página web.\nCookies de terceros: Son aquellas que se envían a tu ordenador o terminal desde un dominio o una página web que no es gestionada por nosotros, sino por otra entidad que trata los datos obtenidos a través de las cookies.\nCookies de análisis: Son aquéllas que bien tratadas por nosotros o por terceros, nos permiten cuantificar el número de usuarios y realizar la medición y análisis estadístico de la utilización que hacen los usuarios de nuestra web. Para ello analizamos la navegación en nuestra página web con el fin de mejorar la oferta de productos o servicios que ofrecemos.\nCookies publicitarias: Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que hay en nuestra página web en base a criterios como el contenido editado o la frecuencia en la que se muestran los anuncios o en función del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar la publicidad en función del mismo.\nADMINISTRACIÓN DE LAS COOKIES\nPuedes permitir, bloquear o eliminar las cookies instaladas en tu ordenador mediante la configuración de las opciones del navegador instalado en tu ordenador.\nNavegador Google Chrome\nNavegador Google Chrome para Andorid\nNavegador Safari\nNavegador Safari para iOS (iPhone y iPad)\nNavegador Internet Explorer\nNavegador Mozilla Firefox\nMuchos navegadores permiten activar un modo privado mediante el cual las cookies se borran siempre después de su visita. Dependiendo de cada navegador este modo privado puede tener diferentes nombres. A continuación encontrará una lista de los navegadores más comunes y los diferentes nombres de este “modo privado\":\nGoogle Chrome 10 y superior – Incógnito\nSafari 2 y superior – Navegación Privada\nFirefox 3.5 y superior – Navegación Privada\nInternet Explorer 8 y superior – InPrivate\nOpera 10.5 y superior – Navegación Privada\nCOOKIES UTILIZADAS EN DOCTORAMASA.COM\nCookies de terceros: La Web de Doctora Masa puede utilizar servicios de terceros que, por cuenta de Doctora Masa, recopilaran información con fines estadísticos, de uso del Site por parte del usuario y para la prestación de otros servicios relacionados con la actividad del Website y otros servicios de Internet.Este sitio Web utiliza:\nSquarespace cookies. Squarespace utiliza cookies y tecnologías similares con el objetivo de proporcionar, personalizar, evaluar, mejorar, promover y proteger nuestros Servicios. Más información en el siguiente enlace: Política sobre el uso de cookies de Squarespace.\nGoogle Analytics. Herramienta de análisis que ayuda a los propietarios de sitios web a medir cómo interactúan los usuarios con el contenido del sitio: número de páginas vistas, frecuencia y repetición de las visitas, duración de las visitas, navegador usado, operador que presta el servicio, idioma, terminal usado o la ciudad a la que está asignada su dirección IP. Para garantizar el anonimato, Google Analytics trunca la dirección IP antes de almacenarla. Más información en los siguientes enlaces: Política de Privacidad de Google Analytics / Sobre el uso que Google da a las cookies"
      ],
      "images": [
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png",
        "/assets/squarespace/videoconsulta-1-e78b92b59a.png",
        "/assets/squarespace/videoconsulta-1-6679593101.png",
        "/assets/squarespace/videoconsulta-1-3f2ea7e36b.png"
      ]
    },
    {
      "route": "/poltica-de-privacidad",
      "slug": "poltica-de-privacidad",
      "url": "https://www.doctoramasa.com/poltica-de-privacidad",
      "title": "Política de privacidad",
      "collectionTitle": "Política de privacidad",
      "description": "",
      "category": "legal",
      "lastmod": "2018-08-11",
      "priority": "0.75",
      "headings": [
        {
          "level": "h2",
          "text": "Política de Privacidad"
        }
      ],
      "sections": [
        {
          "heading": "Política de Privacidad",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "En cumplimiento de lo establecido en la RGPD, le informamos que sus datos serán tratados en nuestros ficheros, con la finalidad del mantenimiento y cumplimiento de la relación con nuestra entidad, incluyendo el envío de comunicaciones en el marco de la citada relación.\nAsí mismo, sus datos serán cedidos en todos aquellos casos en que sea necesario para el desarrollo, cumplimiento y control de la relación con nuestra entidad o en los supuestos en que lo autorice una norma con rango de ley.\nLos usuarios podrán ejercitar libremente su derecho de acceso, rectificación, cancelación y oposición al mantenimiento de datos (Derechos ARCO). Los datos se conservarán mientras se mantenga la relación y no se solicite su supresión y en cualquier caso en cumplimiento de plazos legales de prescripción que le resulten de aplicación. Por e-mail a info@doctoramasa.com, y por correo postal a la dirección calle Jaén 2, escalera 2, 3ºA, 28020 Madrid. Le atenderemos lo más brevemente posible siempre dentro del marco legal. Será necesario aportar la documentación que le acredite, normalmente el DNI.",
          "items": [
            "En cumplimiento de lo establecido en la RGPD, le informamos que sus datos serán tratados en nuestros ficheros, con la finalidad del mantenimiento y cumplimiento de la relación con nuestra entidad, incluyendo el envío de comunicaciones en el marco de la citada relación.",
            "Así mismo, sus datos serán cedidos en todos aquellos casos en que sea necesario para el desarrollo, cumplimiento y control de la relación con nuestra entidad o en los supuestos en que lo autorice una norma con rango de ley.",
            "Los usuarios podrán ejercitar libremente su derecho de acceso, rectificación, cancelación y oposición al mantenimiento de datos (Derechos ARCO). Los datos se conservarán mientras se mantenga la relación y no se solicite su supresión y en cualquier caso en cumplimiento de plazos legales de prescripción que le resulten de aplicación. Por e-mail a info@doctoramasa.com, y por correo postal a la dirección calle Jaén 2, escalera 2, 3ºA, 28020 Madrid. Le atenderemos lo más brevemente posible siempre dentro del marco legal. Será necesario aportar la documentación que le acredite, normalmente el DNI."
          ]
        }
      ],
      "blocks": [
        "Política de Privacidad",
        "En cumplimiento de lo establecido en la RGPD, le informamos que sus datos serán tratados en nuestros ficheros, con la finalidad del mantenimiento y cumplimiento de la relación con nuestra entidad, incluyendo el envío de comunicaciones en el marco de la citada relación.\nAsí mismo, sus datos serán cedidos en todos aquellos casos en que sea necesario para el desarrollo, cumplimiento y control de la relación con nuestra entidad o en los supuestos en que lo autorice una norma con rango de ley.\nLos usuarios podrán ejercitar libremente su derecho de acceso, rectificación, cancelación y oposición al mantenimiento de datos (Derechos ARCO). Los datos se conservarán mientras se mantenga la relación y no se solicite su supresión y en cualquier caso en cumplimiento de plazos legales de prescripción que le resulten de aplicación. Por e-mail a info@doctoramasa.com, y por correo postal a la dirección calle Jaén 2, escalera 2, 3ºA, 28020 Madrid. Le atenderemos lo más brevemente posible siempre dentro del marco legal. Será necesario aportar la documentación que le acredite, normalmente el DNI."
      ],
      "images": [
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png",
        "/assets/squarespace/videoconsulta-1-e78b92b59a.png",
        "/assets/squarespace/videoconsulta-1-6679593101.png",
        "/assets/squarespace/videoconsulta-1-3f2ea7e36b.png"
      ]
    },
    {
      "route": "/elevacion-de-pecho-doctora-masa",
      "slug": "elevacion-de-pecho-doctora-masa",
      "url": "https://www.doctoramasa.com/elevacion-de-pecho-doctora-masa",
      "title": "LP - Elevación de pecho",
      "collectionTitle": "LP - Elevación de pecho",
      "description": "Cirugía plástica y estética en Madrid · Doctora Masa · Elevación de mama ✓ · Resultados naturales ✓&nbsp;· Máxima calidad y seguridad ✓ ·&nbsp;☎ 664 39 28 07 · Pida su 1ª Cita",
      "category": "procedure",
      "lastmod": "2020-03-07",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Elevación de pecho"
        },
        {
          "level": "h2",
          "text": "Consúltanos tus dudas"
        },
        {
          "level": "h3",
          "text": "Resumen de la técnica: Elevación de pecho"
        },
        {
          "level": "h2",
          "text": "Solicita tu valoración preoperatoria"
        }
      ],
      "sections": [
        {
          "heading": "Elevación de pecho",
          "body": "",
          "items": []
        },
        {
          "heading": "Consúltanos tus dudas",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "La elevación de pecho o mastopexia, es un procedimiento quirúrgico que permite subir la mama y mejorar la forma del pecho de la mujer. Esta elevación de senos puede realizarse de forma independiente, remodelando la glándula de la mujer para ponerla en una posición más elevada. También puede asociarse la elevación de pecho a un aumento de volumen mediante el uso de implantes mamarios, la denominada mastopexia de aumento.\nEs imprescindible una valoración personalizada en la que valorar la mejor técnica para cada paciente. En la primera consulta la Doctora Masa te explica los distintos aspectos de la intervención. En función de la caída de la mama se diseñará la cirugía. Fundamentalmente afecta al tipo de cicatrices que resultarán. De esta manera tenemos el patrón periareolar, el patrón vertical o el patrón en \"T\" invertida.",
          "items": [
            "La elevación de pecho o mastopexia, es un procedimiento quirúrgico que permite subir la mama y mejorar la forma del pecho de la mujer. Esta elevación de senos puede realizarse de forma independiente, remodelando la glándula de la mujer para ponerla en una posición más elevada. También puede asociarse la elevación de pecho a un aumento de volumen mediante el uso de implantes mamarios, la denominada mastopexia de aumento.",
            "Es imprescindible una valoración personalizada en la que valorar la mejor técnica para cada paciente. En la primera consulta la Doctora Masa te explica los distintos aspectos de la intervención. En función de la caída de la mama se diseñará la cirugía. Fundamentalmente afecta al tipo de cicatrices que resultarán. De esta manera tenemos el patrón periareolar, el patrón vertical o el patrón en \"T\" invertida."
          ]
        },
        {
          "heading": "Resumen de la técnica: Elevación de pecho",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Tiempo de cirugíaTipo de anestesiaHospitalizaciónReposo postoperatorioAlta médica",
          "items": [
            "Tiempo de cirugíaTipo de anestesiaHospitalizaciónReposo postoperatorioAlta médica"
          ]
        },
        {
          "heading": "",
          "body": "De 60 a 180 minutosAnestesia general1 noche de control intrahospitalarioReposo relativo de 4 a 5 días. Y 20 días sin hacer esfuerzos.Revisiones durante un año postoperatorio.",
          "items": [
            "De 60 a 180 minutosAnestesia general1 noche de control intrahospitalarioReposo relativo de 4 a 5 días. Y 20 días sin hacer esfuerzos.Revisiones durante un año postoperatorio."
          ]
        },
        {
          "heading": "Solicita tu valoración preoperatoria",
          "body": "Pide tu cita cuando mejor se adapte a tus planes y te llamaremos para confirmarla.",
          "items": [
            "Pide tu cita cuando mejor se adapte a tus planes y te llamaremos para confirmarla."
          ]
        }
      ],
      "blocks": [
        "Elevación de pecho",
        "Consúltanos tus dudas",
        "La elevación de pecho o mastopexia, es un procedimiento quirúrgico que permite subir la mama y mejorar la forma del pecho de la mujer. Esta elevación de senos puede realizarse de forma independiente, remodelando la glándula de la mujer para ponerla en una posición más elevada. También puede asociarse la elevación de pecho a un aumento de volumen mediante el uso de implantes mamarios, la denominada mastopexia de aumento.\nEs imprescindible una valoración personalizada en la que valorar la mejor técnica para cada paciente. En la primera consulta la Doctora Masa te explica los distintos aspectos de la intervención. En función de la caída de la mama se diseñará la cirugía. Fundamentalmente afecta al tipo de cicatrices que resultarán. De esta manera tenemos el patrón periareolar, el patrón vertical o el patrón en \"T\" invertida.",
        "Resumen de la técnica: Elevación de pecho",
        "Tiempo de cirugíaTipo de anestesiaHospitalizaciónReposo postoperatorioAlta médica",
        "De 60 a 180 minutosAnestesia general1 noche de control intrahospitalarioReposo relativo de 4 a 5 días. Y 20 días sin hacer esfuerzos.Revisiones durante un año postoperatorio.",
        "Solicita tu valoración preoperatoria\nPide tu cita cuando mejor se adapte a tus planes y te llamaremos para confirmarla."
      ],
      "images": [
        "/assets/squarespace/female-832266_640-9dd5a32439.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/female-832266_640-a5052afcfb.jpg",
        "/assets/squarespace/female-832266_640-ae67044927.jpg",
        "/assets/squarespace/female-832266_640-51fdd8f41f.jpg",
        "/assets/squarespace/female-832266_640-13663c4b12.jpg",
        "/assets/squarespace/female-832266_640-37b027fceb.jpg",
        "/assets/squarespace/female-832266_640-0a5faa001e.jpg",
        "/assets/squarespace/female-832266_640-26b2829e0f.jpg"
      ]
    },
    {
      "route": "/aumento-de-pecho-con-grasa",
      "slug": "aumento-de-pecho-con-grasa",
      "url": "https://www.doctoramasa.com/aumento-de-pecho-con-grasa",
      "title": "Aumento de Pecho con Grasa Propia",
      "collectionTitle": "Aumento de Pecho con Grasa Propia",
      "description": "Cirugía plástica y estética en Madrid · Doctora Masa · Elevación de mama ✓ · Mastopexia ✓&nbsp;· Resultados naturales ✓&nbsp;· Máxima calidad y seguridad ✓ &nbsp;☎ Pida su 1ª Cita Gratuita",
      "category": "procedure",
      "lastmod": "2019-12-17",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Aumento de pecho con grasa propia"
        },
        {
          "level": "h3",
          "text": "Indicación"
        },
        {
          "level": "h3",
          "text": "Primera consulta"
        },
        {
          "level": "h3",
          "text": "Operación"
        },
        {
          "level": "h3",
          "text": "Postoperatorio"
        }
      ],
      "sections": [
        {
          "heading": "Aumento de pecho con grasa propia",
          "body": "El aumento de pecho con grasa propia o lipotransferencia para mamas es un tipo de cirugía encaminada a la remodelación y aumento de las mamas. Es una técnica que se puede utilizar como alternativa en pacientes que no desean un aumento con implantes, aunque como veremos son técnicas diferentes en algunos aspectos.",
          "items": [
            "El aumento de pecho con grasa propia o lipotransferencia para mamas es un tipo de cirugía encaminada a la remodelación y aumento de las mamas. Es una técnica que se puede utilizar como alternativa en pacientes que no desean un aumento con implantes, aunque como veremos son técnicas diferentes en algunos aspectos."
          ]
        },
        {
          "heading": "Indicación",
          "body": "La transferencia de grasa es una técnica versátil y segura que puede utilizarse para dar respuesta a diferentes situaciones, tanto a nivel mamario, como facial o corporal. El aumento de senos con grasa de la propia paciente está indicada en aquellas pacientes que deseen un aumento natural y moderado del volumen de sus mamas. Además, esta técnica va a ser de gran utilidad para remodelar el pecho en caso de asimetrías mamarias congénitas o post-quirúrgicas (tumorectomías, cicatrices hundidas, etc).\nTambién en el contexto de cirugía secundaria de la mama tiene su aplicación. En pacientes portadoras de implantes mamarios que necesitan o desean la retirada de los mismos, puede combinarse la transferencia de grasa con otras técnicas para remodelar el pecho evitando el aplanamiento del pecho secundario a la retirada de implantes.",
          "items": [
            "La transferencia de grasa es una técnica versátil y segura que puede utilizarse para dar respuesta a diferentes situaciones, tanto a nivel mamario, como facial o corporal. El aumento de senos con grasa de la propia paciente está indicada en aquellas pacientes que deseen un aumento natural y moderado del volumen de sus mamas. Además, esta técnica va a ser de gran utilidad para remodelar el pecho en caso de asimetrías mamarias congénitas o post-quirúrgicas (tumorectomías, cicatrices hundidas, etc).",
            "También en el contexto de cirugía secundaria de la mama tiene su aplicación. En pacientes portadoras de implantes mamarios que necesitan o desean la retirada de los mismos, puede combinarse la transferencia de grasa con otras técnicas para remodelar el pecho evitando el aplanamiento del pecho secundario a la retirada de implantes."
          ]
        },
        {
          "heading": "Primera consulta",
          "body": "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preferencias y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física en la que evaluamos el pecho de la paciente. Es importante explicar bien a la paciente el tipo de resultado que nos proporciona la lipotransferencia en las mamas. Nos permite conseguir un resultado natural y estable, que cambiará con los cambios de peso de la paciente a la vez que evita las consecuencias de tener implantes (posibilidad de retirada o cambio de implantes). Como contrapartida, hay que ser conscientes de que existe una limitación en la cantidad de grasa que se puede transferir y por tanto del aumento de volumen final. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta informativa y consúltanos sin compromiso.",
          "items": [
            "En la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preferencias y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física en la que evaluamos el pecho de la paciente. Es importante explicar bien a la paciente el tipo de resultado que nos proporciona la lipotransferencia en las mamas. Nos permite conseguir un resultado natural y estable, que cambiará con los cambios de peso de la paciente a la vez que evita las consecuencias de tener implantes (posibilidad de retirada o cambio de implantes). Como contrapartida, hay que ser conscientes de que existe una limitación en la cantidad de grasa que se puede transferir y por tanto del aumento de volumen final. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.",
            "Acude a la primera consulta informativa y consúltanos sin compromiso."
          ]
        },
        {
          "heading": "Operación",
          "body": "La cirugía de aumento de senos con grasa propia se realiza en un quirófano bajo anestesia general y tiene una duración de 2-3 horas. La intervención consta de tres partes fundamentales:\nExtracción de grasa, normalmente de abdomen, caderas o piernas.\nProcesamiento y purificación de la grasa obtenida.\nTransferencia o infiltración de la grasa purificada en las mamas.\nEn algunos casos, está técnica se puede combinar con otras como la mastopexia, la retirada de implantes mamarios, relleno facial, o lipoescultura. Los resultados son muy satisfactorios, mejorando tanto la estética como la autoestima del paciente.",
          "items": [
            "La cirugía de aumento de senos con grasa propia se realiza en un quirófano bajo anestesia general y tiene una duración de 2-3 horas. La intervención consta de tres partes fundamentales:",
            "Extracción de grasa, normalmente de abdomen, caderas o piernas.",
            "Procesamiento y purificación de la grasa obtenida.",
            "Transferencia o infiltración de la grasa purificada en las mamas.",
            "En algunos casos, está técnica se puede combinar con otras como la mastopexia, la retirada de implantes mamarios, relleno facial, o lipoescultura. Los resultados son muy satisfactorios, mejorando tanto la estética como la autoestima del paciente."
          ]
        },
        {
          "heading": "Postoperatorio",
          "body": "Tras la operación la paciente saldrá del quirófano con un vendaje en el pecho y una faja en las zonas donantes de grasa. Es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la operación.\nLa paciente podrá recuperar sus actividad normal en dos a cuatro días. No obstante, le recomendamos que limite su actividad física al principio, evitando ejercicios pesados o movimientos bruscos durante al menos tres semanas. La paciente debe llevar un sujetador anatómico especial también en las tres primeras semanas. Una vez transcurrido este plazo, la inflamación se habrá reducido casi completamente y comenzaremos a ver el pecho con un aspecto más natural y definitivo.",
          "items": [
            "Tras la operación la paciente saldrá del quirófano con un vendaje en el pecho y una faja en las zonas donantes de grasa. Es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la operación.",
            "La paciente podrá recuperar sus actividad normal en dos a cuatro días. No obstante, le recomendamos que limite su actividad física al principio, evitando ejercicios pesados o movimientos bruscos durante al menos tres semanas. La paciente debe llevar un sujetador anatómico especial también en las tres primeras semanas. Una vez transcurrido este plazo, la inflamación se habrá reducido casi completamente y comenzaremos a ver el pecho con un aspecto más natural y definitivo."
          ]
        }
      ],
      "blocks": [
        "Aumento de pecho con grasa propia\nEl aumento de pecho con grasa propia o lipotransferencia para mamas es un tipo de cirugía encaminada a la remodelación y aumento de las mamas. Es una técnica que se puede utilizar como alternativa en pacientes que no desean un aumento con implantes, aunque como veremos son técnicas diferentes en algunos aspectos.",
        "Indicación\nLa transferencia de grasa es una técnica versátil y segura que puede utilizarse para dar respuesta a diferentes situaciones, tanto a nivel mamario, como facial o corporal. El aumento de senos con grasa de la propia paciente está indicada en aquellas pacientes que deseen un aumento natural y moderado del volumen de sus mamas. Además, esta técnica va a ser de gran utilidad para remodelar el pecho en caso de asimetrías mamarias congénitas o post-quirúrgicas (tumorectomías, cicatrices hundidas, etc).\nTambién en el contexto de cirugía secundaria de la mama tiene su aplicación. En pacientes portadoras de implantes mamarios que necesitan o desean la retirada de los mismos, puede combinarse la transferencia de grasa con otras técnicas para remodelar el pecho evitando el aplanamiento del pecho secundario a la retirada de implantes.",
        "Primera consulta\nEn la primera consulta valoraremos cada caso de forma personalizada siendo muy importante que la paciente comente sus preferencias y exponga sus expectativas. Tras una breve historia clínica, procedemos a la exploración física en la que evaluamos el pecho de la paciente. Es importante explicar bien a la paciente el tipo de resultado que nos proporciona la lipotransferencia en las mamas. Nos permite conseguir un resultado natural y estable, que cambiará con los cambios de peso de la paciente a la vez que evita las consecuencias de tener implantes (posibilidad de retirada o cambio de implantes). Como contrapartida, hay que ser conscientes de que existe una limitación en la cantidad de grasa que se puede transferir y por tanto del aumento de volumen final. Es habitual que después de esta primera consulta surjan dudas que podremos solucionar en otra cita antes de la intervención quirúrgica si fuera necesario.\nAcude a la primera consulta informativa y consúltanos sin compromiso.",
        "Operación\nLa cirugía de aumento de senos con grasa propia se realiza en un quirófano bajo anestesia general y tiene una duración de 2-3 horas. La intervención consta de tres partes fundamentales:\nExtracción de grasa, normalmente de abdomen, caderas o piernas.\nProcesamiento y purificación de la grasa obtenida.\nTransferencia o infiltración de la grasa purificada en las mamas.\nEn algunos casos, está técnica se puede combinar con otras como la mastopexia, la retirada de implantes mamarios, relleno facial, o lipoescultura. Los resultados son muy satisfactorios, mejorando tanto la estética como la autoestima del paciente.",
        "Postoperatorio\nTras la operación la paciente saldrá del quirófano con un vendaje en el pecho y una faja en las zonas donantes de grasa. Es normal tener molestias en la zona intervenida que se controlan bien con analgésicos por vía oral tras el alta hospitalaria. Es recomendable el ingreso durante unas horas dándose el alta normalmente al día siguiente de la operación.\nLa paciente podrá recuperar sus actividad normal en dos a cuatro días. No obstante, le recomendamos que limite su actividad física al principio, evitando ejercicios pesados o movimientos bruscos durante al menos tres semanas. La paciente debe llevar un sujetador anatómico especial también en las tres primeras semanas. Una vez transcurrido este plazo, la inflamación se habrá reducido casi completamente y comenzaremos a ver el pecho con un aspecto más natural y definitivo."
      ],
      "images": [
        "/assets/squarespace/image-asset-af7f2bf47b.jpg",
        "/assets/squarespace/eedb3801-730b186fbd.jpg",
        "/assets/squarespace/image-asset-4a885ac844.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/eedb3801-cd08edaafd.jpg",
        "/assets/squarespace/eedb3801-bb8d90bced.jpg",
        "/assets/squarespace/eedb3801-cafd37128b.jpg",
        "/assets/squarespace/eedb3801-76279d29f6.jpg",
        "/assets/squarespace/eedb3801-0d6b88ae9e.jpg"
      ]
    },
    {
      "route": "/pide-cita-2",
      "slug": "pide-cita-2",
      "url": "https://www.doctoramasa.com/pide-cita-2",
      "title": "Pide cita borrador",
      "collectionTitle": "Pide cita borrador",
      "description": "",
      "category": "contact",
      "lastmod": "2020-03-07",
      "priority": "0.75",
      "headings": [
        {
          "level": "h2",
          "text": "Elige consulta y pide tu cita online"
        },
        {
          "level": "h3",
          "text": "Consulta en López Pozas"
        },
        {
          "level": "h3",
          "text": "Consulta en Alluring Clinic"
        },
        {
          "level": "h2",
          "text": "Consúltanos tus dudas"
        }
      ],
      "sections": [
        {
          "heading": "Elige consulta y pide tu cita online",
          "body": "Elige la consulta que prefieras y solicita tu cita cuando mejor se adapte a tus planes. Te llamaremos para confirmarla.",
          "items": [
            "Elige la consulta que prefieras y solicita tu cita cuando mejor se adapte a tus planes. Te llamaremos para confirmarla."
          ]
        },
        {
          "heading": "Consulta en López Pozas",
          "body": "Dirección Calle General López Pozas, 10.",
          "items": [
            "Dirección Calle General López Pozas, 10."
          ]
        },
        {
          "heading": "Consulta en Alluring Clinic",
          "body": "Dirección Calle de Raimundo Fdez-Villaverde, 53C.",
          "items": [
            "Dirección Calle de Raimundo Fdez-Villaverde, 53C."
          ]
        },
        {
          "heading": "Consúltanos tus dudas",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Mediante el uso de este formulario de contacto enviarás un correo electrónico a la Doctora Masa. Enviando el formulario aceptas nuestra Política de Privacidad.",
          "items": [
            "Mediante el uso de este formulario de contacto enviarás un correo electrónico a la Doctora Masa. Enviando el formulario aceptas nuestra Política de Privacidad."
          ]
        }
      ],
      "blocks": [
        "Elige consulta y pide tu cita online\nElige la consulta que prefieras y solicita tu cita cuando mejor se adapte a tus planes. Te llamaremos para confirmarla.",
        "Consulta en López Pozas\nDirección Calle General López Pozas, 10.",
        "Consulta en Alluring Clinic\nDirección Calle de Raimundo Fdez-Villaverde, 53C.",
        "Consúltanos tus dudas",
        "Mediante el uso de este formulario de contacto enviarás un correo electrónico a la Doctora Masa. Enviando el formulario aceptas nuestra Política de Privacidad."
      ],
      "images": [
        "/assets/squarespace/img_0008-f150fc65df.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/img_0008-e5585faf4a.jpg",
        "/assets/squarespace/img_0008-9739e5bcbe.jpg",
        "/assets/squarespace/img_0008-c2509307f1.jpg",
        "/assets/squarespace/img_0008-7286a6fa21.jpg",
        "/assets/squarespace/img_0008-0e02788dce.jpg",
        "/assets/squarespace/img_0008-48468655c1.jpg",
        "/assets/squarespace/img_0008-19705b44f0.jpg"
      ]
    },
    {
      "route": "/pide-cita",
      "slug": "pide-cita",
      "url": "https://www.doctoramasa.com/pide-cita",
      "title": "Pide cita",
      "collectionTitle": "Pide cita",
      "description": "",
      "category": "contact",
      "lastmod": "2020-05-24",
      "priority": "0.75",
      "headings": [
        {
          "level": "h2",
          "text": "Elige consulta y pide tu cita online"
        },
        {
          "level": "h3",
          "text": "Videoconsulta"
        },
        {
          "level": "h3",
          "text": "Consulta López Pozas"
        },
        {
          "level": "h3",
          "text": "Alluring Clinic"
        },
        {
          "level": "h2",
          "text": "Consúltanos tus dudas"
        }
      ],
      "sections": [
        {
          "heading": "Elige consulta y pide tu cita online",
          "body": "Elige la consulta que prefieras y solicita tu cita cuando mejor se adapte a tus planes. Te llamaremos para confirmarla.",
          "items": [
            "Elige la consulta que prefieras y solicita tu cita cuando mejor se adapte a tus planes. Te llamaremos para confirmarla."
          ]
        },
        {
          "heading": "Videoconsulta",
          "body": "Desde tu móvil, tablet u ordenador",
          "items": [
            "Desde tu móvil, tablet u ordenador"
          ]
        },
        {
          "heading": "Consulta López Pozas",
          "body": "En Calle General López Pozas, 10.",
          "items": [
            "En Calle General López Pozas, 10."
          ]
        },
        {
          "heading": "Alluring Clinic",
          "body": "En Calle de Raimundo Fdez-Villaverde, 53C.",
          "items": [
            "En Calle de Raimundo Fdez-Villaverde, 53C."
          ]
        },
        {
          "heading": "Consúltanos tus dudas",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Mediante el uso de este formulario de contacto enviarás un correo electrónico a la Doctora Masa. Enviando el formulario aceptas nuestra Política de Privacidad.",
          "items": [
            "Mediante el uso de este formulario de contacto enviarás un correo electrónico a la Doctora Masa. Enviando el formulario aceptas nuestra Política de Privacidad."
          ]
        }
      ],
      "blocks": [
        "Elige consulta y pide tu cita online\nElige la consulta que prefieras y solicita tu cita cuando mejor se adapte a tus planes. Te llamaremos para confirmarla.",
        "Videoconsulta\nDesde tu móvil, tablet u ordenador",
        "Consulta López Pozas\nEn Calle General López Pozas, 10.",
        "Alluring Clinic\nEn Calle de Raimundo Fdez-Villaverde, 53C.",
        "Consúltanos tus dudas",
        "Mediante el uso de este formulario de contacto enviarás un correo electrónico a la Doctora Masa. Enviando el formulario aceptas nuestra Política de Privacidad."
      ],
      "images": [
        "/assets/squarespace/img_0008-f150fc65df.jpg",
        "/assets/squarespace/foto-videollamada-1f218fb6ec.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/foto-videollamada-dcaa261296.jpg",
        "/assets/squarespace/foto-videollamada-8b11947e6c.jpg",
        "/assets/squarespace/foto-videollamada-8ce0ea3f43.jpg",
        "/assets/squarespace/foto-videollamada-afe7d038ad.jpg",
        "/assets/squarespace/foto-videollamada-b2f899b730.jpg",
        "/assets/squarespace/foto-videollamada-e23c362847.jpg"
      ]
    },
    {
      "route": "/dra-masa-1-1",
      "slug": "dra-masa-1-1",
      "url": "https://www.doctoramasa.com/dra-masa-1-1",
      "title": "Doctora Masa",
      "collectionTitle": "Home (Baja temporal)",
      "description": "Cirugía plástica y estética en Madrid  · Doctora Masa · Cirugía de mama ✓ · Liposucción ✓ · Blefaroplastia ✓ · Otoplastia ✓ · Máxima calidad y seguridad ✓  ☎ Pida su 1ª Cita Gratuita",
      "category": "profile",
      "lastmod": "2025-08-21",
      "priority": "1.0",
      "headings": [
        {
          "level": "h2",
          "text": "Mamas"
        },
        {
          "level": "h2",
          "text": "Facial"
        },
        {
          "level": "h2",
          "text": "Corporal"
        },
        {
          "level": "h2",
          "text": "Reconstrucción"
        },
        {
          "level": "h3",
          "text": "Profesionalidad"
        },
        {
          "level": "h3",
          "text": "1ª Consulta informativa"
        },
        {
          "level": "h3",
          "text": "Seguridad"
        }
      ],
      "sections": [
        {
          "heading": "Mamas",
          "body": "Aumento de pecho\nElevación de pecho\nReducción de pecho\nAsimetría de pecho\nReconstrucción",
          "items": [
            "Aumento de pecho",
            "Elevación de pecho",
            "Reducción de pecho",
            "Asimetría de pecho",
            "Reconstrucción"
          ]
        },
        {
          "heading": "Facial",
          "body": "Otoplastia\nBlefaroplastia\nRinoplastia\nLifting facial",
          "items": [
            "Otoplastia",
            "Blefaroplastia",
            "Rinoplastia",
            "Lifting facial"
          ]
        },
        {
          "heading": "Corporal",
          "body": "Liposucción\nAbdominoplastia\nLifting de muslos\nLipotransferencia\nCirugía íntima",
          "items": [
            "Liposucción",
            "Abdominoplastia",
            "Lifting de muslos",
            "Lipotransferencia",
            "Cirugía íntima"
          ]
        },
        {
          "heading": "Reconstrucción",
          "body": "Reconstrucción de mama\nOncología cutánea\nPérdidas de sustancia\nQuemaduras",
          "items": [
            "Reconstrucción de mama",
            "Oncología cutánea",
            "Pérdidas de sustancia",
            "Quemaduras"
          ]
        },
        {
          "heading": "",
          "body": "La doctora Inmaculada Masa es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid y Doctora cum laude en Medicina por la Universidad Autónoma de Madrid. Saber más...",
          "items": [
            "La doctora Inmaculada Masa es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid y Doctora cum laude en Medicina por la Universidad Autónoma de Madrid. Saber más..."
          ]
        },
        {
          "heading": "",
          "body": "\"En cirugía plástica, considero imprescindible ejercer con profesionalidad, cercanía y honestidad. Entender y ayudar a mis pacientes es mi principal motivación.\"\nDoctora Masa",
          "items": [
            "\"En cirugía plástica, considero imprescindible ejercer con profesionalidad, cercanía y honestidad. Entender y ayudar a mis pacientes es mi principal motivación.\"",
            "Doctora Masa"
          ]
        },
        {
          "heading": "Profesionalidad",
          "body": "La dra. Masa está acreditada por la Sociedad Española de Cirugía Plástica, Reparadora y Estética (SECPRE).",
          "items": [
            "La dra. Masa está acreditada por la Sociedad Española de Cirugía Plástica, Reparadora y Estética (SECPRE)."
          ]
        },
        {
          "heading": "1ª Consulta informativa",
          "body": "Te ofrecemos un asesoramiento personalizado y resolvemos todas tus dudas",
          "items": [
            "Te ofrecemos un asesoramiento personalizado y resolvemos todas tus dudas"
          ]
        },
        {
          "heading": "Seguridad",
          "body": "La seguridad es una máxima de nuestro servicio. Te atenderemos en HM Hospitales, centros de reconocido prestigio en Madrid.",
          "items": [
            "La seguridad es una máxima de nuestro servicio. Te atenderemos en HM Hospitales, centros de reconocido prestigio en Madrid."
          ]
        }
      ],
      "blocks": [
        "Mamas\nAumento de pecho\nElevación de pecho\nReducción de pecho\nAsimetría de pecho\nReconstrucción",
        "Facial\nOtoplastia\nBlefaroplastia\nRinoplastia\nLifting facial",
        "Corporal\nLiposucción\nAbdominoplastia\nLifting de muslos\nLipotransferencia\nCirugía íntima",
        "Reconstrucción\nReconstrucción de mama\nOncología cutánea\nPérdidas de sustancia\nQuemaduras",
        "La doctora Inmaculada Masa es Especialista en Cirugía Plástica, Reparadora y Estética en Madrid y Doctora cum laude en Medicina por la Universidad Autónoma de Madrid. Saber más...",
        "\"En cirugía plástica, considero imprescindible ejercer con profesionalidad, cercanía y honestidad. Entender y ayudar a mis pacientes es mi principal motivación.\"\nDoctora Masa",
        "Profesionalidad\nLa dra. Masa está acreditada por la Sociedad Española de Cirugía Plástica, Reparadora y Estética (SECPRE).",
        "1ª Consulta informativa\nTe ofrecemos un asesoramiento personalizado y resolvemos todas tus dudas",
        "Seguridad\nLa seguridad es una máxima de nuestro servicio. Te atenderemos en HM Hospitales, centros de reconocido prestigio en Madrid."
      ],
      "images": [
        "/assets/squarespace/image-asset-5d69e03a59.jpg",
        "/assets/squarespace/image-asset-3f2d3b2871.jpg",
        "/assets/squarespace/sensabell_fotos_dra-inma_39-2ca1d2db5c.jpg",
        "/assets/squarespace/sensabell_fotos_dra-inma_26-b6fd55c1ca.jpg",
        "/assets/squarespace/img_0031-83a24c7e72.jpg",
        "/assets/squarespace/image-asset-0a59dab612.jpg",
        "/assets/squarespace/image-asset-dd26de1725.jpg",
        "/assets/squarespace/image-asset-bce51393a6.jpg",
        "/assets/squarespace/image-asset-3ca9b3032e.jpg",
        "/assets/squarespace/image-asset-8430df6428.jpg",
        "/assets/squarespace/image-asset-a460a7dc97.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png"
      ]
    },
    {
      "route": "/contacto-1",
      "slug": "contacto-1",
      "url": "https://www.doctoramasa.com/contacto-1",
      "title": "Contacto",
      "collectionTitle": "Contacto",
      "description": "",
      "category": "contact",
      "lastmod": "2025-12-09",
      "priority": "0.75",
      "headings": [
        {
          "level": "h3",
          "text": "Videoconsulta a distancia"
        },
        {
          "level": "h3",
          "text": "Consulta en Sensabell Plastic Surgery"
        },
        {
          "level": "h2",
          "text": "Consúltanos tus dudas"
        }
      ],
      "sections": [
        {
          "heading": "Videoconsulta a distancia",
          "body": "Desde tu móvil, tablet u ordenador",
          "items": [
            "Desde tu móvil, tablet u ordenador"
          ]
        },
        {
          "heading": "Consulta en Sensabell Plastic Surgery",
          "body": "Calle Nuñez de Balboa 107, planta 5, consultas 501-502. 28006 Madrid",
          "items": [
            "Calle Nuñez de Balboa 107, planta 5, consultas 501-502. 28006 Madrid"
          ]
        },
        {
          "heading": "Consúltanos tus dudas",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Mediante el uso de este formulario de contacto enviarás un correo electrónico a la Doctora Masa. Enviando el formulario aceptas nuestra Política de Privacidad.",
          "items": [
            "Mediante el uso de este formulario de contacto enviarás un correo electrónico a la Doctora Masa. Enviando el formulario aceptas nuestra Política de Privacidad."
          ]
        }
      ],
      "blocks": [
        "Videoconsulta a distancia\nDesde tu móvil, tablet u ordenador",
        "Consulta en Sensabell Plastic Surgery\nCalle Nuñez de Balboa 107, planta 5, consultas 501-502. 28006 Madrid",
        "Consúltanos tus dudas",
        "Mediante el uso de este formulario de contacto enviarás un correo electrónico a la Doctora Masa. Enviando el formulario aceptas nuestra Política de Privacidad."
      ],
      "images": [
        "/assets/squarespace/img_0008-f150fc65df.jpg",
        "/assets/squarespace/foto-videollamada-1f218fb6ec.jpg",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/foto-videollamada-dcaa261296.jpg",
        "/assets/squarespace/foto-videollamada-8b11947e6c.jpg",
        "/assets/squarespace/foto-videollamada-8ce0ea3f43.jpg",
        "/assets/squarespace/foto-videollamada-afe7d038ad.jpg",
        "/assets/squarespace/foto-videollamada-b2f899b730.jpg",
        "/assets/squarespace/foto-videollamada-e23c362847.jpg"
      ]
    },
    {
      "route": "/classes-om",
      "slug": "classes-om",
      "url": "https://www.doctoramasa.com/classes-om",
      "title": "Classes",
      "collectionTitle": "Classes",
      "description": "",
      "category": "legacy",
      "lastmod": "2025-05-09",
      "priority": "0.75",
      "headings": [],
      "sections": [],
      "blocks": [],
      "images": [
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png",
        "/assets/squarespace/videoconsulta-1-e78b92b59a.png",
        "/assets/squarespace/videoconsulta-1-6679593101.png",
        "/assets/squarespace/videoconsulta-1-3f2ea7e36b.png"
      ]
    },
    {
      "route": "/read-me-om",
      "slug": "read-me-om",
      "url": "https://www.doctoramasa.com/read-me-om",
      "title": "Read Me",
      "collectionTitle": "Read Me",
      "description": "",
      "category": "legacy",
      "lastmod": "2025-05-09",
      "priority": "0.75",
      "headings": [
        {
          "level": "h1",
          "text": "Om is a great template that’s easy to setup and comes with many customization options. Use Om for flexibility, clean layouts, and effortless style."
        },
        {
          "level": "h2",
          "text": "Sizes & Values"
        },
        {
          "level": "h2",
          "text": "Template Options"
        },
        {
          "level": "h2",
          "text": "Index Styles"
        },
        {
          "level": "h2",
          "text": "Blog Styles"
        },
        {
          "level": "h2",
          "text": "Product Styles"
        },
        {
          "level": "h2",
          "text": "Event Styles"
        }
      ],
      "sections": [
        {
          "heading": "Om is a great template that’s easy to setup and comes with many customization options. Use Om for flexibility, clean layouts, and effortless style.",
          "body": "",
          "items": []
        },
        {
          "heading": "Sizes & Values",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Site Width - determines the width of the page, including padding and border.\nPage Content Width - set the width of the page content width separate from the Page Banner Area.\nCanvas Padding - control the amount of space between the page content and the edge of the canvas.\nTop Padding - control the amount of space at the top of the site above the canvas.\nNavigation Link Spacing - sets the amount of space between each navigation link.",
          "items": [
            "Site Width - determines the width of the page, including padding and border.",
            "Page Content Width - set the width of the page content width separate from the Page Banner Area.",
            "Canvas Padding - control the amount of space between the page content and the edge of the canvas.",
            "Top Padding - control the amount of space at the top of the site above the canvas.",
            "Navigation Link Spacing - sets the amount of space between each navigation link."
          ]
        },
        {
          "heading": "",
          "body": "Header Spacing - control the amount of spacing at the bottom of the header, above the navigation.\nPage Padding - determines the amount of space at the top and bottom of the page as well as the space below the Page Banner.\nFooter Padding - controls the top and bottom padding used inside the page footer area.\nLogo Size (Max) - determines the maximum height allowed for the site logo in the header area.\nSocial Icon Size - set the size of the (non-social-block) social icons.",
          "items": [
            "Header Spacing - control the amount of spacing at the bottom of the header, above the navigation.",
            "Page Padding - determines the amount of space at the top and bottom of the page as well as the space below the Page Banner.",
            "Footer Padding - controls the top and bottom padding used inside the page footer area.",
            "Logo Size (Max) - determines the maximum height allowed for the site logo in the header area.",
            "Social Icon Size - set the size of the (non-social-block) social icons."
          ]
        },
        {
          "heading": "Template Options",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Page Borders - control the thickness and/or visibility of all borders and rules in the template.\nCanvas Style - choose the layout and logo position inside the header area of the site.\nHeader Subtitle - select the type of content that should be shown directly below (or above with Canvas Style change) the logo.\nBanner Alignment - aligns the text when displayed inside the Page Banner area.\nSocial Icon Style - sets the template specific (non-social icon block) social icons style.",
          "items": [
            "Page Borders - control the thickness and/or visibility of all borders and rules in the template.",
            "Canvas Style - choose the layout and logo position inside the header area of the site.",
            "Header Subtitle - select the type of content that should be shown directly below (or above with Canvas Style change) the logo.",
            "Banner Alignment - aligns the text when displayed inside the Page Banner area.",
            "Social Icon Style - sets the template specific (non-social icon block) social icons style."
          ]
        },
        {
          "heading": "",
          "body": "Hide Social Icons - hides the template specific (non-social icon block) social icons links.\nHide Info Footer - hides the special Info Footer showing social icon links and latest single blog post.\nHide Page Banner - disables the display of the Page Banner area (page thumbnail, title and description).\nHide Page Title - hides only the title inside the Page Banner area.\nHide Page Title Underline - toggles the display of the miniature underline beneath the page title inside the Page Banner area.",
          "items": [
            "Hide Social Icons - hides the template specific (non-social icon block) social icons links.",
            "Hide Info Footer - hides the special Info Footer showing social icon links and latest single blog post.",
            "Hide Page Banner - disables the display of the Page Banner area (page thumbnail, title and description).",
            "Hide Page Title - hides only the title inside the Page Banner area.",
            "Hide Page Title Underline - toggles the display of the miniature underline beneath the page title inside the Page Banner area."
          ]
        },
        {
          "heading": "Index Styles",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Index Thumb Title Color - sets the color of the thumbnail title for each index item.\nIndex Thumb Background Color - sets the color behind the thumbnail image for each index item.\nIndex Thumb Titles - choose the font and size used for the thumbnail title text.\nIndex Sidebar Width - sets the width of the sidebar displaying the title and description of the item.\nThumbnails Per Row - controls the number of columns used on your Index page.\nThumbnail Ratio - sets the size and shape of the thumbnail images based on a ratio.",
          "items": [
            "Index Thumb Title Color - sets the color of the thumbnail title for each index item.",
            "Index Thumb Background Color - sets the color behind the thumbnail image for each index item.",
            "Index Thumb Titles - choose the font and size used for the thumbnail title text.",
            "Index Sidebar Width - sets the width of the sidebar displaying the title and description of the item.",
            "Thumbnails Per Row - controls the number of columns used on your Index page.",
            "Thumbnail Ratio - sets the size and shape of the thumbnail images based on a ratio."
          ]
        },
        {
          "heading": "",
          "body": "Thumbnail Padding - controls the amount of space in between each index item thumbnail image.\nThumbnail Opacity - sets the initial amount of transparency that should be used on index item thumbnail images.\nThumbnail Hover Opacity - sets the transparency of the thumbnail image on hover.\nProject Layout - determines the position of the sidebar displaying the title and description of the item.\nThumbnails on Open Page - show or hide the index thumbnails at the bottom of an index item view.\nHide Thumbnail Titles - toggle the display of the thumbnail title for each index item.",
          "items": [
            "Thumbnail Padding - controls the amount of space in between each index item thumbnail image.",
            "Thumbnail Opacity - sets the initial amount of transparency that should be used on index item thumbnail images.",
            "Thumbnail Hover Opacity - sets the transparency of the thumbnail image on hover.",
            "Project Layout - determines the position of the sidebar displaying the title and description of the item.",
            "Thumbnails on Open Page - show or hide the index thumbnails at the bottom of an index item view.",
            "Hide Thumbnail Titles - toggle the display of the thumbnail title for each index item."
          ]
        },
        {
          "heading": "Blog Styles",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Blog Post Title - sets the font of the article title.\nBlog Page Width - determine the width for the blog content area different from that of the page content width.",
          "items": [
            "Blog Post Title - sets the font of the article title.",
            "Blog Page Width - determine the width for the blog content area different from that of the page content width."
          ]
        },
        {
          "heading": "",
          "body": "Blog Post Spacing - controls the amount of space between each blog post on the list view.\nHide Article Author - toggles the display of the article author with the date under the article title.",
          "items": [
            "Blog Post Spacing - controls the amount of space between each blog post on the list view.",
            "Hide Article Author - toggles the display of the article author with the date under the article title."
          ]
        },
        {
          "heading": "Product Styles",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Product Background Color - sets the color behind the product image.\nProduct Overlay Color - sets the color of the overlay when product list titles are set to 'overlay.'\nProducts Per Row - determines the number of products shown per line on the product list.\nProduct List Titles - controls the position of the product title on the product list.\nProduct List Alignment - sets the text alignment of the product title on the product list.\nProduct Item Size - select an image ratio for the product photo on the product list.",
          "items": [
            "Product Background Color - sets the color behind the product image.",
            "Product Overlay Color - sets the color of the overlay when product list titles are set to 'overlay.'",
            "Products Per Row - determines the number of products shown per line on the product list.",
            "Product List Titles - controls the position of the product title on the product list.",
            "Product List Alignment - sets the text alignment of the product title on the product list.",
            "Product Item Size - select an image ratio for the product photo on the product list."
          ]
        },
        {
          "heading": "",
          "body": "Product Image Auto Crop - determines whether product images fill the image area or fit within.\nProduct Gallery Size - select an image ratio for the product gallery on the product item page.\nProduct Gallery Auto Crop - determines whether product images fill the gallery area or fit within.\nShow Product Price - shows the price on the product list page when enabled.\nShow Product Item Nav - shows the 'back to shop' link on the product item page.",
          "items": [
            "Product Image Auto Crop - determines whether product images fill the image area or fit within.",
            "Product Gallery Size - select an image ratio for the product gallery on the product item page.",
            "Product Gallery Auto Crop - determines whether product images fill the gallery area or fit within.",
            "Show Product Price - shows the price on the product list page when enabled.",
            "Show Product Item Nav - shows the 'back to shop' link on the product item page."
          ]
        },
        {
          "heading": "Event Styles",
          "body": "",
          "items": []
        },
        {
          "heading": "",
          "body": "Event Time Format - toggle between 24 hour or AM/PM for event times.\nEvent Icons - enable icons on the address and event time display.\nEvent Thumbnails - show an image thumbnail in list view.\nEvent Thumbnail Size - controls the size (ratio width:height) of the event thumbnail image.\nEvent Date Label - enable date overlay on top of event thumbnail.\nEvent Date Label Time - include the time of the event with the date overlay.\nEvent Excerpts - show optional excerpt text of events on the list view when present.\nEvent List Date - show the full event date (day, month, year) of the event on the list view.",
          "items": [
            "Event Time Format - toggle between 24 hour or AM/PM for event times.",
            "Event Icons - enable icons on the address and event time display.",
            "Event Thumbnails - show an image thumbnail in list view.",
            "Event Thumbnail Size - controls the size (ratio width:height) of the event thumbnail image.",
            "Event Date Label - enable date overlay on top of event thumbnail.",
            "Event Date Label Time - include the time of the event with the date overlay.",
            "Event Excerpts - show optional excerpt text of events on the list view when present.",
            "Event List Date - show the full event date (day, month, year) of the event on the list view."
          ]
        },
        {
          "heading": "",
          "body": "Event List Time - show the time range (start time-end time) of the event on the list view.\nEvent List Address - show the event location address when present.\nEvent iCal/gCal Links - show links to add events to Apple or Google calendars.\nEvent Like and Share Buttons - show Squarespace simple like and share buttons on events.\nEvent Calendar Compact View - enable a simpler calendar view optimized for smal\nEvent List Compact View - enable a simple stacked view of events in the list view.\nEvent Calendar Compact View - enable a simpler calendar view optimized for smaller areas.",
          "items": [
            "Event List Time - show the time range (start time-end time) of the event on the list view.",
            "Event List Address - show the event location address when present.",
            "Event iCal/gCal Links - show links to add events to Apple or Google calendars.",
            "Event Like and Share Buttons - show Squarespace simple like and share buttons on events.",
            "Event Calendar Compact View - enable a simpler calendar view optimized for smal",
            "Event List Compact View - enable a simple stacked view of events in the list view.",
            "Event Calendar Compact View - enable a simpler calendar view optimized for smaller areas."
          ]
        }
      ],
      "blocks": [
        "Om is a great template that’s easy to setup and comes with many customization options. Use Om for flexibility, clean layouts, and effortless style.",
        "Sizes & Values",
        "Site Width - determines the width of the page, including padding and border.\nPage Content Width - set the width of the page content width separate from the Page Banner Area.\nCanvas Padding - control the amount of space between the page content and the edge of the canvas.\nTop Padding - control the amount of space at the top of the site above the canvas.\nNavigation Link Spacing - sets the amount of space between each navigation link.",
        "Header Spacing - control the amount of spacing at the bottom of the header, above the navigation.\nPage Padding - determines the amount of space at the top and bottom of the page as well as the space below the Page Banner.\nFooter Padding - controls the top and bottom padding used inside the page footer area.\nLogo Size (Max) - determines the maximum height allowed for the site logo in the header area.\nSocial Icon Size - set the size of the (non-social-block) social icons.",
        "Template Options",
        "Page Borders - control the thickness and/or visibility of all borders and rules in the template.\nCanvas Style - choose the layout and logo position inside the header area of the site.\nHeader Subtitle - select the type of content that should be shown directly below (or above with Canvas Style change) the logo.\nBanner Alignment - aligns the text when displayed inside the Page Banner area.\nSocial Icon Style - sets the template specific (non-social icon block) social icons style.",
        "Hide Social Icons - hides the template specific (non-social icon block) social icons links.\nHide Info Footer - hides the special Info Footer showing social icon links and latest single blog post.\nHide Page Banner - disables the display of the Page Banner area (page thumbnail, title and description).\nHide Page Title - hides only the title inside the Page Banner area.\nHide Page Title Underline - toggles the display of the miniature underline beneath the page title inside the Page Banner area.",
        "Index Styles",
        "Index Thumb Title Color - sets the color of the thumbnail title for each index item.\nIndex Thumb Background Color - sets the color behind the thumbnail image for each index item.\nIndex Thumb Titles - choose the font and size used for the thumbnail title text.\nIndex Sidebar Width - sets the width of the sidebar displaying the title and description of the item.\nThumbnails Per Row - controls the number of columns used on your Index page.\nThumbnail Ratio - sets the size and shape of the thumbnail images based on a ratio.",
        "Thumbnail Padding - controls the amount of space in between each index item thumbnail image.\nThumbnail Opacity - sets the initial amount of transparency that should be used on index item thumbnail images.\nThumbnail Hover Opacity - sets the transparency of the thumbnail image on hover.\nProject Layout - determines the position of the sidebar displaying the title and description of the item.\nThumbnails on Open Page - show or hide the index thumbnails at the bottom of an index item view.\nHide Thumbnail Titles - toggle the display of the thumbnail title for each index item.",
        "Blog Styles",
        "Blog Post Title - sets the font of the article title.\nBlog Page Width - determine the width for the blog content area different from that of the page content width.",
        "Blog Post Spacing - controls the amount of space between each blog post on the list view.\nHide Article Author - toggles the display of the article author with the date under the article title.",
        "Product Styles",
        "Product Background Color - sets the color behind the product image.\nProduct Overlay Color - sets the color of the overlay when product list titles are set to 'overlay.'\nProducts Per Row - determines the number of products shown per line on the product list.\nProduct List Titles - controls the position of the product title on the product list.\nProduct List Alignment - sets the text alignment of the product title on the product list.\nProduct Item Size - select an image ratio for the product photo on the product list.",
        "Product Image Auto Crop - determines whether product images fill the image area or fit within.\nProduct Gallery Size - select an image ratio for the product gallery on the product item page.\nProduct Gallery Auto Crop - determines whether product images fill the gallery area or fit within.\nShow Product Price - shows the price on the product list page when enabled.\nShow Product Item Nav - shows the 'back to shop' link on the product item page.",
        "Event Styles",
        "Event Time Format - toggle between 24 hour or AM/PM for event times.\nEvent Icons - enable icons on the address and event time display.\nEvent Thumbnails - show an image thumbnail in list view.\nEvent Thumbnail Size - controls the size (ratio width:height) of the event thumbnail image.\nEvent Date Label - enable date overlay on top of event thumbnail.\nEvent Date Label Time - include the time of the event with the date overlay.\nEvent Excerpts - show optional excerpt text of events on the list view when present.\nEvent List Date - show the full event date (day, month, year) of the event on the list view.",
        "Event List Time - show the time range (start time-end time) of the event on the list view.\nEvent List Address - show the event location address when present.\nEvent iCal/gCal Links - show links to add events to Apple or Google calendars.\nEvent Like and Share Buttons - show Squarespace simple like and share buttons on events.\nEvent Calendar Compact View - enable a simpler calendar view optimized for smal\nEvent List Compact View - enable a simple stacked view of events in the list view.\nEvent Calendar Compact View - enable a simpler calendar view optimized for smaller areas."
      ],
      "images": [
        "/assets/squarespace/51e453dee4b06abd3403c22e-02cff8ed4e.png",
        "/assets/squarespace/synthetica-20130821--cbe31b3636.jpg",
        "/assets/squarespace/515c4225e4b0afec1218b21e-50353b4567.png",
        "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
        "/assets/squarespace/logo2-0e6513f224.png",
        "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
        "/assets/squarespace/logo2-707d850460.png",
        "/assets/squarespace/videoconsulta-1-c49edcb786.png",
        "/assets/squarespace/videoconsulta-1-85315e749e.png",
        "/assets/squarespace/videoconsulta-1-7b86298be1.png",
        "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
        "/assets/squarespace/videoconsulta-1-9b91e968f4.png"
      ]
    }
  ],
  "images": [
    {
      "source": "http://static1.squarespace.com/static/56910baa2399a3180163ea4e/t/574c8001d51cd43e7b8483ee/1464631604918/LOGO.Mint+oscuro.png?format=1500w",
      "local": "/assets/squarespace/logo.mint-oscuro-aad6c78a2c.png",
      "bytes": 32330,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1469483315461-TQL0EILAMIEYNE6550OV/logo2.png",
      "local": "/assets/squarespace/logo2-0e6513f224.png",
      "bytes": 75002,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1464631602605-CV0Z3BA1DBE17NA776KU/LOGO.Mint+oscuro.png",
      "local": "/assets/squarespace/logo.mint-oscuro-b371a01013.png",
      "bytes": 32330,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1469483315461-TQL0EILAMIEYNE6550OV/logo2.png?format=1500w",
      "local": "/assets/squarespace/logo2-707d850460.png",
      "bytes": 48596,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1755794968151-NNGNX92W14NMIDYZTJX1/Sensabell_Fotos_Dra+Inma_39.jpg",
      "local": "/assets/squarespace/sensabell_fotos_dra-inma_39-2ca1d2db5c.jpg",
      "bytes": 166674,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1755794970930-5A458BWSURY3EZ76BCV4/Sensabell_Fotos_Dra+Inma_26.jpg",
      "local": "/assets/squarespace/sensabell_fotos_dra-inma_26-b6fd55c1ca.jpg",
      "bytes": 166556,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482334349564-AE2T7VX0HUPS5H21LGFW/IMG_0031.JPG",
      "local": "/assets/squarespace/img_0031-83a24c7e72.jpg",
      "bytes": 44080,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482341335648-NXTV439YF3NHJH7R5U8Y/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-bce51393a6.jpg",
      "bytes": 178326,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482341335648-NXTV439YF3NHJH7R5U8Y/image-asset.jpeg?format=100w",
      "local": "/assets/squarespace/image-asset-9097a98543.jpg",
      "bytes": 1520,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482341335648-NXTV439YF3NHJH7R5U8Y/image-asset.jpeg?format=300w",
      "local": "/assets/squarespace/image-asset-8a31dd194b.jpg",
      "bytes": 4900,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482341335648-NXTV439YF3NHJH7R5U8Y/image-asset.jpeg?format=500w",
      "local": "/assets/squarespace/image-asset-f62353df21.jpg",
      "bytes": 10168,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482341335648-NXTV439YF3NHJH7R5U8Y/image-asset.jpeg?format=750w",
      "local": "/assets/squarespace/image-asset-cefd18e88c.jpg",
      "bytes": 18286,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589024447341-YNDAGWUOMQG1K56U8NPM/Videoconsulta+1.png",
      "local": "/assets/squarespace/videoconsulta-1-c49edcb786.png",
      "bytes": 220470,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589024447341-YNDAGWUOMQG1K56U8NPM/Videoconsulta+1.png?format=100w",
      "local": "/assets/squarespace/videoconsulta-1-85315e749e.png",
      "bytes": 8588,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589024447341-YNDAGWUOMQG1K56U8NPM/Videoconsulta+1.png?format=300w",
      "local": "/assets/squarespace/videoconsulta-1-7b86298be1.png",
      "bytes": 24096,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589024447341-YNDAGWUOMQG1K56U8NPM/Videoconsulta+1.png?format=500w",
      "local": "/assets/squarespace/videoconsulta-1-be58c6b0f6.png",
      "bytes": 46616,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589024447341-YNDAGWUOMQG1K56U8NPM/Videoconsulta+1.png?format=750w",
      "local": "/assets/squarespace/videoconsulta-1-9b91e968f4.png",
      "bytes": 79852,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589024447341-YNDAGWUOMQG1K56U8NPM/Videoconsulta+1.png?format=1000w",
      "local": "/assets/squarespace/videoconsulta-1-e78b92b59a.png",
      "bytes": 124092,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589024447341-YNDAGWUOMQG1K56U8NPM/Videoconsulta+1.png?format=1500w",
      "local": "/assets/squarespace/videoconsulta-1-6679593101.png",
      "bytes": 222708,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589024447341-YNDAGWUOMQG1K56U8NPM/Videoconsulta+1.png?format=2500w",
      "local": "/assets/squarespace/videoconsulta-1-3f2ea7e36b.png",
      "bytes": 220470,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/5405e8dfe4b017ae41b45b77/1410818569610-ZZS44VQP00DD37X6ASH4/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-3b32f2b70a.jpg",
      "bytes": 242438,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/5405e8dfe4b017ae41b45b77/1410817129633-NWBL75I1IZRCXKCQDNMP/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-8b1ca18f19.jpg",
      "bytes": 61474,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/5405e8dfe4b017ae41b45b77/1410818469871-9PHCE3V19U7TMCX0WKK6/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-a7f23287c2.jpg",
      "bytes": 203480,
      "contentType": "image/webp"
    },
    {
      "source": "http://static1.squarespace.com/static/56910baa2399a3180163ea4e/681e2cf6f2af05430b0ee2f1/681e2cf6f2af05430b0ee2f2/1554927987543/?format=1500w",
      "local": "/assets/squarespace/asset-634a4bdfc2.webp",
      "bytes": 203480,
      "contentType": "image/webp"
    },
    {
      "source": "http://static1.squarespace.com/static/56910baa2399a3180163ea4e/681e2cf6f2af05430b0ee2f1/681e2cf6f2af05430b0ee2f4/1554927963330/?format=1500w",
      "local": "/assets/squarespace/asset-8576491107.webp",
      "bytes": 242438,
      "contentType": "image/webp"
    },
    {
      "source": "http://static1.squarespace.com/static/56910baa2399a3180163ea4e/681e2cf6f2af05430b0ee2f1/681e2cf6f2af05430b0ee2f6/1554927974872/?format=1500w",
      "local": "/assets/squarespace/asset-dd6491840c.webp",
      "bytes": 61474,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1533658045112-9THUAF9JBFHNF3X4RA66/EEDB3784.JPG",
      "local": "/assets/squarespace/eedb3784-58e19e1918.jpg",
      "bytes": 23348,
      "contentType": "image/webp"
    },
    {
      "source": "https://static1.squarespace.com/static/56910baa2399a3180163ea4e/t/5b69c0ea6d2a73dcca44c157/1533657459489/LOGO+COMPLETO.Mint+oscuro.2+%282%29.jpg",
      "local": "/assets/squarespace/logo-completo.mint-oscuro.2-2--5c9b1029fd.jpg",
      "bytes": 12744,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/798a485e-bc9b-4526-87fb-45da6fe478a4/DSC04954.jpg",
      "local": "/assets/squarespace/dsc04954-b0e067497f.jpg",
      "bytes": 853154,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/798a485e-bc9b-4526-87fb-45da6fe478a4/DSC04954.jpg?format=100w",
      "local": "/assets/squarespace/dsc04954-f305cbfe55.jpg",
      "bytes": 30956,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/798a485e-bc9b-4526-87fb-45da6fe478a4/DSC04954.jpg?format=300w",
      "local": "/assets/squarespace/dsc04954-1417e6e31f.jpg",
      "bytes": 39330,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/798a485e-bc9b-4526-87fb-45da6fe478a4/DSC04954.jpg?format=500w",
      "local": "/assets/squarespace/dsc04954-99c2f728dc.jpg",
      "bytes": 51408,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/798a485e-bc9b-4526-87fb-45da6fe478a4/DSC04954.jpg?format=750w",
      "local": "/assets/squarespace/dsc04954-3f90872638.jpg",
      "bytes": 71510,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/798a485e-bc9b-4526-87fb-45da6fe478a4/DSC04954.jpg?format=1000w",
      "local": "/assets/squarespace/dsc04954-c47b5efa8f.jpg",
      "bytes": 104738,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/798a485e-bc9b-4526-87fb-45da6fe478a4/DSC04954.jpg?format=1500w",
      "local": "/assets/squarespace/dsc04954-ef9b5582a4.jpg",
      "bytes": 234648,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/798a485e-bc9b-4526-87fb-45da6fe478a4/DSC04954.jpg?format=2500w",
      "local": "/assets/squarespace/dsc04954-06129ece38.jpg",
      "bytes": 853154,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482339959790-L36MRXECTEKH8AMW0Y84/EEDB3825.JPG",
      "local": "/assets/squarespace/eedb3825-1991c5068d.jpg",
      "bytes": 30076,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482334397122-NWT4CEJ3EMYRXV4IIW31/EEDB3853.JPG",
      "local": "/assets/squarespace/eedb3853-7d96611053.jpg",
      "bytes": 41068,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1472553669609-JGARWBVK545986KANYAD/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-dd26de1725.jpg",
      "bytes": 40216,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482340807413-CYFYIYMTVB8RYS8FG3Z2/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-0a59dab612.jpg",
      "bytes": 18396,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482340571611-PVPMQT5NPJQ38L0KP56S/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-8430df6428.jpg",
      "bytes": 50056,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1470937821331-08UWOQYOI9HI4ZN4VU57/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-5d69e03a59.jpg",
      "bytes": 72324,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1470938228012-2TXQCL6LCGNXTA7EPAZD/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-3f2d3b2871.jpg",
      "bytes": 22712,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482340779879-IEPQGAER2PB544MQ74LM/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-a460a7dc97.jpg",
      "bytes": 219202,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1470937380612-KD536ZK1J43R548SYM4R/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-3ca9b3032e.jpg",
      "bytes": 40900,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1534021060516-E6KQ2KIPOIY1XSOUXW2J/IMG_0008.JPG",
      "local": "/assets/squarespace/img_0008-f150fc65df.jpg",
      "bytes": 21944,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589021660449-SJ36YXIR301KA1I68OVR/Foto+videollamada.jpg",
      "local": "/assets/squarespace/foto-videollamada-1f218fb6ec.jpg",
      "bytes": 100628,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589021660449-SJ36YXIR301KA1I68OVR/Foto+videollamada.jpg?format=100w",
      "local": "/assets/squarespace/foto-videollamada-dcaa261296.jpg",
      "bytes": 5090,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589021660449-SJ36YXIR301KA1I68OVR/Foto+videollamada.jpg?format=300w",
      "local": "/assets/squarespace/foto-videollamada-8b11947e6c.jpg",
      "bytes": 11144,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589021660449-SJ36YXIR301KA1I68OVR/Foto+videollamada.jpg?format=500w",
      "local": "/assets/squarespace/foto-videollamada-8ce0ea3f43.jpg",
      "bytes": 18964,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589021660449-SJ36YXIR301KA1I68OVR/Foto+videollamada.jpg?format=750w",
      "local": "/assets/squarespace/foto-videollamada-afe7d038ad.jpg",
      "bytes": 30170,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589021660449-SJ36YXIR301KA1I68OVR/Foto+videollamada.jpg?format=1000w",
      "local": "/assets/squarespace/foto-videollamada-b2f899b730.jpg",
      "bytes": 41630,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1589021660449-SJ36YXIR301KA1I68OVR/Foto+videollamada.jpg?format=1500w",
      "local": "/assets/squarespace/foto-videollamada-e23c362847.jpg",
      "bytes": 69196,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482343298243-FH3T4SC1K8OG6GWINYYF/Exploraci%C3%B3n+mama",
      "local": "/assets/squarespace/exploraci-n-mama-6f7694dc81.webp",
      "bytes": 32470,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482343332952-NBY852WOZ95MG0FPTKZF/EEDB3738.JPG",
      "local": "/assets/squarespace/eedb3738-381d9d1829.jpg",
      "bytes": 53374,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482343361251-DKRCD166ZJS27H8ZHKXM/EEDB3878.JPG",
      "local": "/assets/squarespace/eedb3878-729a0eab46.jpg",
      "bytes": 17200,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482343298243-FH3T4SC1K8OG6GWINYYF/Exploraci%C3%B3n+mama?format=100w",
      "local": "/assets/squarespace/exploraci-n-mama-07834d558e.webp",
      "bytes": 2524,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482343298243-FH3T4SC1K8OG6GWINYYF/Exploraci%C3%B3n+mama?format=300w",
      "local": "/assets/squarespace/exploraci-n-mama-814eb0eba9.webp",
      "bytes": 10658,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482343298243-FH3T4SC1K8OG6GWINYYF/Exploraci%C3%B3n+mama?format=500w",
      "local": "/assets/squarespace/exploraci-n-mama-f9521fcd2b.webp",
      "bytes": 21940,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482343298243-FH3T4SC1K8OG6GWINYYF/Exploraci%C3%B3n+mama?format=750w",
      "local": "/assets/squarespace/exploraci-n-mama-1ee071accc.webp",
      "bytes": 32470,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482343298243-FH3T4SC1K8OG6GWINYYF/Exploraci%C3%B3n+mama?format=1000w",
      "local": "/assets/squarespace/exploraci-n-mama-e1f55f188b.webp",
      "bytes": 32470,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1481476088375-ANWKRWJV3PDIXPJQ25SF/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-7257a97311.jpg",
      "bytes": 244360,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1481476241552-VGI2QN7OPEMSJJVPLICY/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-5d788c2e01.jpg",
      "bytes": 102952,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482340171340-S3YL577773DOWASGDKAQ/breast",
      "local": "/assets/squarespace/breast-633a0f6615.webp",
      "bytes": 151224,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482340132451-1W1GXG1MSN3W3BJSI8VK/Aumento+de+pecho",
      "local": "/assets/squarespace/aumento-de-pecho-aa391fff40.webp",
      "bytes": 208902,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1481476049914-MY86DEW407WPNYHEADYU/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-b29d91e1ee.jpg",
      "bytes": 72902,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1535135474032-UTIM5SEU1I9625OE8QTH/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-bbd5988cd5.jpg",
      "bytes": 58418,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482340132451-1W1GXG1MSN3W3BJSI8VK/Aumento+de+pecho?format=100w",
      "local": "/assets/squarespace/aumento-de-pecho-5eaaeaf1d2.webp",
      "bytes": 10768,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482340132451-1W1GXG1MSN3W3BJSI8VK/Aumento+de+pecho?format=300w",
      "local": "/assets/squarespace/aumento-de-pecho-a3e1b47449.webp",
      "bytes": 13772,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345495281-3RX2HN4BTCWJ6XUNWAOA/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-ffd2dfac7e.jpg",
      "bytes": 29054,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482344813098-OTYEVBQQQFOV5OOY48SP/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-4944a8cec2.jpg",
      "bytes": 57470,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345442377-AOIOOA6A9U0SHVFE9CNJ/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-65a7d30917.jpg",
      "bytes": 157944,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345442377-AOIOOA6A9U0SHVFE9CNJ/image-asset.jpeg?format=100w",
      "local": "/assets/squarespace/image-asset-c53a65f201.jpg",
      "bytes": 1842,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345442377-AOIOOA6A9U0SHVFE9CNJ/image-asset.jpeg?format=300w",
      "local": "/assets/squarespace/image-asset-a64ed5205b.jpg",
      "bytes": 6092,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345442377-AOIOOA6A9U0SHVFE9CNJ/image-asset.jpeg?format=500w",
      "local": "/assets/squarespace/image-asset-170746b0f8.jpg",
      "bytes": 11144,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345442377-AOIOOA6A9U0SHVFE9CNJ/image-asset.jpeg?format=750w",
      "local": "/assets/squarespace/image-asset-13862b7f83.jpg",
      "bytes": 18136,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345442377-AOIOOA6A9U0SHVFE9CNJ/image-asset.jpeg?format=1000w",
      "local": "/assets/squarespace/image-asset-305e54e327.jpg",
      "bytes": 27696,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482344483847-0YABU7NCTXW5KSDAJXVT/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-4a885ac844.jpg",
      "bytes": 18034,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482344681908-TIBSUI0TT5JDVJ9DXLCF/EEDB3801.JPG",
      "local": "/assets/squarespace/eedb3801-730b186fbd.jpg",
      "bytes": 46560,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482344637158-1CBKMGBY4CFABAFNU3RE/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-af7f2bf47b.jpg",
      "bytes": 42472,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482344681908-TIBSUI0TT5JDVJ9DXLCF/EEDB3801.JPG?format=100w",
      "local": "/assets/squarespace/eedb3801-cd08edaafd.jpg",
      "bytes": 5804,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482344681908-TIBSUI0TT5JDVJ9DXLCF/EEDB3801.JPG?format=300w",
      "local": "/assets/squarespace/eedb3801-bb8d90bced.jpg",
      "bytes": 11624,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482344681908-TIBSUI0TT5JDVJ9DXLCF/EEDB3801.JPG?format=500w",
      "local": "/assets/squarespace/eedb3801-cafd37128b.jpg",
      "bytes": 19852,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482344681908-TIBSUI0TT5JDVJ9DXLCF/EEDB3801.JPG?format=750w",
      "local": "/assets/squarespace/eedb3801-76279d29f6.jpg",
      "bytes": 32314,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482344681908-TIBSUI0TT5JDVJ9DXLCF/EEDB3801.JPG?format=1000w",
      "local": "/assets/squarespace/eedb3801-0d6b88ae9e.jpg",
      "bytes": 46560,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484003232864-U7FSAGH8W3SQXN1HYFB2/lipotransferencia",
      "local": "/assets/squarespace/lipotransferencia-b99c1eb193.webp",
      "bytes": 58424,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484003154171-M5JCHR814LI70JBZO184/liposuccion+madrid",
      "local": "/assets/squarespace/liposuccion-madrid-c933dacc68.webp",
      "bytes": 84580,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484003267460-VEF8A879UJALO2LRSNWF/hypertrophic+breast",
      "local": "/assets/squarespace/hypertrophic-breast-b020cf10d0.webp",
      "bytes": 172858,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484003175614-2NXQ0HH2UOF6MIIGPLM7/abdominoplastia",
      "local": "/assets/squarespace/abdominoplastia-1561fe5da7.webp",
      "bytes": 312240,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484003199680-JZU5F586TG9X6BKTSTT8/lifting+de+muslos+madrid",
      "local": "/assets/squarespace/lifting-de-muslos-madrid-e5dc8c1139.webp",
      "bytes": 89210,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484003154171-M5JCHR814LI70JBZO184/liposuccion+madrid?format=100w",
      "local": "/assets/squarespace/liposuccion-madrid-e7f99c311d.webp",
      "bytes": 15820,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484003154171-M5JCHR814LI70JBZO184/liposuccion+madrid?format=300w",
      "local": "/assets/squarespace/liposuccion-madrid-f515dd5013.webp",
      "bytes": 18102,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484003154171-M5JCHR814LI70JBZO184/liposuccion+madrid?format=500w",
      "local": "/assets/squarespace/liposuccion-madrid-acc4527308.webp",
      "bytes": 20878,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484003041244-PB6SFJLCQDKN0PRY055W/rinoplastia",
      "local": "/assets/squarespace/rinoplastia-202ed30422.webp",
      "bytes": 138614,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484003011972-Z6JE1R0Y5Z70L510E1Q7/blefaroplastia",
      "local": "/assets/squarespace/blefaroplastia-8594353f07.webp",
      "bytes": 180976,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484003073218-CKYGWKOKJUAJBXSM1AGT/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-97fbd71a7b.jpg",
      "bytes": 126096,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484002989583-WQG41N1J38IVGTQHYGUS/otoplasty",
      "local": "/assets/squarespace/otoplasty-66aaf36194.webp",
      "bytes": 130406,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484002989583-WQG41N1J38IVGTQHYGUS/otoplasty?format=100w",
      "local": "/assets/squarespace/otoplasty-38bf191457.webp",
      "bytes": 2344,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484002989583-WQG41N1J38IVGTQHYGUS/otoplasty?format=300w",
      "local": "/assets/squarespace/otoplasty-05b86ae882.webp",
      "bytes": 10526,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484002989583-WQG41N1J38IVGTQHYGUS/otoplasty?format=500w",
      "local": "/assets/squarespace/otoplasty-6b6d8f9760.webp",
      "bytes": 26694,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1484002989583-WQG41N1J38IVGTQHYGUS/otoplasty?format=750w",
      "local": "/assets/squarespace/otoplasty-d714582bc0.webp",
      "bytes": 56704,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488732006046-NH897P9IKPA9T8VIGQJ8/Tu+consulta+de+est%C3%A9tica+en+Madrid",
      "local": "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-1272a0b094.webp",
      "bytes": 38304,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488732095487-XZ0JMQR9JBAAKLKEHYLY/EEDB3858.JPG",
      "local": "/assets/squarespace/eedb3858-ede3beae9e.jpg",
      "bytes": 48420,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488732006046-NH897P9IKPA9T8VIGQJ8/Tu+consulta+de+est%C3%A9tica+en+Madrid?format=100w",
      "local": "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-0f2f90ee53.webp",
      "bytes": 5666,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488732006046-NH897P9IKPA9T8VIGQJ8/Tu+consulta+de+est%C3%A9tica+en+Madrid?format=300w",
      "local": "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-e3c4e7ddd5.webp",
      "bytes": 10904,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488732006046-NH897P9IKPA9T8VIGQJ8/Tu+consulta+de+est%C3%A9tica+en+Madrid?format=500w",
      "local": "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-e2d12d49f3.webp",
      "bytes": 17692,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488732006046-NH897P9IKPA9T8VIGQJ8/Tu+consulta+de+est%C3%A9tica+en+Madrid?format=750w",
      "local": "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-6a68abed10.webp",
      "bytes": 27836,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488732006046-NH897P9IKPA9T8VIGQJ8/Tu+consulta+de+est%C3%A9tica+en+Madrid?format=1000w",
      "local": "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-3c8248703e.webp",
      "bytes": 38304,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488732006046-NH897P9IKPA9T8VIGQJ8/Tu+consulta+de+est%C3%A9tica+en+Madrid?format=1500w",
      "local": "/assets/squarespace/tu-consulta-de-est-tica-en-madrid-fbfb6d559c.webp",
      "bytes": 38304,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1471624240192-CCN7OHVX0ESYN3FB32BB/EEDB3878.JPG",
      "local": "/assets/squarespace/eedb3878-6a637abba0.jpg",
      "bytes": 29054,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345653842-Q0LNUDVPQJ248GCUOQ1M/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-626297d419.jpg",
      "bytes": 94250,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1471624109093-UC4JJ3TVN6L7FHVD0TYJ/EEDB3738.JPG",
      "local": "/assets/squarespace/eedb3738-d85f50e9e3.jpg",
      "bytes": 86088,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345653842-Q0LNUDVPQJ248GCUOQ1M/image-asset.jpeg?format=100w",
      "local": "/assets/squarespace/image-asset-09c2e5cb3f.jpg",
      "bytes": 14776,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345653842-Q0LNUDVPQJ248GCUOQ1M/image-asset.jpeg?format=300w",
      "local": "/assets/squarespace/image-asset-1ff8244bed.jpg",
      "bytes": 18188,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345653842-Q0LNUDVPQJ248GCUOQ1M/image-asset.jpeg?format=500w",
      "local": "/assets/squarespace/image-asset-46a77e2bb7.jpg",
      "bytes": 22020,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345653842-Q0LNUDVPQJ248GCUOQ1M/image-asset.jpeg?format=750w",
      "local": "/assets/squarespace/image-asset-863f21a8d7.jpg",
      "bytes": 28800,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1482345653842-Q0LNUDVPQJ248GCUOQ1M/image-asset.jpeg?format=1000w",
      "local": "/assets/squarespace/image-asset-26820700f1.jpg",
      "bytes": 36892,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488647301253-AKH5CL297BAJSXPUV98S/image-asset.jpeg",
      "local": "/assets/squarespace/image-asset-85356642a0.jpg",
      "bytes": 54872,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488647242364-H7M0TVUOXPR5WI4HMWNJ/IMG_0008.JPG",
      "local": "/assets/squarespace/img_0008-8c4a6d58ff.jpg",
      "bytes": 28982,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488647242364-H7M0TVUOXPR5WI4HMWNJ/IMG_0008.JPG?format=100w",
      "local": "/assets/squarespace/img_0008-b2929da7df.jpg",
      "bytes": 1832,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488647242364-H7M0TVUOXPR5WI4HMWNJ/IMG_0008.JPG?format=300w",
      "local": "/assets/squarespace/img_0008-7af5cdd7d7.jpg",
      "bytes": 6658,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488647242364-H7M0TVUOXPR5WI4HMWNJ/IMG_0008.JPG?format=500w",
      "local": "/assets/squarespace/img_0008-d314c18c90.jpg",
      "bytes": 13160,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488647242364-H7M0TVUOXPR5WI4HMWNJ/IMG_0008.JPG?format=750w",
      "local": "/assets/squarespace/img_0008-d5ece0f939.jpg",
      "bytes": 21416,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488647242364-H7M0TVUOXPR5WI4HMWNJ/IMG_0008.JPG?format=1000w",
      "local": "/assets/squarespace/img_0008-cefb451f23.jpg",
      "bytes": 28982,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488647242364-H7M0TVUOXPR5WI4HMWNJ/IMG_0008.JPG?format=1500w",
      "local": "/assets/squarespace/img_0008-0f8384fd2d.jpg",
      "bytes": 28982,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488733221393-BW6XD5CGD9IPSOFPKH94/EEDB3738.JPG",
      "local": "/assets/squarespace/eedb3738-4092e2ef60.jpg",
      "bytes": 38304,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488733221393-BW6XD5CGD9IPSOFPKH94/EEDB3738.JPG?format=100w",
      "local": "/assets/squarespace/eedb3738-c8381ceaf1.jpg",
      "bytes": 5666,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488733221393-BW6XD5CGD9IPSOFPKH94/EEDB3738.JPG?format=300w",
      "local": "/assets/squarespace/eedb3738-1b051fd165.jpg",
      "bytes": 10904,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488733221393-BW6XD5CGD9IPSOFPKH94/EEDB3738.JPG?format=500w",
      "local": "/assets/squarespace/eedb3738-6bdfdd7880.jpg",
      "bytes": 17692,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488733221393-BW6XD5CGD9IPSOFPKH94/EEDB3738.JPG?format=750w",
      "local": "/assets/squarespace/eedb3738-19583213bf.jpg",
      "bytes": 27836,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488733221393-BW6XD5CGD9IPSOFPKH94/EEDB3738.JPG?format=1000w",
      "local": "/assets/squarespace/eedb3738-de4f416809.jpg",
      "bytes": 38304,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488733221393-BW6XD5CGD9IPSOFPKH94/EEDB3738.JPG?format=1500w",
      "local": "/assets/squarespace/eedb3738-3d33c8abf0.jpg",
      "bytes": 38304,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730434771-UAXG2BJ1VFLYHT2HTP9E/IMG_0008.JPG",
      "local": "/assets/squarespace/img_0008-d3cdbe59f6.jpg",
      "bytes": 38304,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730434771-UAXG2BJ1VFLYHT2HTP9E/IMG_0008.JPG?format=100w",
      "local": "/assets/squarespace/img_0008-abf34d43f7.jpg",
      "bytes": 5666,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730434771-UAXG2BJ1VFLYHT2HTP9E/IMG_0008.JPG?format=300w",
      "local": "/assets/squarespace/img_0008-9d35ef70eb.jpg",
      "bytes": 10904,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730434771-UAXG2BJ1VFLYHT2HTP9E/IMG_0008.JPG?format=500w",
      "local": "/assets/squarespace/img_0008-afad8a0fff.jpg",
      "bytes": 17692,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730434771-UAXG2BJ1VFLYHT2HTP9E/IMG_0008.JPG?format=750w",
      "local": "/assets/squarespace/img_0008-fda9922599.jpg",
      "bytes": 27836,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730434771-UAXG2BJ1VFLYHT2HTP9E/IMG_0008.JPG?format=1000w",
      "local": "/assets/squarespace/img_0008-b19335ee26.jpg",
      "bytes": 38304,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730434771-UAXG2BJ1VFLYHT2HTP9E/IMG_0008.JPG?format=1500w",
      "local": "/assets/squarespace/img_0008-6273fe081c.jpg",
      "bytes": 38304,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730959331-O3L3U7YJEJ2I9H4LYKOQ/EEDB3738.JPG",
      "local": "/assets/squarespace/eedb3738-442f846f52.jpg",
      "bytes": 38304,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730959331-O3L3U7YJEJ2I9H4LYKOQ/EEDB3738.JPG?format=100w",
      "local": "/assets/squarespace/eedb3738-0a4138e82b.jpg",
      "bytes": 5666,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730959331-O3L3U7YJEJ2I9H4LYKOQ/EEDB3738.JPG?format=300w",
      "local": "/assets/squarespace/eedb3738-e984343dfe.jpg",
      "bytes": 10904,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730959331-O3L3U7YJEJ2I9H4LYKOQ/EEDB3738.JPG?format=500w",
      "local": "/assets/squarespace/eedb3738-b106f43811.jpg",
      "bytes": 17692,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730959331-O3L3U7YJEJ2I9H4LYKOQ/EEDB3738.JPG?format=750w",
      "local": "/assets/squarespace/eedb3738-ed87b19f2f.jpg",
      "bytes": 27836,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730959331-O3L3U7YJEJ2I9H4LYKOQ/EEDB3738.JPG?format=1000w",
      "local": "/assets/squarespace/eedb3738-c3f3169de8.jpg",
      "bytes": 38304,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1488730959331-O3L3U7YJEJ2I9H4LYKOQ/EEDB3738.JPG?format=1500w",
      "local": "/assets/squarespace/eedb3738-eca7124026.jpg",
      "bytes": 38304,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1587484409793-PWOJC7879GJWQ6RUUYN4/Foto+videollamada.jpg",
      "local": "/assets/squarespace/foto-videollamada-07ffa904e9.jpg",
      "bytes": 100628,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/8cf92c48-12e1-4d6c-ac17-3a12dda0fb02/Sensabel+logo.png",
      "local": "/assets/squarespace/sensabel-logo-f08b28186b.png",
      "bytes": 2172,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/cb9c9a58-ec58-49c4-986a-9d302daa5c00/Consulta_Sensabell_Madrid-1030x690.png",
      "local": "/assets/squarespace/consulta_sensabell_madrid-1030x690-7f6d82626f.png",
      "bytes": 637496,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/8cf92c48-12e1-4d6c-ac17-3a12dda0fb02/Sensabel+logo.png?format=100w",
      "local": "/assets/squarespace/sensabel-logo-06e65271d5.png",
      "bytes": 1596,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/8cf92c48-12e1-4d6c-ac17-3a12dda0fb02/Sensabel+logo.png?format=300w",
      "local": "/assets/squarespace/sensabel-logo-ab9cf3b119.png",
      "bytes": 5720,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/8cf92c48-12e1-4d6c-ac17-3a12dda0fb02/Sensabel+logo.png?format=500w",
      "local": "/assets/squarespace/sensabel-logo-735c166cc6.png",
      "bytes": 2172,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/8cf92c48-12e1-4d6c-ac17-3a12dda0fb02/Sensabel+logo.png?format=750w",
      "local": "/assets/squarespace/sensabel-logo-f8e8ec0a19.png",
      "bytes": 2172,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/8cf92c48-12e1-4d6c-ac17-3a12dda0fb02/Sensabel+logo.png?format=1000w",
      "local": "/assets/squarespace/sensabel-logo-ee8454ed34.png",
      "bytes": 2172,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1532874162989-NNRYEH94FYH892GBKJE3/EEDB3741.JPG",
      "local": "/assets/squarespace/eedb3741-8dad1c5631.jpg",
      "bytes": 23792,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582032886-A8WUEEEYZG3OZ4IYDEN3/female-832266_640.jpg",
      "local": "/assets/squarespace/female-832266_640-eba2d3fac1.jpg",
      "bytes": 31992,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582032886-A8WUEEEYZG3OZ4IYDEN3/female-832266_640.jpg?format=100w",
      "local": "/assets/squarespace/female-832266_640-619e6b43b7.jpg",
      "bytes": 1800,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582032886-A8WUEEEYZG3OZ4IYDEN3/female-832266_640.jpg?format=300w",
      "local": "/assets/squarespace/female-832266_640-d593f6579e.jpg",
      "bytes": 8176,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582032886-A8WUEEEYZG3OZ4IYDEN3/female-832266_640.jpg?format=500w",
      "local": "/assets/squarespace/female-832266_640-a77148310a.jpg",
      "bytes": 19846,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582032886-A8WUEEEYZG3OZ4IYDEN3/female-832266_640.jpg?format=750w",
      "local": "/assets/squarespace/female-832266_640-31f0f3226b.jpg",
      "bytes": 31992,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582032886-A8WUEEEYZG3OZ4IYDEN3/female-832266_640.jpg?format=1000w",
      "local": "/assets/squarespace/female-832266_640-7e4ca876ee.jpg",
      "bytes": 31992,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582032886-A8WUEEEYZG3OZ4IYDEN3/female-832266_640.jpg?format=1500w",
      "local": "/assets/squarespace/female-832266_640-38636e9a12.jpg",
      "bytes": 31992,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582080754-FG87Y2YX8O075G3EA7F3/female-832266_640.jpg",
      "local": "/assets/squarespace/female-832266_640-9dd5a32439.jpg",
      "bytes": 31992,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582080754-FG87Y2YX8O075G3EA7F3/female-832266_640.jpg?format=100w",
      "local": "/assets/squarespace/female-832266_640-a5052afcfb.jpg",
      "bytes": 1800,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582080754-FG87Y2YX8O075G3EA7F3/female-832266_640.jpg?format=300w",
      "local": "/assets/squarespace/female-832266_640-ae67044927.jpg",
      "bytes": 8176,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582080754-FG87Y2YX8O075G3EA7F3/female-832266_640.jpg?format=500w",
      "local": "/assets/squarespace/female-832266_640-51fdd8f41f.jpg",
      "bytes": 19846,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582080754-FG87Y2YX8O075G3EA7F3/female-832266_640.jpg?format=750w",
      "local": "/assets/squarespace/female-832266_640-13663c4b12.jpg",
      "bytes": 31992,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582080754-FG87Y2YX8O075G3EA7F3/female-832266_640.jpg?format=1000w",
      "local": "/assets/squarespace/female-832266_640-37b027fceb.jpg",
      "bytes": 31992,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582080754-FG87Y2YX8O075G3EA7F3/female-832266_640.jpg?format=1500w",
      "local": "/assets/squarespace/female-832266_640-0a5faa001e.jpg",
      "bytes": 31992,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1583582080754-FG87Y2YX8O075G3EA7F3/female-832266_640.jpg?format=2500w",
      "local": "/assets/squarespace/female-832266_640-26b2829e0f.jpg",
      "bytes": 31992,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1534021060516-E6KQ2KIPOIY1XSOUXW2J/IMG_0008.JPG?format=100w",
      "local": "/assets/squarespace/img_0008-e5585faf4a.jpg",
      "bytes": 1750,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1534021060516-E6KQ2KIPOIY1XSOUXW2J/IMG_0008.JPG?format=300w",
      "local": "/assets/squarespace/img_0008-9739e5bcbe.jpg",
      "bytes": 6982,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1534021060516-E6KQ2KIPOIY1XSOUXW2J/IMG_0008.JPG?format=500w",
      "local": "/assets/squarespace/img_0008-c2509307f1.jpg",
      "bytes": 13556,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1534021060516-E6KQ2KIPOIY1XSOUXW2J/IMG_0008.JPG?format=750w",
      "local": "/assets/squarespace/img_0008-7286a6fa21.jpg",
      "bytes": 21944,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1534021060516-E6KQ2KIPOIY1XSOUXW2J/IMG_0008.JPG?format=1000w",
      "local": "/assets/squarespace/img_0008-0e02788dce.jpg",
      "bytes": 21944,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1534021060516-E6KQ2KIPOIY1XSOUXW2J/IMG_0008.JPG?format=1500w",
      "local": "/assets/squarespace/img_0008-48468655c1.jpg",
      "bytes": 21944,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/56910baa2399a3180163ea4e/1534021060516-E6KQ2KIPOIY1XSOUXW2J/IMG_0008.JPG?format=2500w",
      "local": "/assets/squarespace/img_0008-19705b44f0.jpg",
      "bytes": 21944,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/5052176b84aeb45fa5cfcc83/1377097104716-HDI53XJVV0DKZ24A3T68/51e453dee4b06abd3403c22e.png",
      "local": "/assets/squarespace/51e453dee4b06abd3403c22e-02cff8ed4e.png",
      "bytes": 471060,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/5052176b84aeb45fa5cfcc83/1377096775448-0L7B4Q54H1VLOGFF1DPR/synthetica+%2820130821%29.jpg",
      "local": "/assets/squarespace/synthetica-20130821--cbe31b3636.jpg",
      "bytes": 108384,
      "contentType": "image/webp"
    },
    {
      "source": "https://images.squarespace-cdn.com/content/v1/5052176b84aeb45fa5cfcc83/1377096507573-1MU42OOOOGIM9URAJ9D9/515c4225e4b0afec1218b21e.png",
      "local": "/assets/squarespace/515c4225e4b0afec1218b21e-50353b4567.png",
      "bytes": 345872,
      "contentType": "image/webp"
    }
  ]
} as const;
